import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_data_proto from './dcei_engine_data_proto';
export class SettingsData {
  get descriptor() {
    return SettingsData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlay = false;
    this._play = null;
    this._hasHistory = false;
    this._history = null;
    this._hasLog = false;
    this._log = null;
    this._hasTool = false;
    this._tool = null;
    this._hasView = false;
    this._view = null;
    this._hasEditorSettings = false;
    this._editorSettings = null;
  }
  isEmpty() {
    if (this._hasPlay && !this._play.isEmpty()) return false;
    if (this._hasHistory && !this._history.isEmpty()) return false;
    if (this._hasLog && !this._log.isEmpty()) return false;
    if (this._hasTool && !this._tool.isEmpty()) return false;
    if (this._hasView && !this._view.isEmpty()) return false;
    if (this._hasEditorSettings && !this._editorSettings.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SettingsData) {
      return value;
    }
    return SettingsData.fromJson(value);
  }
  static fromJson(json) {
    const result = new SettingsData();
    if (json.play != null) {
      result._hasPlay = true;
      result._play = PlaySettings.fromJson(json.play);
    }
    if (json.history != null) {
      result._hasHistory = true;
      result._history = History.fromJson(json.history);
    }
    if (json.log != null) {
      result._hasLog = true;
      result._log = LogSettings.fromJson(json.log);
    }
    if (json.tool != null) {
      result._hasTool = true;
      result._tool = ToolSettings.fromJson(json.tool);
    }
    if (json.view != null) {
      result._hasView = true;
      result._view = ViewSettings.fromJson(json.view);
    }
    if (json.editorSettings != null) {
      result._hasEditorSettings = true;
      result._editorSettings = EditorSettings.fromJson(json.editorSettings);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlay && !this._play.isEmpty()) {
      result.play = PlaySettings.toJson(this._play);
    }
    if (this._hasHistory && !this._history.isEmpty()) {
      result.history = History.toJson(this._history);
    }
    if (this._hasLog && !this._log.isEmpty()) {
      result.log = LogSettings.toJson(this._log);
    }
    if (this._hasTool && !this._tool.isEmpty()) {
      result.tool = ToolSettings.toJson(this._tool);
    }
    if (this._hasView && !this._view.isEmpty()) {
      result.view = ViewSettings.toJson(this._view);
    }
    if (this._hasEditorSettings && !this._editorSettings.isEmpty()) {
      result.editorSettings = EditorSettings.toJson(this._editorSettings);
    }
    return result;
  }
  /**
   * @returns {PlaySettings}
   */
  get play() {
    return this._hasPlay ? this._play : PlaySettings.default;
  }
  get hasPlay() {
    return this._hasPlay;
  }
  setPlay(path, value) {
    return {type: 'SET', path: path.concat(['play']), value: value.toJson()};
  }
  deletePlay(path) {
    return {type: 'DELETE', path: path.concat(['play'])};
  }
  /**
   * @returns {History}
   */
  get history() {
    return this._hasHistory ? this._history : History.default;
  }
  get hasHistory() {
    return this._hasHistory;
  }
  setHistory(path, value) {
    return {type: 'SET', path: path.concat(['history']), value: value.toJson()};
  }
  deleteHistory(path) {
    return {type: 'DELETE', path: path.concat(['history'])};
  }
  /**
   * @returns {LogSettings}
   */
  get log() {
    return this._hasLog ? this._log : LogSettings.default;
  }
  get hasLog() {
    return this._hasLog;
  }
  setLog(path, value) {
    return {type: 'SET', path: path.concat(['log']), value: value.toJson()};
  }
  deleteLog(path) {
    return {type: 'DELETE', path: path.concat(['log'])};
  }
  /**
   * @returns {ToolSettings}
   */
  get tool() {
    return this._hasTool ? this._tool : ToolSettings.default;
  }
  get hasTool() {
    return this._hasTool;
  }
  setTool(path, value) {
    return {type: 'SET', path: path.concat(['tool']), value: value.toJson()};
  }
  deleteTool(path) {
    return {type: 'DELETE', path: path.concat(['tool'])};
  }
  /**
   * @returns {ViewSettings}
   */
  get view() {
    return this._hasView ? this._view : ViewSettings.default;
  }
  get hasView() {
    return this._hasView;
  }
  setView(path, value) {
    return {type: 'SET', path: path.concat(['view']), value: value.toJson()};
  }
  deleteView(path) {
    return {type: 'DELETE', path: path.concat(['view'])};
  }
  /**
   * @returns {EditorSettings}
   */
  get editorSettings() {
    return this._hasEditorSettings ? this._editorSettings : EditorSettings.default;
  }
  get hasEditorSettings() {
    return this._hasEditorSettings;
  }
  setEditorSettings(path, value) {
    return {type: 'SET', path: path.concat(['editorSettings']), value: value.toJson()};
  }
  deleteEditorSettings(path) {
    return {type: 'DELETE', path: path.concat(['editorSettings'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "play": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SettingsData(this);
              copy._hasPlay = true;
              copy._play = PlaySettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlay) {
                return this;
              }
              const copy = new SettingsData(this);
              copy._hasPlay = false;
              copy._play = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlay) {
            const copy = new SettingsData(this);
            copy._hasPlay = true;
            copy._play = PlaySettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._play.apply(type, path.slice(1), value);
          if (newValue === this._play) {
            return this;
          }
          const copy = new SettingsData(this);
          copy._play = copy._play.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "history": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SettingsData(this);
              copy._hasHistory = true;
              copy._history = History.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHistory) {
                return this;
              }
              const copy = new SettingsData(this);
              copy._hasHistory = false;
              copy._history = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHistory) {
            const copy = new SettingsData(this);
            copy._hasHistory = true;
            copy._history = History.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._history.apply(type, path.slice(1), value);
          if (newValue === this._history) {
            return this;
          }
          const copy = new SettingsData(this);
          copy._history = copy._history.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "log": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SettingsData(this);
              copy._hasLog = true;
              copy._log = LogSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLog) {
                return this;
              }
              const copy = new SettingsData(this);
              copy._hasLog = false;
              copy._log = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLog) {
            const copy = new SettingsData(this);
            copy._hasLog = true;
            copy._log = LogSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._log.apply(type, path.slice(1), value);
          if (newValue === this._log) {
            return this;
          }
          const copy = new SettingsData(this);
          copy._log = copy._log.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "tool": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SettingsData(this);
              copy._hasTool = true;
              copy._tool = ToolSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTool) {
                return this;
              }
              const copy = new SettingsData(this);
              copy._hasTool = false;
              copy._tool = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTool) {
            const copy = new SettingsData(this);
            copy._hasTool = true;
            copy._tool = ToolSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._tool.apply(type, path.slice(1), value);
          if (newValue === this._tool) {
            return this;
          }
          const copy = new SettingsData(this);
          copy._tool = copy._tool.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "view": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SettingsData(this);
              copy._hasView = true;
              copy._view = ViewSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasView) {
                return this;
              }
              const copy = new SettingsData(this);
              copy._hasView = false;
              copy._view = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasView) {
            const copy = new SettingsData(this);
            copy._hasView = true;
            copy._view = ViewSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._view.apply(type, path.slice(1), value);
          if (newValue === this._view) {
            return this;
          }
          const copy = new SettingsData(this);
          copy._view = copy._view.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "editorSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SettingsData(this);
              copy._hasEditorSettings = true;
              copy._editorSettings = EditorSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEditorSettings) {
                return this;
              }
              const copy = new SettingsData(this);
              copy._hasEditorSettings = false;
              copy._editorSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEditorSettings) {
            const copy = new SettingsData(this);
            copy._hasEditorSettings = true;
            copy._editorSettings = EditorSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._editorSettings.apply(type, path.slice(1), value);
          if (newValue === this._editorSettings) {
            return this;
          }
          const copy = new SettingsData(this);
          copy._editorSettings = copy._editorSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SettingsData} other
   * @returns {SettingsData}
   */
  merge(other) {
    const copy = new SettingsData(this);
    if (other._hasPlay) {
      if (copy._hasPlay) {
        copy._play = copy.play.merge(other.play);
      } else {
        copy._play = other._play;
      }
      copy._hasPlay = true;
    }
    if (other._hasHistory) {
      if (copy._hasHistory) {
        copy._history = copy.history.merge(other.history);
      } else {
        copy._history = other._history;
      }
      copy._hasHistory = true;
    }
    if (other._hasLog) {
      if (copy._hasLog) {
        copy._log = copy.log.merge(other.log);
      } else {
        copy._log = other._log;
      }
      copy._hasLog = true;
    }
    if (other._hasTool) {
      if (copy._hasTool) {
        copy._tool = copy.tool.merge(other.tool);
      } else {
        copy._tool = other._tool;
      }
      copy._hasTool = true;
    }
    if (other._hasView) {
      if (copy._hasView) {
        copy._view = copy.view.merge(other.view);
      } else {
        copy._view = other._view;
      }
      copy._hasView = true;
    }
    if (other._hasEditorSettings) {
      if (copy._hasEditorSettings) {
        copy._editorSettings = copy.editorSettings.merge(other.editorSettings);
      } else {
        copy._editorSettings = other._editorSettings;
      }
      copy._hasEditorSettings = true;
    }
    return copy;
  }
}
SettingsData.default = new SettingsData();
class SettingsData_Builder {
  constructor(value) {
    this._value = new SettingsData(value);
  }
  build() {
    return new SettingsData(this._value);
  }
  setPlay(value) {
    this._value._hasPlay = true;
    this._value._play = value;
    return this;
  }
  deletePlay() {
    this._value._hasPlay = false;
    this._value._play = null;
    return this;
  }
  setHistory(value) {
    this._value._hasHistory = true;
    this._value._history = value;
    return this;
  }
  deleteHistory() {
    this._value._hasHistory = false;
    this._value._history = null;
    return this;
  }
  setLog(value) {
    this._value._hasLog = true;
    this._value._log = value;
    return this;
  }
  deleteLog() {
    this._value._hasLog = false;
    this._value._log = null;
    return this;
  }
  setTool(value) {
    this._value._hasTool = true;
    this._value._tool = value;
    return this;
  }
  deleteTool() {
    this._value._hasTool = false;
    this._value._tool = null;
    return this;
  }
  setView(value) {
    this._value._hasView = true;
    this._value._view = value;
    return this;
  }
  deleteView() {
    this._value._hasView = false;
    this._value._view = null;
    return this;
  }
  setEditorSettings(value) {
    this._value._hasEditorSettings = true;
    this._value._editorSettings = value;
    return this;
  }
  deleteEditorSettings() {
    this._value._hasEditorSettings = false;
    this._value._editorSettings = null;
    return this;
  }
}
SettingsData.Builder = SettingsData_Builder;
class SettingsData_WithParent {
  /**
   * @param {SettingsData} value
   * @param {SettingsData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SettingsData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlay() {
    if (this._cachedHasPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedHasPlay = true;
      } else {
        this._cachedHasPlay = this._parent ? this._parent.hasPlay : false;
      }
    }
    return this._cachedHasPlay;
  }
  get play() {
    if (!this._cachedPlay) {
      if (this._value.hasPlay) {
        this._cachedPlay = new PlaySettings.WithParent(this._value.play, this._parent && this._parent.hasPlay ? this._parent.play : null);
      } else {
        this._cachedPlay = this._parent ? new PlaySettings.WithParent(PlaySettings.default, this._parent.play) : PlaySettings.WithParent.default;
      }
    }
    return this._cachedPlay;
  }
  get hasHistory() {
    if (this._cachedHasHistory === undefined) {
      if (this._value.hasHistory) {
        this._cachedHasHistory = true;
      } else {
        this._cachedHasHistory = this._parent ? this._parent.hasHistory : false;
      }
    }
    return this._cachedHasHistory;
  }
  get history() {
    if (!this._cachedHistory) {
      if (this._value.hasHistory) {
        this._cachedHistory = new History.WithParent(this._value.history, this._parent && this._parent.hasHistory ? this._parent.history : null);
      } else {
        this._cachedHistory = this._parent ? new History.WithParent(History.default, this._parent.history) : History.WithParent.default;
      }
    }
    return this._cachedHistory;
  }
  get hasLog() {
    if (this._cachedHasLog === undefined) {
      if (this._value.hasLog) {
        this._cachedHasLog = true;
      } else {
        this._cachedHasLog = this._parent ? this._parent.hasLog : false;
      }
    }
    return this._cachedHasLog;
  }
  get log() {
    if (!this._cachedLog) {
      if (this._value.hasLog) {
        this._cachedLog = new LogSettings.WithParent(this._value.log, this._parent && this._parent.hasLog ? this._parent.log : null);
      } else {
        this._cachedLog = this._parent ? new LogSettings.WithParent(LogSettings.default, this._parent.log) : LogSettings.WithParent.default;
      }
    }
    return this._cachedLog;
  }
  get hasTool() {
    if (this._cachedHasTool === undefined) {
      if (this._value.hasTool) {
        this._cachedHasTool = true;
      } else {
        this._cachedHasTool = this._parent ? this._parent.hasTool : false;
      }
    }
    return this._cachedHasTool;
  }
  get tool() {
    if (!this._cachedTool) {
      if (this._value.hasTool) {
        this._cachedTool = new ToolSettings.WithParent(this._value.tool, this._parent && this._parent.hasTool ? this._parent.tool : null);
      } else {
        this._cachedTool = this._parent ? new ToolSettings.WithParent(ToolSettings.default, this._parent.tool) : ToolSettings.WithParent.default;
      }
    }
    return this._cachedTool;
  }
  get hasView() {
    if (this._cachedHasView === undefined) {
      if (this._value.hasView) {
        this._cachedHasView = true;
      } else {
        this._cachedHasView = this._parent ? this._parent.hasView : false;
      }
    }
    return this._cachedHasView;
  }
  get view() {
    if (!this._cachedView) {
      if (this._value.hasView) {
        this._cachedView = new ViewSettings.WithParent(this._value.view, this._parent && this._parent.hasView ? this._parent.view : null);
      } else {
        this._cachedView = this._parent ? new ViewSettings.WithParent(ViewSettings.default, this._parent.view) : ViewSettings.WithParent.default;
      }
    }
    return this._cachedView;
  }
  get hasEditorSettings() {
    if (this._cachedHasEditorSettings === undefined) {
      if (this._value.hasEditorSettings) {
        this._cachedHasEditorSettings = true;
      } else {
        this._cachedHasEditorSettings = this._parent ? this._parent.hasEditorSettings : false;
      }
    }
    return this._cachedHasEditorSettings;
  }
  get editorSettings() {
    if (!this._cachedEditorSettings) {
      if (this._value.hasEditorSettings) {
        this._cachedEditorSettings = new EditorSettings.WithParent(this._value.editorSettings, this._parent && this._parent.hasEditorSettings ? this._parent.editorSettings : null);
      } else {
        this._cachedEditorSettings = this._parent ? new EditorSettings.WithParent(EditorSettings.default, this._parent.editorSettings) : EditorSettings.WithParent.default;
      }
    }
    return this._cachedEditorSettings;
  }
  update(current, parent) {
    const result = new SettingsData_WithParent(current, parent);
    if (this._cachedPlay && this._value.hasPlay && current.hasPlay) {
      if (this._value.play === current.play && this._parent === parent) {
        result._cachedPlay = this._cachedPlay;
      } else {
        result._cachedPlay = this._cachedPlay.update(current.play, parent && parent.hasPlay ? parent.play : null);
      }
    }
    if (this._cachedHistory && this._value.hasHistory && current.hasHistory) {
      if (this._value.history === current.history && this._parent === parent) {
        result._cachedHistory = this._cachedHistory;
      } else {
        result._cachedHistory = this._cachedHistory.update(current.history, parent && parent.hasHistory ? parent.history : null);
      }
    }
    if (this._cachedLog && this._value.hasLog && current.hasLog) {
      if (this._value.log === current.log && this._parent === parent) {
        result._cachedLog = this._cachedLog;
      } else {
        result._cachedLog = this._cachedLog.update(current.log, parent && parent.hasLog ? parent.log : null);
      }
    }
    if (this._cachedTool && this._value.hasTool && current.hasTool) {
      if (this._value.tool === current.tool && this._parent === parent) {
        result._cachedTool = this._cachedTool;
      } else {
        result._cachedTool = this._cachedTool.update(current.tool, parent && parent.hasTool ? parent.tool : null);
      }
    }
    if (this._cachedView && this._value.hasView && current.hasView) {
      if (this._value.view === current.view && this._parent === parent) {
        result._cachedView = this._cachedView;
      } else {
        result._cachedView = this._cachedView.update(current.view, parent && parent.hasView ? parent.view : null);
      }
    }
    if (this._cachedEditorSettings && this._value.hasEditorSettings && current.hasEditorSettings) {
      if (this._value.editorSettings === current.editorSettings && this._parent === parent) {
        result._cachedEditorSettings = this._cachedEditorSettings;
      } else {
        result._cachedEditorSettings = this._cachedEditorSettings.update(current.editorSettings, parent && parent.hasEditorSettings ? parent.editorSettings : null);
      }
    }
    return result;
  }
}
SettingsData_WithParent.default = new SettingsData_WithParent(SettingsData.default, null);
SettingsData.WithParent = SettingsData_WithParent;
class SettingsData_Descriptor {
  get play() {
    if (!this._play) {
      this._play = {
        name: "play",
        Name: "Play",
        number: 1,
        protoType: 11,
        protoName: "play",
        type: PlaySettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._play;
  }
  get history() {
    if (!this._history) {
      this._history = {
        name: "history",
        Name: "History",
        number: 2,
        protoType: 11,
        protoName: "history",
        type: History,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._history;
  }
  get log() {
    if (!this._log) {
      this._log = {
        name: "log",
        Name: "Log",
        number: 3,
        protoType: 11,
        protoName: "log",
        type: LogSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._log;
  }
  get tool() {
    if (!this._tool) {
      this._tool = {
        name: "tool",
        Name: "Tool",
        number: 4,
        protoType: 11,
        protoName: "tool",
        type: ToolSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tool;
  }
  get view() {
    if (!this._view) {
      this._view = {
        name: "view",
        Name: "View",
        number: 5,
        protoType: 11,
        protoName: "view",
        type: ViewSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._view;
  }
  get editorSettings() {
    if (!this._editorSettings) {
      this._editorSettings = {
        name: "editorSettings",
        Name: "EditorSettings",
        number: 6,
        protoType: 11,
        protoName: "editorSettings",
        type: EditorSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._editorSettings;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.play,
        this.history,
        this.log,
        this.tool,
        this.view,
        this.editorSettings,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlay",
        Name: "DummyOneofForPlay",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHistory",
        Name: "DummyOneofForHistory",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLog",
        Name: "DummyOneofForLog",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTool",
        Name: "DummyOneofForTool",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForView",
        Name: "DummyOneofForView",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEditorSettings",
        Name: "DummyOneofForEditorSettings",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
SettingsData.descriptor = new SettingsData_Descriptor();
export class EditorSettings {
  get descriptor() {
    return EditorSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKeybindSettings = false;
    this._keybindSettings = null;
    this._hasFileSettings = false;
    this._fileSettings = null;
    this._hasStartupSettings = false;
    this._startupSettings = null;
  }
  isEmpty() {
    if (this._hasKeybindSettings && !this._keybindSettings.isEmpty()) return false;
    if (this._hasFileSettings && !this._fileSettings.isEmpty()) return false;
    if (this._hasStartupSettings && !this._startupSettings.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EditorSettings) {
      return value;
    }
    return EditorSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new EditorSettings();
    if (json.keybindSettings != null) {
      result._hasKeybindSettings = true;
      result._keybindSettings = KeybindSettingCollection.fromJson(json.keybindSettings);
    }
    if (json.fileSettings != null) {
      result._hasFileSettings = true;
      result._fileSettings = FileSettings.fromJson(json.fileSettings);
    }
    if (json.startupSettings != null) {
      result._hasStartupSettings = true;
      result._startupSettings = StartupSettings.fromJson(json.startupSettings);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKeybindSettings && !this._keybindSettings.isEmpty()) {
      result.keybindSettings = KeybindSettingCollection.toJson(this._keybindSettings);
    }
    if (this._hasFileSettings && !this._fileSettings.isEmpty()) {
      result.fileSettings = FileSettings.toJson(this._fileSettings);
    }
    if (this._hasStartupSettings && !this._startupSettings.isEmpty()) {
      result.startupSettings = StartupSettings.toJson(this._startupSettings);
    }
    return result;
  }
  /**
   * @returns {KeybindSettingCollection}
   */
  get keybindSettings() {
    return this._hasKeybindSettings ? this._keybindSettings : KeybindSettingCollection.default;
  }
  get hasKeybindSettings() {
    return this._hasKeybindSettings;
  }
  setKeybindSettings(path, value) {
    return {type: 'SET', path: path.concat(['keybindSettings']), value: value.toJson()};
  }
  deleteKeybindSettings(path) {
    return {type: 'DELETE', path: path.concat(['keybindSettings'])};
  }
  /**
   * @returns {FileSettings}
   */
  get fileSettings() {
    return this._hasFileSettings ? this._fileSettings : FileSettings.default;
  }
  get hasFileSettings() {
    return this._hasFileSettings;
  }
  setFileSettings(path, value) {
    return {type: 'SET', path: path.concat(['fileSettings']), value: value.toJson()};
  }
  deleteFileSettings(path) {
    return {type: 'DELETE', path: path.concat(['fileSettings'])};
  }
  /**
   * @returns {StartupSettings}
   */
  get startupSettings() {
    return this._hasStartupSettings ? this._startupSettings : StartupSettings.default;
  }
  get hasStartupSettings() {
    return this._hasStartupSettings;
  }
  setStartupSettings(path, value) {
    return {type: 'SET', path: path.concat(['startupSettings']), value: value.toJson()};
  }
  deleteStartupSettings(path) {
    return {type: 'DELETE', path: path.concat(['startupSettings'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "keybindSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EditorSettings(this);
              copy._hasKeybindSettings = true;
              copy._keybindSettings = KeybindSettingCollection.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeybindSettings) {
                return this;
              }
              const copy = new EditorSettings(this);
              copy._hasKeybindSettings = false;
              copy._keybindSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasKeybindSettings) {
            const copy = new EditorSettings(this);
            copy._hasKeybindSettings = true;
            copy._keybindSettings = KeybindSettingCollection.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._keybindSettings.apply(type, path.slice(1), value);
          if (newValue === this._keybindSettings) {
            return this;
          }
          const copy = new EditorSettings(this);
          copy._keybindSettings = copy._keybindSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "fileSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EditorSettings(this);
              copy._hasFileSettings = true;
              copy._fileSettings = FileSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFileSettings) {
                return this;
              }
              const copy = new EditorSettings(this);
              copy._hasFileSettings = false;
              copy._fileSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFileSettings) {
            const copy = new EditorSettings(this);
            copy._hasFileSettings = true;
            copy._fileSettings = FileSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._fileSettings.apply(type, path.slice(1), value);
          if (newValue === this._fileSettings) {
            return this;
          }
          const copy = new EditorSettings(this);
          copy._fileSettings = copy._fileSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "startupSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EditorSettings(this);
              copy._hasStartupSettings = true;
              copy._startupSettings = StartupSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartupSettings) {
                return this;
              }
              const copy = new EditorSettings(this);
              copy._hasStartupSettings = false;
              copy._startupSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasStartupSettings) {
            const copy = new EditorSettings(this);
            copy._hasStartupSettings = true;
            copy._startupSettings = StartupSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._startupSettings.apply(type, path.slice(1), value);
          if (newValue === this._startupSettings) {
            return this;
          }
          const copy = new EditorSettings(this);
          copy._startupSettings = copy._startupSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EditorSettings} other
   * @returns {EditorSettings}
   */
  merge(other) {
    const copy = new EditorSettings(this);
    if (other._hasKeybindSettings) {
      if (copy._hasKeybindSettings) {
        copy._keybindSettings = copy.keybindSettings.merge(other.keybindSettings);
      } else {
        copy._keybindSettings = other._keybindSettings;
      }
      copy._hasKeybindSettings = true;
    }
    if (other._hasFileSettings) {
      if (copy._hasFileSettings) {
        copy._fileSettings = copy.fileSettings.merge(other.fileSettings);
      } else {
        copy._fileSettings = other._fileSettings;
      }
      copy._hasFileSettings = true;
    }
    if (other._hasStartupSettings) {
      if (copy._hasStartupSettings) {
        copy._startupSettings = copy.startupSettings.merge(other.startupSettings);
      } else {
        copy._startupSettings = other._startupSettings;
      }
      copy._hasStartupSettings = true;
    }
    return copy;
  }
}
EditorSettings.default = new EditorSettings();
class EditorSettings_Builder {
  constructor(value) {
    this._value = new EditorSettings(value);
  }
  build() {
    return new EditorSettings(this._value);
  }
  setKeybindSettings(value) {
    this._value._hasKeybindSettings = true;
    this._value._keybindSettings = value;
    return this;
  }
  deleteKeybindSettings() {
    this._value._hasKeybindSettings = false;
    this._value._keybindSettings = null;
    return this;
  }
  setFileSettings(value) {
    this._value._hasFileSettings = true;
    this._value._fileSettings = value;
    return this;
  }
  deleteFileSettings() {
    this._value._hasFileSettings = false;
    this._value._fileSettings = null;
    return this;
  }
  setStartupSettings(value) {
    this._value._hasStartupSettings = true;
    this._value._startupSettings = value;
    return this;
  }
  deleteStartupSettings() {
    this._value._hasStartupSettings = false;
    this._value._startupSettings = null;
    return this;
  }
}
EditorSettings.Builder = EditorSettings_Builder;
class EditorSettings_WithParent {
  /**
   * @param {EditorSettings} value
   * @param {EditorSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EditorSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKeybindSettings() {
    if (this._cachedHasKeybindSettings === undefined) {
      if (this._value.hasKeybindSettings) {
        this._cachedHasKeybindSettings = true;
      } else {
        this._cachedHasKeybindSettings = this._parent ? this._parent.hasKeybindSettings : false;
      }
    }
    return this._cachedHasKeybindSettings;
  }
  get keybindSettings() {
    if (!this._cachedKeybindSettings) {
      if (this._value.hasKeybindSettings) {
        this._cachedKeybindSettings = new KeybindSettingCollection.WithParent(this._value.keybindSettings, this._parent && this._parent.hasKeybindSettings ? this._parent.keybindSettings : null);
      } else {
        this._cachedKeybindSettings = this._parent ? new KeybindSettingCollection.WithParent(KeybindSettingCollection.default, this._parent.keybindSettings) : KeybindSettingCollection.WithParent.default;
      }
    }
    return this._cachedKeybindSettings;
  }
  get hasFileSettings() {
    if (this._cachedHasFileSettings === undefined) {
      if (this._value.hasFileSettings) {
        this._cachedHasFileSettings = true;
      } else {
        this._cachedHasFileSettings = this._parent ? this._parent.hasFileSettings : false;
      }
    }
    return this._cachedHasFileSettings;
  }
  get fileSettings() {
    if (!this._cachedFileSettings) {
      if (this._value.hasFileSettings) {
        this._cachedFileSettings = new FileSettings.WithParent(this._value.fileSettings, this._parent && this._parent.hasFileSettings ? this._parent.fileSettings : null);
      } else {
        this._cachedFileSettings = this._parent ? new FileSettings.WithParent(FileSettings.default, this._parent.fileSettings) : FileSettings.WithParent.default;
      }
    }
    return this._cachedFileSettings;
  }
  get hasStartupSettings() {
    if (this._cachedHasStartupSettings === undefined) {
      if (this._value.hasStartupSettings) {
        this._cachedHasStartupSettings = true;
      } else {
        this._cachedHasStartupSettings = this._parent ? this._parent.hasStartupSettings : false;
      }
    }
    return this._cachedHasStartupSettings;
  }
  get startupSettings() {
    if (!this._cachedStartupSettings) {
      if (this._value.hasStartupSettings) {
        this._cachedStartupSettings = new StartupSettings.WithParent(this._value.startupSettings, this._parent && this._parent.hasStartupSettings ? this._parent.startupSettings : null);
      } else {
        this._cachedStartupSettings = this._parent ? new StartupSettings.WithParent(StartupSettings.default, this._parent.startupSettings) : StartupSettings.WithParent.default;
      }
    }
    return this._cachedStartupSettings;
  }
  update(current, parent) {
    const result = new EditorSettings_WithParent(current, parent);
    if (this._cachedKeybindSettings && this._value.hasKeybindSettings && current.hasKeybindSettings) {
      if (this._value.keybindSettings === current.keybindSettings && this._parent === parent) {
        result._cachedKeybindSettings = this._cachedKeybindSettings;
      } else {
        result._cachedKeybindSettings = this._cachedKeybindSettings.update(current.keybindSettings, parent && parent.hasKeybindSettings ? parent.keybindSettings : null);
      }
    }
    if (this._cachedFileSettings && this._value.hasFileSettings && current.hasFileSettings) {
      if (this._value.fileSettings === current.fileSettings && this._parent === parent) {
        result._cachedFileSettings = this._cachedFileSettings;
      } else {
        result._cachedFileSettings = this._cachedFileSettings.update(current.fileSettings, parent && parent.hasFileSettings ? parent.fileSettings : null);
      }
    }
    if (this._cachedStartupSettings && this._value.hasStartupSettings && current.hasStartupSettings) {
      if (this._value.startupSettings === current.startupSettings && this._parent === parent) {
        result._cachedStartupSettings = this._cachedStartupSettings;
      } else {
        result._cachedStartupSettings = this._cachedStartupSettings.update(current.startupSettings, parent && parent.hasStartupSettings ? parent.startupSettings : null);
      }
    }
    return result;
  }
}
EditorSettings_WithParent.default = new EditorSettings_WithParent(EditorSettings.default, null);
EditorSettings.WithParent = EditorSettings_WithParent;
class EditorSettings_Descriptor {
  get keybindSettings() {
    if (!this._keybindSettings) {
      this._keybindSettings = {
        name: "keybindSettings",
        Name: "KeybindSettings",
        number: 1,
        protoType: 11,
        protoName: "keybindSettings",
        type: KeybindSettingCollection,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keybindSettings;
  }
  get fileSettings() {
    if (!this._fileSettings) {
      this._fileSettings = {
        name: "fileSettings",
        Name: "FileSettings",
        number: 2,
        protoType: 11,
        protoName: "fileSettings",
        type: FileSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fileSettings;
  }
  get startupSettings() {
    if (!this._startupSettings) {
      this._startupSettings = {
        name: "startupSettings",
        Name: "StartupSettings",
        number: 3,
        protoType: 11,
        protoName: "startupSettings",
        type: StartupSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startupSettings;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.keybindSettings,
        this.fileSettings,
        this.startupSettings,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKeybindSettings",
        Name: "DummyOneofForKeybindSettings",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFileSettings",
        Name: "DummyOneofForFileSettings",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartupSettings",
        Name: "DummyOneofForStartupSettings",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EditorSettings.descriptor = new EditorSettings_Descriptor();
export class StartupSettings {
  get descriptor() {
    return StartupSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._startupWindows = [];
  }
  isEmpty() {
    if (this._startupWindows.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StartupSettings) {
      return value;
    }
    return StartupSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new StartupSettings();
    result._startupWindows = JsonToList(json.startupWindows, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._startupWindows.length > 0) {
      result.startupWindows = ArrayToJson(this._startupWindows, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get startupWindows() {
    return this._startupWindows;
  }
  addStartupWindows(path, value) {
    return {type: 'ADD', path: path.concat(['startupWindows']), value};
  }
  setStartupWindows(path, value) {
    return {type: 'SET', path: path.concat(['startupWindows']), value: ArrayToJson(value, JsonToString)};
  }
  setStartupWindowsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['startupWindows', key]), value};
  }
  deleteStartupWindows(path) {
    return {type: 'DELETE', path: path.concat(['startupWindows'])};
  }
  deleteStartupWindowsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['startupWindows', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "startupWindows": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StartupSettings(this);
              copy._startupWindows = [];        for (let i of value) {
                copy._startupWindows.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StartupSettings(this);
              copy._startupWindows = copy._startupWindows.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._startupWindows.length === 0) {
                return this;
              }
              const copy = new StartupSettings(this);
              copy._startupWindows = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._startupWindows.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StartupSettings(this);
              copy._startupWindows = copy._startupWindows.slice();
              copy._startupWindows[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StartupSettings(this);
              copy._startupWindows = copy._startupWindows.slice(0, path[1]).concat(copy._startupWindows.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._startupWindows.length) {
            return this;
          }
          const oldValue = this._startupWindows[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StartupSettings(this);
          copy._startupWindows = copy._startupWindows.slice();
          copy._startupWindows[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StartupSettings} other
   * @returns {StartupSettings}
   */
  merge(other) {
    const copy = new StartupSettings(this);
    copy._startupWindows = this._startupWindows.concat(other._startupWindows);
    return copy;
  }
}
StartupSettings.default = new StartupSettings();
class StartupSettings_Builder {
  constructor(value) {
    this._value = new StartupSettings(value);
  }
  build() {
    return new StartupSettings(this._value);
  }
  addAllStartupWindows(values) {
    this._value._startupWindows = this._value._startupWindows.concat(values);
    return this;
  }
  addStartupWindows(value) {
    this._value._startupWindows = this._value._startupWindows.concat([value]);
    return this;
  }
  setStartupWindows(index, value) {
    this._value._startupWindows = this._value._startupWindows.concat();
    this._value._startupWindows[index] = value;
    return this;
  }
  clearStartupWindows() {
    this._value._startupWindows = [];
    return this;
  }
}
StartupSettings.Builder = StartupSettings_Builder;
class StartupSettings_WithParent {
  /**
   * @param {StartupSettings} value
   * @param {StartupSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StartupSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfStartupWindows() {
    return this._value.startupWindows;
  }
  get inherentStartupWindows() {
    if (!this._inherentStartupWindows) {
      this._inherentStartupWindows = this._parent ? this._parent.startupWindows : [];
    }
    return this._inherentStartupWindows;
  }
  get startupWindows() {
    if (!this._allStartupWindows) {
      this._allStartupWindows = this._parent ? this._parent.startupWindows.concat(this.selfStartupWindows) : this.selfStartupWindows;
    }
    return this._allStartupWindows;
  }
  update(current, parent) {
    const result = new StartupSettings_WithParent(current, parent);
    return result;
  }
}
StartupSettings_WithParent.default = new StartupSettings_WithParent(StartupSettings.default, null);
StartupSettings.WithParent = StartupSettings_WithParent;
class StartupSettings_Descriptor {
  get startupWindows() {
    if (!this._startupWindows) {
      this._startupWindows = {
        name: "startupWindows",
        Name: "StartupWindows",
        number: 1,
        protoType: 9,
        protoName: "startupWindows",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startupWindows;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.startupWindows,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
StartupSettings.descriptor = new StartupSettings_Descriptor();
export class FileSettings {
  get descriptor() {
    return FileSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAutoReloadExternalChanges = false;
    this._autoReloadExternalChanges = null;
  }
  isEmpty() {
    if (this._hasAutoReloadExternalChanges) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FileSettings) {
      return value;
    }
    return FileSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new FileSettings();
    if (json.autoReloadExternalChanges != null) {
      result._hasAutoReloadExternalChanges = true;
      result._autoReloadExternalChanges = JsonToBoolean.fromJson(json.autoReloadExternalChanges);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAutoReloadExternalChanges) {
      result.autoReloadExternalChanges = JsonToBoolean.toJson(this._autoReloadExternalChanges);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get autoReloadExternalChanges() {
    return this._hasAutoReloadExternalChanges ? this._autoReloadExternalChanges : JsonToBoolean.default;
  }
  get hasAutoReloadExternalChanges() {
    return this._hasAutoReloadExternalChanges;
  }
  setAutoReloadExternalChanges(path, value) {
    return {type: 'SET', path: path.concat(['autoReloadExternalChanges']), value};
  }
  deleteAutoReloadExternalChanges(path) {
    return {type: 'DELETE', path: path.concat(['autoReloadExternalChanges'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "autoReloadExternalChanges": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FileSettings(this);
              copy._hasAutoReloadExternalChanges = true;
              copy._autoReloadExternalChanges = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAutoReloadExternalChanges) {
                return this;
              }
              const copy = new FileSettings(this);
              copy._hasAutoReloadExternalChanges = false;
              copy._autoReloadExternalChanges = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FileSettings} other
   * @returns {FileSettings}
   */
  merge(other) {
    const copy = new FileSettings(this);
    if (other._hasAutoReloadExternalChanges) {
      copy._hasAutoReloadExternalChanges = true;
      copy._autoReloadExternalChanges = other._autoReloadExternalChanges;
    }
    return copy;
  }
}
FileSettings.default = new FileSettings();
class FileSettings_Builder {
  constructor(value) {
    this._value = new FileSettings(value);
  }
  build() {
    return new FileSettings(this._value);
  }
  setAutoReloadExternalChanges(value) {
    this._value._hasAutoReloadExternalChanges = true;
    this._value._autoReloadExternalChanges = value;
    return this;
  }
  deleteAutoReloadExternalChanges() {
    this._value._hasAutoReloadExternalChanges = false;
    this._value._autoReloadExternalChanges = null;
    return this;
  }
}
FileSettings.Builder = FileSettings_Builder;
class FileSettings_WithParent {
  /**
   * @param {FileSettings} value
   * @param {FileSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FileSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAutoReloadExternalChanges() {
    if (this._cachedHasAutoReloadExternalChanges === undefined) {
      if (this._value.hasAutoReloadExternalChanges) {
        this._cachedHasAutoReloadExternalChanges = true;
      } else {
        this._cachedHasAutoReloadExternalChanges = this._parent ? this._parent.hasAutoReloadExternalChanges : false;
      }
    }
    return this._cachedHasAutoReloadExternalChanges;
  }
  get autoReloadExternalChanges() {
    if (this._cachedAutoReloadExternalChanges === undefined) {
      if (this._value.hasAutoReloadExternalChanges) {
        this._cachedAutoReloadExternalChanges = this._value.autoReloadExternalChanges;
      } else {
        this._cachedAutoReloadExternalChanges = this._parent ? this._parent.autoReloadExternalChanges : this._value.autoReloadExternalChanges;
      }
    }
    return this._cachedAutoReloadExternalChanges;
  }
  update(current, parent) {
    const result = new FileSettings_WithParent(current, parent);
    return result;
  }
}
FileSettings_WithParent.default = new FileSettings_WithParent(FileSettings.default, null);
FileSettings.WithParent = FileSettings_WithParent;
class FileSettings_Descriptor {
  get autoReloadExternalChanges() {
    if (!this._autoReloadExternalChanges) {
      this._autoReloadExternalChanges = {
        name: "autoReloadExternalChanges",
        Name: "AutoReloadExternalChanges",
        number: 1,
        protoType: 8,
        protoName: "auto_reload_external_changes",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._autoReloadExternalChanges;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.autoReloadExternalChanges,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAutoReloadExternalChanges",
        Name: "DummyOneofForAutoReloadExternalChanges",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
FileSettings.descriptor = new FileSettings_Descriptor();
export class KeybindSettingCollection {
  get descriptor() {
    return KeybindSettingCollection.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasHandleToolFreeMove = false;
    this._HandleToolFreeMove = null;
    this._hasHandleToolTranslate = false;
    this._HandleToolTranslate = null;
    this._hasHandleToolRotate = false;
    this._HandleToolRotate = null;
    this._hasHandleToolScale = false;
    this._HandleToolScale = null;
    this._hasBrushModePaint = false;
    this._BrushModePaint = null;
    this._hasBrushModeSelect = false;
    this._BrushModeSelect = null;
    this._hasBrushModePrecise = false;
    this._BrushModePrecise = null;
    this._hasBrushModeErase = false;
    this._BrushModeErase = null;
  }
  isEmpty() {
    if (this._hasHandleToolFreeMove && !this._HandleToolFreeMove.isEmpty()) return false;
    if (this._hasHandleToolTranslate && !this._HandleToolTranslate.isEmpty()) return false;
    if (this._hasHandleToolRotate && !this._HandleToolRotate.isEmpty()) return false;
    if (this._hasHandleToolScale && !this._HandleToolScale.isEmpty()) return false;
    if (this._hasBrushModePaint && !this._BrushModePaint.isEmpty()) return false;
    if (this._hasBrushModeSelect && !this._BrushModeSelect.isEmpty()) return false;
    if (this._hasBrushModePrecise && !this._BrushModePrecise.isEmpty()) return false;
    if (this._hasBrushModeErase && !this._BrushModeErase.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof KeybindSettingCollection) {
      return value;
    }
    return KeybindSettingCollection.fromJson(value);
  }
  static fromJson(json) {
    const result = new KeybindSettingCollection();
    if (json.HandleToolFreeMove != null) {
      result._hasHandleToolFreeMove = true;
      result._HandleToolFreeMove = Keybind.fromJson(json.HandleToolFreeMove);
    }
    if (json.HandleToolTranslate != null) {
      result._hasHandleToolTranslate = true;
      result._HandleToolTranslate = Keybind.fromJson(json.HandleToolTranslate);
    }
    if (json.HandleToolRotate != null) {
      result._hasHandleToolRotate = true;
      result._HandleToolRotate = Keybind.fromJson(json.HandleToolRotate);
    }
    if (json.HandleToolScale != null) {
      result._hasHandleToolScale = true;
      result._HandleToolScale = Keybind.fromJson(json.HandleToolScale);
    }
    if (json.BrushModePaint != null) {
      result._hasBrushModePaint = true;
      result._BrushModePaint = Keybind.fromJson(json.BrushModePaint);
    }
    if (json.BrushModeSelect != null) {
      result._hasBrushModeSelect = true;
      result._BrushModeSelect = Keybind.fromJson(json.BrushModeSelect);
    }
    if (json.BrushModePrecise != null) {
      result._hasBrushModePrecise = true;
      result._BrushModePrecise = Keybind.fromJson(json.BrushModePrecise);
    }
    if (json.BrushModeErase != null) {
      result._hasBrushModeErase = true;
      result._BrushModeErase = Keybind.fromJson(json.BrushModeErase);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasHandleToolFreeMove && !this._HandleToolFreeMove.isEmpty()) {
      result.HandleToolFreeMove = Keybind.toJson(this._HandleToolFreeMove);
    }
    if (this._hasHandleToolTranslate && !this._HandleToolTranslate.isEmpty()) {
      result.HandleToolTranslate = Keybind.toJson(this._HandleToolTranslate);
    }
    if (this._hasHandleToolRotate && !this._HandleToolRotate.isEmpty()) {
      result.HandleToolRotate = Keybind.toJson(this._HandleToolRotate);
    }
    if (this._hasHandleToolScale && !this._HandleToolScale.isEmpty()) {
      result.HandleToolScale = Keybind.toJson(this._HandleToolScale);
    }
    if (this._hasBrushModePaint && !this._BrushModePaint.isEmpty()) {
      result.BrushModePaint = Keybind.toJson(this._BrushModePaint);
    }
    if (this._hasBrushModeSelect && !this._BrushModeSelect.isEmpty()) {
      result.BrushModeSelect = Keybind.toJson(this._BrushModeSelect);
    }
    if (this._hasBrushModePrecise && !this._BrushModePrecise.isEmpty()) {
      result.BrushModePrecise = Keybind.toJson(this._BrushModePrecise);
    }
    if (this._hasBrushModeErase && !this._BrushModeErase.isEmpty()) {
      result.BrushModeErase = Keybind.toJson(this._BrushModeErase);
    }
    return result;
  }
  /**
   * @returns {Keybind}
   */
  get HandleToolFreeMove() {
    return this._hasHandleToolFreeMove ? this._HandleToolFreeMove : Keybind.default;
  }
  get hasHandleToolFreeMove() {
    return this._hasHandleToolFreeMove;
  }
  setHandleToolFreeMove(path, value) {
    return {type: 'SET', path: path.concat(['HandleToolFreeMove']), value: value.toJson()};
  }
  deleteHandleToolFreeMove(path) {
    return {type: 'DELETE', path: path.concat(['HandleToolFreeMove'])};
  }
  /**
   * @returns {Keybind}
   */
  get HandleToolTranslate() {
    return this._hasHandleToolTranslate ? this._HandleToolTranslate : Keybind.default;
  }
  get hasHandleToolTranslate() {
    return this._hasHandleToolTranslate;
  }
  setHandleToolTranslate(path, value) {
    return {type: 'SET', path: path.concat(['HandleToolTranslate']), value: value.toJson()};
  }
  deleteHandleToolTranslate(path) {
    return {type: 'DELETE', path: path.concat(['HandleToolTranslate'])};
  }
  /**
   * @returns {Keybind}
   */
  get HandleToolRotate() {
    return this._hasHandleToolRotate ? this._HandleToolRotate : Keybind.default;
  }
  get hasHandleToolRotate() {
    return this._hasHandleToolRotate;
  }
  setHandleToolRotate(path, value) {
    return {type: 'SET', path: path.concat(['HandleToolRotate']), value: value.toJson()};
  }
  deleteHandleToolRotate(path) {
    return {type: 'DELETE', path: path.concat(['HandleToolRotate'])};
  }
  /**
   * @returns {Keybind}
   */
  get HandleToolScale() {
    return this._hasHandleToolScale ? this._HandleToolScale : Keybind.default;
  }
  get hasHandleToolScale() {
    return this._hasHandleToolScale;
  }
  setHandleToolScale(path, value) {
    return {type: 'SET', path: path.concat(['HandleToolScale']), value: value.toJson()};
  }
  deleteHandleToolScale(path) {
    return {type: 'DELETE', path: path.concat(['HandleToolScale'])};
  }
  /**
   * @returns {Keybind}
   */
  get BrushModePaint() {
    return this._hasBrushModePaint ? this._BrushModePaint : Keybind.default;
  }
  get hasBrushModePaint() {
    return this._hasBrushModePaint;
  }
  setBrushModePaint(path, value) {
    return {type: 'SET', path: path.concat(['BrushModePaint']), value: value.toJson()};
  }
  deleteBrushModePaint(path) {
    return {type: 'DELETE', path: path.concat(['BrushModePaint'])};
  }
  /**
   * @returns {Keybind}
   */
  get BrushModeSelect() {
    return this._hasBrushModeSelect ? this._BrushModeSelect : Keybind.default;
  }
  get hasBrushModeSelect() {
    return this._hasBrushModeSelect;
  }
  setBrushModeSelect(path, value) {
    return {type: 'SET', path: path.concat(['BrushModeSelect']), value: value.toJson()};
  }
  deleteBrushModeSelect(path) {
    return {type: 'DELETE', path: path.concat(['BrushModeSelect'])};
  }
  /**
   * @returns {Keybind}
   */
  get BrushModePrecise() {
    return this._hasBrushModePrecise ? this._BrushModePrecise : Keybind.default;
  }
  get hasBrushModePrecise() {
    return this._hasBrushModePrecise;
  }
  setBrushModePrecise(path, value) {
    return {type: 'SET', path: path.concat(['BrushModePrecise']), value: value.toJson()};
  }
  deleteBrushModePrecise(path) {
    return {type: 'DELETE', path: path.concat(['BrushModePrecise'])};
  }
  /**
   * @returns {Keybind}
   */
  get BrushModeErase() {
    return this._hasBrushModeErase ? this._BrushModeErase : Keybind.default;
  }
  get hasBrushModeErase() {
    return this._hasBrushModeErase;
  }
  setBrushModeErase(path, value) {
    return {type: 'SET', path: path.concat(['BrushModeErase']), value: value.toJson()};
  }
  deleteBrushModeErase(path) {
    return {type: 'DELETE', path: path.concat(['BrushModeErase'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "HandleToolFreeMove": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new KeybindSettingCollection(this);
              copy._hasHandleToolFreeMove = true;
              copy._HandleToolFreeMove = Keybind.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHandleToolFreeMove) {
                return this;
              }
              const copy = new KeybindSettingCollection(this);
              copy._hasHandleToolFreeMove = false;
              copy._HandleToolFreeMove = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHandleToolFreeMove) {
            const copy = new KeybindSettingCollection(this);
            copy._hasHandleToolFreeMove = true;
            copy._HandleToolFreeMove = Keybind.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._HandleToolFreeMove.apply(type, path.slice(1), value);
          if (newValue === this._HandleToolFreeMove) {
            return this;
          }
          const copy = new KeybindSettingCollection(this);
          copy._HandleToolFreeMove = copy._HandleToolFreeMove.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "HandleToolTranslate": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new KeybindSettingCollection(this);
              copy._hasHandleToolTranslate = true;
              copy._HandleToolTranslate = Keybind.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHandleToolTranslate) {
                return this;
              }
              const copy = new KeybindSettingCollection(this);
              copy._hasHandleToolTranslate = false;
              copy._HandleToolTranslate = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHandleToolTranslate) {
            const copy = new KeybindSettingCollection(this);
            copy._hasHandleToolTranslate = true;
            copy._HandleToolTranslate = Keybind.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._HandleToolTranslate.apply(type, path.slice(1), value);
          if (newValue === this._HandleToolTranslate) {
            return this;
          }
          const copy = new KeybindSettingCollection(this);
          copy._HandleToolTranslate = copy._HandleToolTranslate.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "HandleToolRotate": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new KeybindSettingCollection(this);
              copy._hasHandleToolRotate = true;
              copy._HandleToolRotate = Keybind.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHandleToolRotate) {
                return this;
              }
              const copy = new KeybindSettingCollection(this);
              copy._hasHandleToolRotate = false;
              copy._HandleToolRotate = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHandleToolRotate) {
            const copy = new KeybindSettingCollection(this);
            copy._hasHandleToolRotate = true;
            copy._HandleToolRotate = Keybind.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._HandleToolRotate.apply(type, path.slice(1), value);
          if (newValue === this._HandleToolRotate) {
            return this;
          }
          const copy = new KeybindSettingCollection(this);
          copy._HandleToolRotate = copy._HandleToolRotate.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "HandleToolScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new KeybindSettingCollection(this);
              copy._hasHandleToolScale = true;
              copy._HandleToolScale = Keybind.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHandleToolScale) {
                return this;
              }
              const copy = new KeybindSettingCollection(this);
              copy._hasHandleToolScale = false;
              copy._HandleToolScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHandleToolScale) {
            const copy = new KeybindSettingCollection(this);
            copy._hasHandleToolScale = true;
            copy._HandleToolScale = Keybind.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._HandleToolScale.apply(type, path.slice(1), value);
          if (newValue === this._HandleToolScale) {
            return this;
          }
          const copy = new KeybindSettingCollection(this);
          copy._HandleToolScale = copy._HandleToolScale.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "BrushModePaint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new KeybindSettingCollection(this);
              copy._hasBrushModePaint = true;
              copy._BrushModePaint = Keybind.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBrushModePaint) {
                return this;
              }
              const copy = new KeybindSettingCollection(this);
              copy._hasBrushModePaint = false;
              copy._BrushModePaint = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBrushModePaint) {
            const copy = new KeybindSettingCollection(this);
            copy._hasBrushModePaint = true;
            copy._BrushModePaint = Keybind.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._BrushModePaint.apply(type, path.slice(1), value);
          if (newValue === this._BrushModePaint) {
            return this;
          }
          const copy = new KeybindSettingCollection(this);
          copy._BrushModePaint = copy._BrushModePaint.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "BrushModeSelect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new KeybindSettingCollection(this);
              copy._hasBrushModeSelect = true;
              copy._BrushModeSelect = Keybind.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBrushModeSelect) {
                return this;
              }
              const copy = new KeybindSettingCollection(this);
              copy._hasBrushModeSelect = false;
              copy._BrushModeSelect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBrushModeSelect) {
            const copy = new KeybindSettingCollection(this);
            copy._hasBrushModeSelect = true;
            copy._BrushModeSelect = Keybind.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._BrushModeSelect.apply(type, path.slice(1), value);
          if (newValue === this._BrushModeSelect) {
            return this;
          }
          const copy = new KeybindSettingCollection(this);
          copy._BrushModeSelect = copy._BrushModeSelect.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "BrushModePrecise": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new KeybindSettingCollection(this);
              copy._hasBrushModePrecise = true;
              copy._BrushModePrecise = Keybind.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBrushModePrecise) {
                return this;
              }
              const copy = new KeybindSettingCollection(this);
              copy._hasBrushModePrecise = false;
              copy._BrushModePrecise = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBrushModePrecise) {
            const copy = new KeybindSettingCollection(this);
            copy._hasBrushModePrecise = true;
            copy._BrushModePrecise = Keybind.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._BrushModePrecise.apply(type, path.slice(1), value);
          if (newValue === this._BrushModePrecise) {
            return this;
          }
          const copy = new KeybindSettingCollection(this);
          copy._BrushModePrecise = copy._BrushModePrecise.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "BrushModeErase": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new KeybindSettingCollection(this);
              copy._hasBrushModeErase = true;
              copy._BrushModeErase = Keybind.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBrushModeErase) {
                return this;
              }
              const copy = new KeybindSettingCollection(this);
              copy._hasBrushModeErase = false;
              copy._BrushModeErase = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBrushModeErase) {
            const copy = new KeybindSettingCollection(this);
            copy._hasBrushModeErase = true;
            copy._BrushModeErase = Keybind.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._BrushModeErase.apply(type, path.slice(1), value);
          if (newValue === this._BrushModeErase) {
            return this;
          }
          const copy = new KeybindSettingCollection(this);
          copy._BrushModeErase = copy._BrushModeErase.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {KeybindSettingCollection} other
   * @returns {KeybindSettingCollection}
   */
  merge(other) {
    const copy = new KeybindSettingCollection(this);
    if (other._hasHandleToolFreeMove) {
      if (copy._hasHandleToolFreeMove) {
        copy._HandleToolFreeMove = copy.HandleToolFreeMove.merge(other.HandleToolFreeMove);
      } else {
        copy._HandleToolFreeMove = other._HandleToolFreeMove;
      }
      copy._hasHandleToolFreeMove = true;
    }
    if (other._hasHandleToolTranslate) {
      if (copy._hasHandleToolTranslate) {
        copy._HandleToolTranslate = copy.HandleToolTranslate.merge(other.HandleToolTranslate);
      } else {
        copy._HandleToolTranslate = other._HandleToolTranslate;
      }
      copy._hasHandleToolTranslate = true;
    }
    if (other._hasHandleToolRotate) {
      if (copy._hasHandleToolRotate) {
        copy._HandleToolRotate = copy.HandleToolRotate.merge(other.HandleToolRotate);
      } else {
        copy._HandleToolRotate = other._HandleToolRotate;
      }
      copy._hasHandleToolRotate = true;
    }
    if (other._hasHandleToolScale) {
      if (copy._hasHandleToolScale) {
        copy._HandleToolScale = copy.HandleToolScale.merge(other.HandleToolScale);
      } else {
        copy._HandleToolScale = other._HandleToolScale;
      }
      copy._hasHandleToolScale = true;
    }
    if (other._hasBrushModePaint) {
      if (copy._hasBrushModePaint) {
        copy._BrushModePaint = copy.BrushModePaint.merge(other.BrushModePaint);
      } else {
        copy._BrushModePaint = other._BrushModePaint;
      }
      copy._hasBrushModePaint = true;
    }
    if (other._hasBrushModeSelect) {
      if (copy._hasBrushModeSelect) {
        copy._BrushModeSelect = copy.BrushModeSelect.merge(other.BrushModeSelect);
      } else {
        copy._BrushModeSelect = other._BrushModeSelect;
      }
      copy._hasBrushModeSelect = true;
    }
    if (other._hasBrushModePrecise) {
      if (copy._hasBrushModePrecise) {
        copy._BrushModePrecise = copy.BrushModePrecise.merge(other.BrushModePrecise);
      } else {
        copy._BrushModePrecise = other._BrushModePrecise;
      }
      copy._hasBrushModePrecise = true;
    }
    if (other._hasBrushModeErase) {
      if (copy._hasBrushModeErase) {
        copy._BrushModeErase = copy.BrushModeErase.merge(other.BrushModeErase);
      } else {
        copy._BrushModeErase = other._BrushModeErase;
      }
      copy._hasBrushModeErase = true;
    }
    return copy;
  }
}
KeybindSettingCollection.default = new KeybindSettingCollection();
class KeybindSettingCollection_Builder {
  constructor(value) {
    this._value = new KeybindSettingCollection(value);
  }
  build() {
    return new KeybindSettingCollection(this._value);
  }
  setHandleToolFreeMove(value) {
    this._value._hasHandleToolFreeMove = true;
    this._value._HandleToolFreeMove = value;
    return this;
  }
  deleteHandleToolFreeMove() {
    this._value._hasHandleToolFreeMove = false;
    this._value._HandleToolFreeMove = null;
    return this;
  }
  setHandleToolTranslate(value) {
    this._value._hasHandleToolTranslate = true;
    this._value._HandleToolTranslate = value;
    return this;
  }
  deleteHandleToolTranslate() {
    this._value._hasHandleToolTranslate = false;
    this._value._HandleToolTranslate = null;
    return this;
  }
  setHandleToolRotate(value) {
    this._value._hasHandleToolRotate = true;
    this._value._HandleToolRotate = value;
    return this;
  }
  deleteHandleToolRotate() {
    this._value._hasHandleToolRotate = false;
    this._value._HandleToolRotate = null;
    return this;
  }
  setHandleToolScale(value) {
    this._value._hasHandleToolScale = true;
    this._value._HandleToolScale = value;
    return this;
  }
  deleteHandleToolScale() {
    this._value._hasHandleToolScale = false;
    this._value._HandleToolScale = null;
    return this;
  }
  setBrushModePaint(value) {
    this._value._hasBrushModePaint = true;
    this._value._BrushModePaint = value;
    return this;
  }
  deleteBrushModePaint() {
    this._value._hasBrushModePaint = false;
    this._value._BrushModePaint = null;
    return this;
  }
  setBrushModeSelect(value) {
    this._value._hasBrushModeSelect = true;
    this._value._BrushModeSelect = value;
    return this;
  }
  deleteBrushModeSelect() {
    this._value._hasBrushModeSelect = false;
    this._value._BrushModeSelect = null;
    return this;
  }
  setBrushModePrecise(value) {
    this._value._hasBrushModePrecise = true;
    this._value._BrushModePrecise = value;
    return this;
  }
  deleteBrushModePrecise() {
    this._value._hasBrushModePrecise = false;
    this._value._BrushModePrecise = null;
    return this;
  }
  setBrushModeErase(value) {
    this._value._hasBrushModeErase = true;
    this._value._BrushModeErase = value;
    return this;
  }
  deleteBrushModeErase() {
    this._value._hasBrushModeErase = false;
    this._value._BrushModeErase = null;
    return this;
  }
}
KeybindSettingCollection.Builder = KeybindSettingCollection_Builder;
class KeybindSettingCollection_WithParent {
  /**
   * @param {KeybindSettingCollection} value
   * @param {KeybindSettingCollection_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return KeybindSettingCollection.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasHandleToolFreeMove() {
    if (this._cachedHasHandleToolFreeMove === undefined) {
      if (this._value.hasHandleToolFreeMove) {
        this._cachedHasHandleToolFreeMove = true;
      } else {
        this._cachedHasHandleToolFreeMove = this._parent ? this._parent.hasHandleToolFreeMove : false;
      }
    }
    return this._cachedHasHandleToolFreeMove;
  }
  get HandleToolFreeMove() {
    if (!this._cachedHandleToolFreeMove) {
      if (this._value.hasHandleToolFreeMove) {
        this._cachedHandleToolFreeMove = new Keybind.WithParent(this._value.HandleToolFreeMove, this._parent && this._parent.hasHandleToolFreeMove ? this._parent.HandleToolFreeMove : null);
      } else {
        this._cachedHandleToolFreeMove = this._parent ? new Keybind.WithParent(Keybind.default, this._parent.HandleToolFreeMove) : Keybind.WithParent.default;
      }
    }
    return this._cachedHandleToolFreeMove;
  }
  get hasHandleToolTranslate() {
    if (this._cachedHasHandleToolTranslate === undefined) {
      if (this._value.hasHandleToolTranslate) {
        this._cachedHasHandleToolTranslate = true;
      } else {
        this._cachedHasHandleToolTranslate = this._parent ? this._parent.hasHandleToolTranslate : false;
      }
    }
    return this._cachedHasHandleToolTranslate;
  }
  get HandleToolTranslate() {
    if (!this._cachedHandleToolTranslate) {
      if (this._value.hasHandleToolTranslate) {
        this._cachedHandleToolTranslate = new Keybind.WithParent(this._value.HandleToolTranslate, this._parent && this._parent.hasHandleToolTranslate ? this._parent.HandleToolTranslate : null);
      } else {
        this._cachedHandleToolTranslate = this._parent ? new Keybind.WithParent(Keybind.default, this._parent.HandleToolTranslate) : Keybind.WithParent.default;
      }
    }
    return this._cachedHandleToolTranslate;
  }
  get hasHandleToolRotate() {
    if (this._cachedHasHandleToolRotate === undefined) {
      if (this._value.hasHandleToolRotate) {
        this._cachedHasHandleToolRotate = true;
      } else {
        this._cachedHasHandleToolRotate = this._parent ? this._parent.hasHandleToolRotate : false;
      }
    }
    return this._cachedHasHandleToolRotate;
  }
  get HandleToolRotate() {
    if (!this._cachedHandleToolRotate) {
      if (this._value.hasHandleToolRotate) {
        this._cachedHandleToolRotate = new Keybind.WithParent(this._value.HandleToolRotate, this._parent && this._parent.hasHandleToolRotate ? this._parent.HandleToolRotate : null);
      } else {
        this._cachedHandleToolRotate = this._parent ? new Keybind.WithParent(Keybind.default, this._parent.HandleToolRotate) : Keybind.WithParent.default;
      }
    }
    return this._cachedHandleToolRotate;
  }
  get hasHandleToolScale() {
    if (this._cachedHasHandleToolScale === undefined) {
      if (this._value.hasHandleToolScale) {
        this._cachedHasHandleToolScale = true;
      } else {
        this._cachedHasHandleToolScale = this._parent ? this._parent.hasHandleToolScale : false;
      }
    }
    return this._cachedHasHandleToolScale;
  }
  get HandleToolScale() {
    if (!this._cachedHandleToolScale) {
      if (this._value.hasHandleToolScale) {
        this._cachedHandleToolScale = new Keybind.WithParent(this._value.HandleToolScale, this._parent && this._parent.hasHandleToolScale ? this._parent.HandleToolScale : null);
      } else {
        this._cachedHandleToolScale = this._parent ? new Keybind.WithParent(Keybind.default, this._parent.HandleToolScale) : Keybind.WithParent.default;
      }
    }
    return this._cachedHandleToolScale;
  }
  get hasBrushModePaint() {
    if (this._cachedHasBrushModePaint === undefined) {
      if (this._value.hasBrushModePaint) {
        this._cachedHasBrushModePaint = true;
      } else {
        this._cachedHasBrushModePaint = this._parent ? this._parent.hasBrushModePaint : false;
      }
    }
    return this._cachedHasBrushModePaint;
  }
  get BrushModePaint() {
    if (!this._cachedBrushModePaint) {
      if (this._value.hasBrushModePaint) {
        this._cachedBrushModePaint = new Keybind.WithParent(this._value.BrushModePaint, this._parent && this._parent.hasBrushModePaint ? this._parent.BrushModePaint : null);
      } else {
        this._cachedBrushModePaint = this._parent ? new Keybind.WithParent(Keybind.default, this._parent.BrushModePaint) : Keybind.WithParent.default;
      }
    }
    return this._cachedBrushModePaint;
  }
  get hasBrushModeSelect() {
    if (this._cachedHasBrushModeSelect === undefined) {
      if (this._value.hasBrushModeSelect) {
        this._cachedHasBrushModeSelect = true;
      } else {
        this._cachedHasBrushModeSelect = this._parent ? this._parent.hasBrushModeSelect : false;
      }
    }
    return this._cachedHasBrushModeSelect;
  }
  get BrushModeSelect() {
    if (!this._cachedBrushModeSelect) {
      if (this._value.hasBrushModeSelect) {
        this._cachedBrushModeSelect = new Keybind.WithParent(this._value.BrushModeSelect, this._parent && this._parent.hasBrushModeSelect ? this._parent.BrushModeSelect : null);
      } else {
        this._cachedBrushModeSelect = this._parent ? new Keybind.WithParent(Keybind.default, this._parent.BrushModeSelect) : Keybind.WithParent.default;
      }
    }
    return this._cachedBrushModeSelect;
  }
  get hasBrushModePrecise() {
    if (this._cachedHasBrushModePrecise === undefined) {
      if (this._value.hasBrushModePrecise) {
        this._cachedHasBrushModePrecise = true;
      } else {
        this._cachedHasBrushModePrecise = this._parent ? this._parent.hasBrushModePrecise : false;
      }
    }
    return this._cachedHasBrushModePrecise;
  }
  get BrushModePrecise() {
    if (!this._cachedBrushModePrecise) {
      if (this._value.hasBrushModePrecise) {
        this._cachedBrushModePrecise = new Keybind.WithParent(this._value.BrushModePrecise, this._parent && this._parent.hasBrushModePrecise ? this._parent.BrushModePrecise : null);
      } else {
        this._cachedBrushModePrecise = this._parent ? new Keybind.WithParent(Keybind.default, this._parent.BrushModePrecise) : Keybind.WithParent.default;
      }
    }
    return this._cachedBrushModePrecise;
  }
  get hasBrushModeErase() {
    if (this._cachedHasBrushModeErase === undefined) {
      if (this._value.hasBrushModeErase) {
        this._cachedHasBrushModeErase = true;
      } else {
        this._cachedHasBrushModeErase = this._parent ? this._parent.hasBrushModeErase : false;
      }
    }
    return this._cachedHasBrushModeErase;
  }
  get BrushModeErase() {
    if (!this._cachedBrushModeErase) {
      if (this._value.hasBrushModeErase) {
        this._cachedBrushModeErase = new Keybind.WithParent(this._value.BrushModeErase, this._parent && this._parent.hasBrushModeErase ? this._parent.BrushModeErase : null);
      } else {
        this._cachedBrushModeErase = this._parent ? new Keybind.WithParent(Keybind.default, this._parent.BrushModeErase) : Keybind.WithParent.default;
      }
    }
    return this._cachedBrushModeErase;
  }
  update(current, parent) {
    const result = new KeybindSettingCollection_WithParent(current, parent);
    if (this._cachedHandleToolFreeMove && this._value.hasHandleToolFreeMove && current.hasHandleToolFreeMove) {
      if (this._value.HandleToolFreeMove === current.HandleToolFreeMove && this._parent === parent) {
        result._cachedHandleToolFreeMove = this._cachedHandleToolFreeMove;
      } else {
        result._cachedHandleToolFreeMove = this._cachedHandleToolFreeMove.update(current.HandleToolFreeMove, parent && parent.hasHandleToolFreeMove ? parent.HandleToolFreeMove : null);
      }
    }
    if (this._cachedHandleToolTranslate && this._value.hasHandleToolTranslate && current.hasHandleToolTranslate) {
      if (this._value.HandleToolTranslate === current.HandleToolTranslate && this._parent === parent) {
        result._cachedHandleToolTranslate = this._cachedHandleToolTranslate;
      } else {
        result._cachedHandleToolTranslate = this._cachedHandleToolTranslate.update(current.HandleToolTranslate, parent && parent.hasHandleToolTranslate ? parent.HandleToolTranslate : null);
      }
    }
    if (this._cachedHandleToolRotate && this._value.hasHandleToolRotate && current.hasHandleToolRotate) {
      if (this._value.HandleToolRotate === current.HandleToolRotate && this._parent === parent) {
        result._cachedHandleToolRotate = this._cachedHandleToolRotate;
      } else {
        result._cachedHandleToolRotate = this._cachedHandleToolRotate.update(current.HandleToolRotate, parent && parent.hasHandleToolRotate ? parent.HandleToolRotate : null);
      }
    }
    if (this._cachedHandleToolScale && this._value.hasHandleToolScale && current.hasHandleToolScale) {
      if (this._value.HandleToolScale === current.HandleToolScale && this._parent === parent) {
        result._cachedHandleToolScale = this._cachedHandleToolScale;
      } else {
        result._cachedHandleToolScale = this._cachedHandleToolScale.update(current.HandleToolScale, parent && parent.hasHandleToolScale ? parent.HandleToolScale : null);
      }
    }
    if (this._cachedBrushModePaint && this._value.hasBrushModePaint && current.hasBrushModePaint) {
      if (this._value.BrushModePaint === current.BrushModePaint && this._parent === parent) {
        result._cachedBrushModePaint = this._cachedBrushModePaint;
      } else {
        result._cachedBrushModePaint = this._cachedBrushModePaint.update(current.BrushModePaint, parent && parent.hasBrushModePaint ? parent.BrushModePaint : null);
      }
    }
    if (this._cachedBrushModeSelect && this._value.hasBrushModeSelect && current.hasBrushModeSelect) {
      if (this._value.BrushModeSelect === current.BrushModeSelect && this._parent === parent) {
        result._cachedBrushModeSelect = this._cachedBrushModeSelect;
      } else {
        result._cachedBrushModeSelect = this._cachedBrushModeSelect.update(current.BrushModeSelect, parent && parent.hasBrushModeSelect ? parent.BrushModeSelect : null);
      }
    }
    if (this._cachedBrushModePrecise && this._value.hasBrushModePrecise && current.hasBrushModePrecise) {
      if (this._value.BrushModePrecise === current.BrushModePrecise && this._parent === parent) {
        result._cachedBrushModePrecise = this._cachedBrushModePrecise;
      } else {
        result._cachedBrushModePrecise = this._cachedBrushModePrecise.update(current.BrushModePrecise, parent && parent.hasBrushModePrecise ? parent.BrushModePrecise : null);
      }
    }
    if (this._cachedBrushModeErase && this._value.hasBrushModeErase && current.hasBrushModeErase) {
      if (this._value.BrushModeErase === current.BrushModeErase && this._parent === parent) {
        result._cachedBrushModeErase = this._cachedBrushModeErase;
      } else {
        result._cachedBrushModeErase = this._cachedBrushModeErase.update(current.BrushModeErase, parent && parent.hasBrushModeErase ? parent.BrushModeErase : null);
      }
    }
    return result;
  }
}
KeybindSettingCollection_WithParent.default = new KeybindSettingCollection_WithParent(KeybindSettingCollection.default, null);
KeybindSettingCollection.WithParent = KeybindSettingCollection_WithParent;
class KeybindSettingCollection_Descriptor {
  get HandleToolFreeMove() {
    if (!this._HandleToolFreeMove) {
      this._HandleToolFreeMove = {
        name: "HandleToolFreeMove",
        Name: "HandleToolFreeMove",
        number: 1,
        protoType: 11,
        protoName: "HandleTool_FreeMove",
        type: Keybind,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._HandleToolFreeMove;
  }
  get HandleToolTranslate() {
    if (!this._HandleToolTranslate) {
      this._HandleToolTranslate = {
        name: "HandleToolTranslate",
        Name: "HandleToolTranslate",
        number: 2,
        protoType: 11,
        protoName: "HandleTool_Translate",
        type: Keybind,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._HandleToolTranslate;
  }
  get HandleToolRotate() {
    if (!this._HandleToolRotate) {
      this._HandleToolRotate = {
        name: "HandleToolRotate",
        Name: "HandleToolRotate",
        number: 3,
        protoType: 11,
        protoName: "HandleTool_Rotate",
        type: Keybind,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._HandleToolRotate;
  }
  get HandleToolScale() {
    if (!this._HandleToolScale) {
      this._HandleToolScale = {
        name: "HandleToolScale",
        Name: "HandleToolScale",
        number: 4,
        protoType: 11,
        protoName: "HandleTool_Scale",
        type: Keybind,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._HandleToolScale;
  }
  get BrushModePaint() {
    if (!this._BrushModePaint) {
      this._BrushModePaint = {
        name: "BrushModePaint",
        Name: "BrushModePaint",
        number: 5,
        protoType: 11,
        protoName: "BrushMode_Paint",
        type: Keybind,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BrushModePaint;
  }
  get BrushModeSelect() {
    if (!this._BrushModeSelect) {
      this._BrushModeSelect = {
        name: "BrushModeSelect",
        Name: "BrushModeSelect",
        number: 6,
        protoType: 11,
        protoName: "BrushMode_Select",
        type: Keybind,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BrushModeSelect;
  }
  get BrushModePrecise() {
    if (!this._BrushModePrecise) {
      this._BrushModePrecise = {
        name: "BrushModePrecise",
        Name: "BrushModePrecise",
        number: 7,
        protoType: 11,
        protoName: "BrushMode_Precise",
        type: Keybind,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BrushModePrecise;
  }
  get BrushModeErase() {
    if (!this._BrushModeErase) {
      this._BrushModeErase = {
        name: "BrushModeErase",
        Name: "BrushModeErase",
        number: 8,
        protoType: 11,
        protoName: "BrushMode_Erase",
        type: Keybind,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BrushModeErase;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.HandleToolFreeMove,
        this.HandleToolTranslate,
        this.HandleToolRotate,
        this.HandleToolScale,
        this.BrushModePaint,
        this.BrushModeSelect,
        this.BrushModePrecise,
        this.BrushModeErase,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForHandleToolFreeMove",
        Name: "DummyOneofForHandleToolFreeMove",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHandleToolTranslate",
        Name: "DummyOneofForHandleToolTranslate",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHandleToolRotate",
        Name: "DummyOneofForHandleToolRotate",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHandleToolScale",
        Name: "DummyOneofForHandleToolScale",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBrushModePaint",
        Name: "DummyOneofForBrushModePaint",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBrushModeSelect",
        Name: "DummyOneofForBrushModeSelect",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBrushModePrecise",
        Name: "DummyOneofForBrushModePrecise",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBrushModeErase",
        Name: "DummyOneofForBrushModeErase",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
KeybindSettingCollection.descriptor = new KeybindSettingCollection_Descriptor();
class Keybind_KeyModifier {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "CTRL": return 1;
        case "SHIFT": return 2;
        case "ALT": return 4;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Keybind_KeyModifier.fromJson(value);
  }
  static fromReact(e) {
    return Keybind_KeyModifier.fromJson(e);
  }
}
Keybind_KeyModifier.NONE = 0;
Keybind_KeyModifier.CTRL = 1;
Keybind_KeyModifier.SHIFT = 2;
Keybind_KeyModifier.ALT = 4;
Keybind_KeyModifier.default = 0;
Keybind_KeyModifier.values = {
  NONE: 0,
  CTRL: 1,
  SHIFT: 2,
  ALT: 4,
};
Keybind_KeyModifier.names = {
  0: "NONE",
  1: "CTRL",
  2: "SHIFT",
  4: "ALT",
};
export class Keybind {
  get descriptor() {
    return Keybind.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKeycode = false;
    this._keycode = null;
    this._hasModifiers = false;
    this._modifiers = null;
  }
  isEmpty() {
    if (this._hasKeycode) return false;
    if (this._hasModifiers) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Keybind) {
      return value;
    }
    return Keybind.fromJson(value);
  }
  static fromJson(json) {
    const result = new Keybind();
    if (json.keycode != null) {
      result._hasKeycode = true;
      result._keycode = JsonToInt32.fromJson(json.keycode);
    }
    if (json.modifiers != null) {
      result._hasModifiers = true;
      result._modifiers = Keybind_KeyModifier.fromJson(json.modifiers);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKeycode) {
      result.keycode = JsonToInt32.toJson(this._keycode);
    }
    if (this._hasModifiers) {
      result.modifiers = Keybind_KeyModifier.toJson(this._modifiers);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get keycode() {
    return this._hasKeycode ? this._keycode : JsonToInt32.default;
  }
  get hasKeycode() {
    return this._hasKeycode;
  }
  setKeycode(path, value) {
    return {type: 'SET', path: path.concat(['keycode']), value};
  }
  deleteKeycode(path) {
    return {type: 'DELETE', path: path.concat(['keycode'])};
  }
  /**
   * @returns {number}
   */
  get modifiers() {
    return this._hasModifiers ? this._modifiers : Keybind_KeyModifier.default;
  }
  get hasModifiers() {
    return this._hasModifiers;
  }
  setModifiers(path, value) {
    return {type: 'SET', path: path.concat(['modifiers']), value};
  }
  deleteModifiers(path) {
    return {type: 'DELETE', path: path.concat(['modifiers'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "keycode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Keybind(this);
              copy._hasKeycode = true;
              copy._keycode = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeycode) {
                return this;
              }
              const copy = new Keybind(this);
              copy._hasKeycode = false;
              copy._keycode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "modifiers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Keybind(this);
              copy._hasModifiers = true;
              copy._modifiers = Keybind_KeyModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModifiers) {
                return this;
              }
              const copy = new Keybind(this);
              copy._hasModifiers = false;
              copy._modifiers = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Keybind} other
   * @returns {Keybind}
   */
  merge(other) {
    const copy = new Keybind(this);
    if (other._hasKeycode) {
      copy._hasKeycode = true;
      copy._keycode = other._keycode;
    }
    if (other._hasModifiers) {
      copy._hasModifiers = true;
      copy._modifiers = other._modifiers;
    }
    return copy;
  }
}
Keybind.default = new Keybind();
Keybind.KeyModifier = Keybind_KeyModifier;
class Keybind_Builder {
  constructor(value) {
    this._value = new Keybind(value);
  }
  build() {
    return new Keybind(this._value);
  }
  setKeycode(value) {
    this._value._hasKeycode = true;
    this._value._keycode = value;
    return this;
  }
  deleteKeycode() {
    this._value._hasKeycode = false;
    this._value._keycode = null;
    return this;
  }
  setModifiers(value) {
    this._value._hasModifiers = true;
    this._value._modifiers = value;
    return this;
  }
  deleteModifiers() {
    this._value._hasModifiers = false;
    this._value._modifiers = null;
    return this;
  }
}
Keybind.Builder = Keybind_Builder;
class Keybind_WithParent {
  /**
   * @param {Keybind} value
   * @param {Keybind_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Keybind.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKeycode() {
    if (this._cachedHasKeycode === undefined) {
      if (this._value.hasKeycode) {
        this._cachedHasKeycode = true;
      } else {
        this._cachedHasKeycode = this._parent ? this._parent.hasKeycode : false;
      }
    }
    return this._cachedHasKeycode;
  }
  get keycode() {
    if (this._cachedKeycode === undefined) {
      if (this._value.hasKeycode) {
        this._cachedKeycode = this._value.keycode;
      } else {
        this._cachedKeycode = this._parent ? this._parent.keycode : this._value.keycode;
      }
    }
    return this._cachedKeycode;
  }
  get hasModifiers() {
    if (this._cachedHasModifiers === undefined) {
      if (this._value.hasModifiers) {
        this._cachedHasModifiers = true;
      } else {
        this._cachedHasModifiers = this._parent ? this._parent.hasModifiers : false;
      }
    }
    return this._cachedHasModifiers;
  }
  get modifiers() {
    if (this._cachedModifiers === undefined) {
      if (this._value.hasModifiers) {
        this._cachedModifiers = this._value.modifiers;
      } else {
        this._cachedModifiers = this._parent ? this._parent.modifiers : this._value.modifiers;
      }
    }
    return this._cachedModifiers;
  }
  update(current, parent) {
    const result = new Keybind_WithParent(current, parent);
    return result;
  }
}
Keybind_WithParent.default = new Keybind_WithParent(Keybind.default, null);
Keybind.WithParent = Keybind_WithParent;
class Keybind_Descriptor {
  get keycode() {
    if (!this._keycode) {
      this._keycode = {
        name: "keycode",
        Name: "Keycode",
        number: 1,
        protoType: 5,
        protoName: "keycode",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keycode;
  }
  get modifiers() {
    if (!this._modifiers) {
      this._modifiers = {
        name: "modifiers",
        Name: "Modifiers",
        number: 2,
        protoType: 14,
        protoName: "modifiers",
        type: Keybind_KeyModifier,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifiers;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.keycode,
        this.modifiers,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKeycode",
        Name: "DummyOneofForKeycode",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForModifiers",
        Name: "DummyOneofForModifiers",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Keybind.descriptor = new Keybind_Descriptor();
export class LocalSettingsData {
  get descriptor() {
    return LocalSettingsData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlay = false;
    this._play = null;
  }
  isEmpty() {
    if (this._hasPlay && !this._play.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof LocalSettingsData) {
      return value;
    }
    return LocalSettingsData.fromJson(value);
  }
  static fromJson(json) {
    const result = new LocalSettingsData();
    if (json.play != null) {
      result._hasPlay = true;
      result._play = PlaySettings.fromJson(json.play);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlay && !this._play.isEmpty()) {
      result.play = PlaySettings.toJson(this._play);
    }
    return result;
  }
  /**
   * @returns {PlaySettings}
   */
  get play() {
    return this._hasPlay ? this._play : PlaySettings.default;
  }
  get hasPlay() {
    return this._hasPlay;
  }
  setPlay(path, value) {
    return {type: 'SET', path: path.concat(['play']), value: value.toJson()};
  }
  deletePlay(path) {
    return {type: 'DELETE', path: path.concat(['play'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "play": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LocalSettingsData(this);
              copy._hasPlay = true;
              copy._play = PlaySettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlay) {
                return this;
              }
              const copy = new LocalSettingsData(this);
              copy._hasPlay = false;
              copy._play = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlay) {
            const copy = new LocalSettingsData(this);
            copy._hasPlay = true;
            copy._play = PlaySettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._play.apply(type, path.slice(1), value);
          if (newValue === this._play) {
            return this;
          }
          const copy = new LocalSettingsData(this);
          copy._play = copy._play.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {LocalSettingsData} other
   * @returns {LocalSettingsData}
   */
  merge(other) {
    const copy = new LocalSettingsData(this);
    if (other._hasPlay) {
      if (copy._hasPlay) {
        copy._play = copy.play.merge(other.play);
      } else {
        copy._play = other._play;
      }
      copy._hasPlay = true;
    }
    return copy;
  }
}
LocalSettingsData.default = new LocalSettingsData();
class LocalSettingsData_Builder {
  constructor(value) {
    this._value = new LocalSettingsData(value);
  }
  build() {
    return new LocalSettingsData(this._value);
  }
  setPlay(value) {
    this._value._hasPlay = true;
    this._value._play = value;
    return this;
  }
  deletePlay() {
    this._value._hasPlay = false;
    this._value._play = null;
    return this;
  }
}
LocalSettingsData.Builder = LocalSettingsData_Builder;
class LocalSettingsData_WithParent {
  /**
   * @param {LocalSettingsData} value
   * @param {LocalSettingsData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return LocalSettingsData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlay() {
    if (this._cachedHasPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedHasPlay = true;
      } else {
        this._cachedHasPlay = this._parent ? this._parent.hasPlay : false;
      }
    }
    return this._cachedHasPlay;
  }
  get play() {
    if (!this._cachedPlay) {
      if (this._value.hasPlay) {
        this._cachedPlay = new PlaySettings.WithParent(this._value.play, this._parent && this._parent.hasPlay ? this._parent.play : null);
      } else {
        this._cachedPlay = this._parent ? new PlaySettings.WithParent(PlaySettings.default, this._parent.play) : PlaySettings.WithParent.default;
      }
    }
    return this._cachedPlay;
  }
  update(current, parent) {
    const result = new LocalSettingsData_WithParent(current, parent);
    if (this._cachedPlay && this._value.hasPlay && current.hasPlay) {
      if (this._value.play === current.play && this._parent === parent) {
        result._cachedPlay = this._cachedPlay;
      } else {
        result._cachedPlay = this._cachedPlay.update(current.play, parent && parent.hasPlay ? parent.play : null);
      }
    }
    return result;
  }
}
LocalSettingsData_WithParent.default = new LocalSettingsData_WithParent(LocalSettingsData.default, null);
LocalSettingsData.WithParent = LocalSettingsData_WithParent;
class LocalSettingsData_Descriptor {
  get play() {
    if (!this._play) {
      this._play = {
        name: "play",
        Name: "Play",
        number: 1,
        protoType: 11,
        protoName: "play",
        type: PlaySettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._play;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.play,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlay",
        Name: "DummyOneofForPlay",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
LocalSettingsData.descriptor = new LocalSettingsData_Descriptor();
export class LogSettings {
  get descriptor() {
    return LogSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasVerbose = false;
    this._verbose = null;
  }
  isEmpty() {
    if (this._hasVerbose) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof LogSettings) {
      return value;
    }
    return LogSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new LogSettings();
    if (json.verbose != null) {
      result._hasVerbose = true;
      result._verbose = JsonToBoolean.fromJson(json.verbose);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasVerbose) {
      result.verbose = JsonToBoolean.toJson(this._verbose);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get verbose() {
    return this._hasVerbose ? this._verbose : JsonToBoolean.default;
  }
  get hasVerbose() {
    return this._hasVerbose;
  }
  setVerbose(path, value) {
    return {type: 'SET', path: path.concat(['verbose']), value};
  }
  deleteVerbose(path) {
    return {type: 'DELETE', path: path.concat(['verbose'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "verbose": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LogSettings(this);
              copy._hasVerbose = true;
              copy._verbose = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVerbose) {
                return this;
              }
              const copy = new LogSettings(this);
              copy._hasVerbose = false;
              copy._verbose = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {LogSettings} other
   * @returns {LogSettings}
   */
  merge(other) {
    const copy = new LogSettings(this);
    if (other._hasVerbose) {
      copy._hasVerbose = true;
      copy._verbose = other._verbose;
    }
    return copy;
  }
}
LogSettings.default = new LogSettings();
class LogSettings_Builder {
  constructor(value) {
    this._value = new LogSettings(value);
  }
  build() {
    return new LogSettings(this._value);
  }
  setVerbose(value) {
    this._value._hasVerbose = true;
    this._value._verbose = value;
    return this;
  }
  deleteVerbose() {
    this._value._hasVerbose = false;
    this._value._verbose = null;
    return this;
  }
}
LogSettings.Builder = LogSettings_Builder;
class LogSettings_WithParent {
  /**
   * @param {LogSettings} value
   * @param {LogSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return LogSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasVerbose() {
    if (this._cachedHasVerbose === undefined) {
      if (this._value.hasVerbose) {
        this._cachedHasVerbose = true;
      } else {
        this._cachedHasVerbose = this._parent ? this._parent.hasVerbose : false;
      }
    }
    return this._cachedHasVerbose;
  }
  get verbose() {
    if (this._cachedVerbose === undefined) {
      if (this._value.hasVerbose) {
        this._cachedVerbose = this._value.verbose;
      } else {
        this._cachedVerbose = this._parent ? this._parent.verbose : this._value.verbose;
      }
    }
    return this._cachedVerbose;
  }
  update(current, parent) {
    const result = new LogSettings_WithParent(current, parent);
    return result;
  }
}
LogSettings_WithParent.default = new LogSettings_WithParent(LogSettings.default, null);
LogSettings.WithParent = LogSettings_WithParent;
class LogSettings_Descriptor {
  get verbose() {
    if (!this._verbose) {
      this._verbose = {
        name: "verbose",
        Name: "Verbose",
        number: 1,
        protoType: 8,
        protoName: "verbose",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._verbose;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.verbose,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForVerbose",
        Name: "DummyOneofForVerbose",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
LogSettings.descriptor = new LogSettings_Descriptor();
export class History {
  get descriptor() {
    return History.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._mapHistory = [];
    this._tabHistory = [];
  }
  isEmpty() {
    if (this._mapHistory.length > 0) return false;
    if (this._tabHistory.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof History) {
      return value;
    }
    return History.fromJson(value);
  }
  static fromJson(json) {
    const result = new History();
    result._mapHistory = JsonToList(json.mapHistory, JsonToString);
    result._tabHistory = JsonToList(json.tabHistory, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._mapHistory.length > 0) {
      result.mapHistory = ArrayToJson(this._mapHistory, JsonToString);
    }
    if (this._tabHistory.length > 0) {
      result.tabHistory = ArrayToJson(this._tabHistory, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get mapHistory() {
    return this._mapHistory;
  }
  addMapHistory(path, value) {
    return {type: 'ADD', path: path.concat(['mapHistory']), value};
  }
  setMapHistory(path, value) {
    return {type: 'SET', path: path.concat(['mapHistory']), value: ArrayToJson(value, JsonToString)};
  }
  setMapHistoryByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapHistory', key]), value};
  }
  deleteMapHistory(path) {
    return {type: 'DELETE', path: path.concat(['mapHistory'])};
  }
  deleteMapHistoryByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapHistory', key])};
  }
  /**
   * @returns {string[]}
   */
  get tabHistory() {
    return this._tabHistory;
  }
  addTabHistory(path, value) {
    return {type: 'ADD', path: path.concat(['tabHistory']), value};
  }
  setTabHistory(path, value) {
    return {type: 'SET', path: path.concat(['tabHistory']), value: ArrayToJson(value, JsonToString)};
  }
  setTabHistoryByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['tabHistory', key]), value};
  }
  deleteTabHistory(path) {
    return {type: 'DELETE', path: path.concat(['tabHistory'])};
  }
  deleteTabHistoryByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['tabHistory', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapHistory": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new History(this);
              copy._mapHistory = [];        for (let i of value) {
                copy._mapHistory.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new History(this);
              copy._mapHistory = copy._mapHistory.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapHistory.length === 0) {
                return this;
              }
              const copy = new History(this);
              copy._mapHistory = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapHistory.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new History(this);
              copy._mapHistory = copy._mapHistory.slice();
              copy._mapHistory[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new History(this);
              copy._mapHistory = copy._mapHistory.slice(0, path[1]).concat(copy._mapHistory.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapHistory.length) {
            return this;
          }
          const oldValue = this._mapHistory[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new History(this);
          copy._mapHistory = copy._mapHistory.slice();
          copy._mapHistory[key] = newValue;
          return copy;
        }
      }
      case "tabHistory": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new History(this);
              copy._tabHistory = [];        for (let i of value) {
                copy._tabHistory.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new History(this);
              copy._tabHistory = copy._tabHistory.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._tabHistory.length === 0) {
                return this;
              }
              const copy = new History(this);
              copy._tabHistory = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._tabHistory.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new History(this);
              copy._tabHistory = copy._tabHistory.slice();
              copy._tabHistory[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new History(this);
              copy._tabHistory = copy._tabHistory.slice(0, path[1]).concat(copy._tabHistory.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._tabHistory.length) {
            return this;
          }
          const oldValue = this._tabHistory[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new History(this);
          copy._tabHistory = copy._tabHistory.slice();
          copy._tabHistory[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {History} other
   * @returns {History}
   */
  merge(other) {
    const copy = new History(this);
    copy._mapHistory = this._mapHistory.concat(other._mapHistory);
    copy._tabHistory = this._tabHistory.concat(other._tabHistory);
    return copy;
  }
}
History.default = new History();
class History_Builder {
  constructor(value) {
    this._value = new History(value);
  }
  build() {
    return new History(this._value);
  }
  addAllMapHistory(values) {
    this._value._mapHistory = this._value._mapHistory.concat(values);
    return this;
  }
  addMapHistory(value) {
    this._value._mapHistory = this._value._mapHistory.concat([value]);
    return this;
  }
  setMapHistory(index, value) {
    this._value._mapHistory = this._value._mapHistory.concat();
    this._value._mapHistory[index] = value;
    return this;
  }
  clearMapHistory() {
    this._value._mapHistory = [];
    return this;
  }
  addAllTabHistory(values) {
    this._value._tabHistory = this._value._tabHistory.concat(values);
    return this;
  }
  addTabHistory(value) {
    this._value._tabHistory = this._value._tabHistory.concat([value]);
    return this;
  }
  setTabHistory(index, value) {
    this._value._tabHistory = this._value._tabHistory.concat();
    this._value._tabHistory[index] = value;
    return this;
  }
  clearTabHistory() {
    this._value._tabHistory = [];
    return this;
  }
}
History.Builder = History_Builder;
class History_WithParent {
  /**
   * @param {History} value
   * @param {History_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return History.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfMapHistory() {
    return this._value.mapHistory;
  }
  get inherentMapHistory() {
    if (!this._inherentMapHistory) {
      this._inherentMapHistory = this._parent ? this._parent.mapHistory : [];
    }
    return this._inherentMapHistory;
  }
  get mapHistory() {
    if (!this._allMapHistory) {
      this._allMapHistory = this._parent ? this._parent.mapHistory.concat(this.selfMapHistory) : this.selfMapHistory;
    }
    return this._allMapHistory;
  }
  get selfTabHistory() {
    return this._value.tabHistory;
  }
  get inherentTabHistory() {
    if (!this._inherentTabHistory) {
      this._inherentTabHistory = this._parent ? this._parent.tabHistory : [];
    }
    return this._inherentTabHistory;
  }
  get tabHistory() {
    if (!this._allTabHistory) {
      this._allTabHistory = this._parent ? this._parent.tabHistory.concat(this.selfTabHistory) : this.selfTabHistory;
    }
    return this._allTabHistory;
  }
  update(current, parent) {
    const result = new History_WithParent(current, parent);
    return result;
  }
}
History_WithParent.default = new History_WithParent(History.default, null);
History.WithParent = History_WithParent;
class History_Descriptor {
  get mapHistory() {
    if (!this._mapHistory) {
      this._mapHistory = {
        name: "mapHistory",
        Name: "MapHistory",
        number: 1,
        protoType: 9,
        protoName: "map_history",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapHistory;
  }
  get tabHistory() {
    if (!this._tabHistory) {
      this._tabHistory = {
        name: "tabHistory",
        Name: "TabHistory",
        number: 2,
        protoType: 9,
        protoName: "tab_history",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tabHistory;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapHistory,
        this.tabHistory,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
History.descriptor = new History_Descriptor();
class PlaySettings_SaveData {
  get descriptor() {
    return PlaySettings_SaveData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasSave = false;
    this._save = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasSave) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlaySettings_SaveData) {
      return value;
    }
    return PlaySettings_SaveData.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlaySettings_SaveData();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.save != null) {
      result._hasSave = true;
      result._save = JsonToString.fromJson(json.save);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasSave) {
      result.save = JsonToString.toJson(this._save);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get save() {
    return this._hasSave ? this._save : JsonToString.default;
  }
  get hasSave() {
    return this._hasSave;
  }
  setSave(path, value) {
    return {type: 'SET', path: path.concat(['save']), value};
  }
  deleteSave(path) {
    return {type: 'DELETE', path: path.concat(['save'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings_SaveData(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new PlaySettings_SaveData(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "save": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings_SaveData(this);
              copy._hasSave = true;
              copy._save = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSave) {
                return this;
              }
              const copy = new PlaySettings_SaveData(this);
              copy._hasSave = false;
              copy._save = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlaySettings_SaveData} other
   * @returns {PlaySettings_SaveData}
   */
  merge(other) {
    const copy = new PlaySettings_SaveData(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasSave) {
      copy._hasSave = true;
      copy._save = other._save;
    }
    return copy;
  }
}
PlaySettings_SaveData.default = new PlaySettings_SaveData();
class PlaySettings_SaveData_Builder {
  constructor(value) {
    this._value = new PlaySettings_SaveData(value);
  }
  build() {
    return new PlaySettings_SaveData(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setSave(value) {
    this._value._hasSave = true;
    this._value._save = value;
    return this;
  }
  deleteSave() {
    this._value._hasSave = false;
    this._value._save = null;
    return this;
  }
}
PlaySettings_SaveData.Builder = PlaySettings_SaveData_Builder;
class PlaySettings_SaveData_WithParent {
  /**
   * @param {PlaySettings_SaveData} value
   * @param {PlaySettings_SaveData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlaySettings_SaveData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasSave() {
    if (this._cachedHasSave === undefined) {
      if (this._value.hasSave) {
        this._cachedHasSave = true;
      } else {
        this._cachedHasSave = this._parent ? this._parent.hasSave : false;
      }
    }
    return this._cachedHasSave;
  }
  get save() {
    if (this._cachedSave === undefined) {
      if (this._value.hasSave) {
        this._cachedSave = this._value.save;
      } else {
        this._cachedSave = this._parent ? this._parent.save : this._value.save;
      }
    }
    return this._cachedSave;
  }
  update(current, parent) {
    const result = new PlaySettings_SaveData_WithParent(current, parent);
    return result;
  }
}
PlaySettings_SaveData_WithParent.default = new PlaySettings_SaveData_WithParent(PlaySettings_SaveData.default, null);
PlaySettings_SaveData.WithParent = PlaySettings_SaveData_WithParent;
class PlaySettings_SaveData_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get save() {
    if (!this._save) {
      this._save = {
        name: "save",
        Name: "Save",
        number: 2,
        protoType: 9,
        protoName: "save",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._save;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.save,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSave",
        Name: "DummyOneofForSave",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PlaySettings_SaveData.descriptor = new PlaySettings_SaveData_Descriptor();
class PlaySettings_Language {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "ENGLISH": return 0;
        case "CHINESE_SIMPLIFIED": return 1;
        case "CHINESE_TRADITIONAL": return 2;
        case "JAPANESE": return 3;
        case "KOREAN": return 4;
        case "SPANISH": return 5;
        case "GERMAN": return 6;
        case "PORTUGUESE": return 7;
        case "RUSSIAN": return 8;
        case "FRENCH": return 9;
        case "ITALIAN": return 10;
        case "THAI": return 11;
        case "ARABIC": return 12;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return PlaySettings_Language.fromJson(value);
  }
  static fromReact(e) {
    return PlaySettings_Language.fromJson(e);
  }
}
PlaySettings_Language.ENGLISH = 0;
PlaySettings_Language.CHINESE_SIMPLIFIED = 1;
PlaySettings_Language.CHINESE_TRADITIONAL = 2;
PlaySettings_Language.JAPANESE = 3;
PlaySettings_Language.KOREAN = 4;
PlaySettings_Language.SPANISH = 5;
PlaySettings_Language.GERMAN = 6;
PlaySettings_Language.PORTUGUESE = 7;
PlaySettings_Language.RUSSIAN = 8;
PlaySettings_Language.FRENCH = 9;
PlaySettings_Language.ITALIAN = 10;
PlaySettings_Language.THAI = 11;
PlaySettings_Language.ARABIC = 12;
PlaySettings_Language.default = 0;
PlaySettings_Language.values = {
  ENGLISH: 0,
  CHINESE_SIMPLIFIED: 1,
  CHINESE_TRADITIONAL: 2,
  JAPANESE: 3,
  KOREAN: 4,
  SPANISH: 5,
  GERMAN: 6,
  PORTUGUESE: 7,
  RUSSIAN: 8,
  FRENCH: 9,
  ITALIAN: 10,
  THAI: 11,
  ARABIC: 12,
};
PlaySettings_Language.names = {
  0: "ENGLISH",
  1: "CHINESE_SIMPLIFIED",
  2: "CHINESE_TRADITIONAL",
  3: "JAPANESE",
  4: "KOREAN",
  5: "SPANISH",
  6: "GERMAN",
  7: "PORTUGUESE",
  8: "RUSSIAN",
  9: "FRENCH",
  10: "ITALIAN",
  11: "THAI",
  12: "ARABIC",
};
export class PlaySettings {
  get descriptor() {
    return PlaySettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasResolution = false;
    this._resolution = null;
    this._hasTriggerContext = false;
    this._triggerContext = null;
    this._hasSaveData = false;
    this._saveData = null;
    this._hasLevelName = false;
    this._levelName = null;
    this._hasMuteMusic = false;
    this._muteMusic = null;
    this._hasMuteSound = false;
    this._muteSound = null;
    this._hasSimulateOnline = false;
    this._simulateOnline = null;
    this._hasSimulateAds = false;
    this._simulateAds = null;
    this._hasSimulateGems = false;
    this._simulateGems = null;
    this._hasSimulateUserId = false;
    this._simulateUserId = null;
    this._hasSimulateLeaderBoardTopScore = false;
    this._simulateLeaderBoardTopScore = null;
    this._hasSimulateLeaderBoardGroup = false;
    this._simulateLeaderBoardGroup = null;
    this._hasSimulateTouchInputWithMouseInput = false;
    this._simulateTouchInputWithMouseInput = null;
    this._hasThrowTriggerErrorAsException = false;
    this._throwTriggerErrorAsException = null;
    this._hasTriggerFunctionProfiling = false;
    this._triggerFunctionProfiling = null;
    this._hasLanguage = false;
    this._language = null;
    this._hasWildSkyData = false;
    this._wildSkyData = null;
    this._hasShowIphoneXFrame = false;
    this._showIphoneXFrame = null;
    this._hasUseSafeArea = false;
    this._useSafeArea = null;
    this._mapSaveData = [];
    this._hasFont = false;
    this._font = null;
    this._hasMapKey = false;
    this._mapKey = null;
    this._hasOverrideUpdateFrequency = false;
    this._overrideUpdateFrequency = null;
  }
  isEmpty() {
    if (this._hasResolution && !this._resolution.isEmpty()) return false;
    if (this._hasTriggerContext && !this._triggerContext.isEmpty()) return false;
    if (this._hasSaveData) return false;
    if (this._hasLevelName) return false;
    if (this._hasMuteMusic) return false;
    if (this._hasMuteSound) return false;
    if (this._hasSimulateOnline) return false;
    if (this._hasSimulateAds) return false;
    if (this._hasSimulateGems) return false;
    if (this._hasSimulateUserId) return false;
    if (this._hasSimulateLeaderBoardTopScore) return false;
    if (this._hasSimulateLeaderBoardGroup) return false;
    if (this._hasSimulateTouchInputWithMouseInput) return false;
    if (this._hasThrowTriggerErrorAsException) return false;
    if (this._hasTriggerFunctionProfiling) return false;
    if (this._hasLanguage) return false;
    if (this._hasWildSkyData) return false;
    if (this._hasShowIphoneXFrame) return false;
    if (this._hasUseSafeArea) return false;
    if (this._mapSaveData.length > 0) return false;
    if (this._hasFont) return false;
    if (this._hasMapKey) return false;
    if (this._hasOverrideUpdateFrequency) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlaySettings) {
      return value;
    }
    return PlaySettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlaySettings();
    if (json.resolution != null) {
      result._hasResolution = true;
      result._resolution = ResolutionSettings.fromJson(json.resolution);
    }
    if (json.triggerContext != null) {
      result._hasTriggerContext = true;
      result._triggerContext = TriggerContextSettings.fromJson(json.triggerContext);
    }
    if (json.saveData != null) {
      result._hasSaveData = true;
      result._saveData = JsonToString.fromJson(json.saveData);
    }
    if (json.levelName != null) {
      result._hasLevelName = true;
      result._levelName = JsonToString.fromJson(json.levelName);
    }
    if (json.muteMusic != null) {
      result._hasMuteMusic = true;
      result._muteMusic = JsonToBoolean.fromJson(json.muteMusic);
    }
    if (json.muteSound != null) {
      result._hasMuteSound = true;
      result._muteSound = JsonToBoolean.fromJson(json.muteSound);
    }
    if (json.simulateOnline != null) {
      result._hasSimulateOnline = true;
      result._simulateOnline = JsonToBoolean.fromJson(json.simulateOnline);
    }
    if (json.simulateAds != null) {
      result._hasSimulateAds = true;
      result._simulateAds = JsonToBoolean.fromJson(json.simulateAds);
    }
    if (json.simulateGems != null) {
      result._hasSimulateGems = true;
      result._simulateGems = JsonToInt32.fromJson(json.simulateGems);
    }
    if (json.simulateUserId != null) {
      result._hasSimulateUserId = true;
      result._simulateUserId = JsonToString.fromJson(json.simulateUserId);
    }
    if (json.simulateLeaderBoardTopScore != null) {
      result._hasSimulateLeaderBoardTopScore = true;
      result._simulateLeaderBoardTopScore = JsonToDouble.fromJson(json.simulateLeaderBoardTopScore);
    }
    if (json.simulateLeaderBoardGroup != null) {
      result._hasSimulateLeaderBoardGroup = true;
      result._simulateLeaderBoardGroup = JsonToInt32.fromJson(json.simulateLeaderBoardGroup);
    }
    if (json.simulateTouchInputWithMouseInput != null) {
      result._hasSimulateTouchInputWithMouseInput = true;
      result._simulateTouchInputWithMouseInput = JsonToBoolean.fromJson(json.simulateTouchInputWithMouseInput);
    }
    if (json.throwTriggerErrorAsException != null) {
      result._hasThrowTriggerErrorAsException = true;
      result._throwTriggerErrorAsException = JsonToBoolean.fromJson(json.throwTriggerErrorAsException);
    }
    if (json.triggerFunctionProfiling != null) {
      result._hasTriggerFunctionProfiling = true;
      result._triggerFunctionProfiling = JsonToBoolean.fromJson(json.triggerFunctionProfiling);
    }
    if (json.language != null) {
      result._hasLanguage = true;
      result._language = PlaySettings_Language.fromJson(json.language);
    }
    if (json.wildSkyData != null) {
      result._hasWildSkyData = true;
      result._wildSkyData = JsonToString.fromJson(json.wildSkyData);
    }
    if (json.showIphoneXFrame != null) {
      result._hasShowIphoneXFrame = true;
      result._showIphoneXFrame = JsonToBoolean.fromJson(json.showIphoneXFrame);
    }
    if (json.useSafeArea != null) {
      result._hasUseSafeArea = true;
      result._useSafeArea = JsonToBoolean.fromJson(json.useSafeArea);
    }
    result._mapSaveData = JsonToList(json.mapSaveData, PlaySettings_SaveData);
    if (json.font != null) {
      result._hasFont = true;
      result._font = JsonToString.fromJson(json.font);
    }
    if (json.mapKey != null) {
      result._hasMapKey = true;
      result._mapKey = JsonToString.fromJson(json.mapKey);
    }
    if (json.overrideUpdateFrequency != null) {
      result._hasOverrideUpdateFrequency = true;
      result._overrideUpdateFrequency = JsonToDouble.fromJson(json.overrideUpdateFrequency);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasResolution && !this._resolution.isEmpty()) {
      result.resolution = ResolutionSettings.toJson(this._resolution);
    }
    if (this._hasTriggerContext && !this._triggerContext.isEmpty()) {
      result.triggerContext = TriggerContextSettings.toJson(this._triggerContext);
    }
    if (this._hasSaveData) {
      result.saveData = JsonToString.toJson(this._saveData);
    }
    if (this._hasLevelName) {
      result.levelName = JsonToString.toJson(this._levelName);
    }
    if (this._hasMuteMusic) {
      result.muteMusic = JsonToBoolean.toJson(this._muteMusic);
    }
    if (this._hasMuteSound) {
      result.muteSound = JsonToBoolean.toJson(this._muteSound);
    }
    if (this._hasSimulateOnline) {
      result.simulateOnline = JsonToBoolean.toJson(this._simulateOnline);
    }
    if (this._hasSimulateAds) {
      result.simulateAds = JsonToBoolean.toJson(this._simulateAds);
    }
    if (this._hasSimulateGems) {
      result.simulateGems = JsonToInt32.toJson(this._simulateGems);
    }
    if (this._hasSimulateUserId) {
      result.simulateUserId = JsonToString.toJson(this._simulateUserId);
    }
    if (this._hasSimulateLeaderBoardTopScore) {
      result.simulateLeaderBoardTopScore = JsonToDouble.toJson(this._simulateLeaderBoardTopScore);
    }
    if (this._hasSimulateLeaderBoardGroup) {
      result.simulateLeaderBoardGroup = JsonToInt32.toJson(this._simulateLeaderBoardGroup);
    }
    if (this._hasSimulateTouchInputWithMouseInput) {
      result.simulateTouchInputWithMouseInput = JsonToBoolean.toJson(this._simulateTouchInputWithMouseInput);
    }
    if (this._hasThrowTriggerErrorAsException) {
      result.throwTriggerErrorAsException = JsonToBoolean.toJson(this._throwTriggerErrorAsException);
    }
    if (this._hasTriggerFunctionProfiling) {
      result.triggerFunctionProfiling = JsonToBoolean.toJson(this._triggerFunctionProfiling);
    }
    if (this._hasLanguage) {
      result.language = PlaySettings_Language.toJson(this._language);
    }
    if (this._hasWildSkyData) {
      result.wildSkyData = JsonToString.toJson(this._wildSkyData);
    }
    if (this._hasShowIphoneXFrame) {
      result.showIphoneXFrame = JsonToBoolean.toJson(this._showIphoneXFrame);
    }
    if (this._hasUseSafeArea) {
      result.useSafeArea = JsonToBoolean.toJson(this._useSafeArea);
    }
    if (this._mapSaveData.length > 0) {
      result.mapSaveData = ArrayToJson(this._mapSaveData, PlaySettings_SaveData);
    }
    if (this._hasFont) {
      result.font = JsonToString.toJson(this._font);
    }
    if (this._hasMapKey) {
      result.mapKey = JsonToString.toJson(this._mapKey);
    }
    if (this._hasOverrideUpdateFrequency) {
      result.overrideUpdateFrequency = JsonToDouble.toJson(this._overrideUpdateFrequency);
    }
    return result;
  }
  /**
   * @returns {ResolutionSettings}
   */
  get resolution() {
    return this._hasResolution ? this._resolution : ResolutionSettings.default;
  }
  get hasResolution() {
    return this._hasResolution;
  }
  setResolution(path, value) {
    return {type: 'SET', path: path.concat(['resolution']), value: value.toJson()};
  }
  deleteResolution(path) {
    return {type: 'DELETE', path: path.concat(['resolution'])};
  }
  /**
   * @returns {TriggerContextSettings}
   */
  get triggerContext() {
    return this._hasTriggerContext ? this._triggerContext : TriggerContextSettings.default;
  }
  get hasTriggerContext() {
    return this._hasTriggerContext;
  }
  setTriggerContext(path, value) {
    return {type: 'SET', path: path.concat(['triggerContext']), value: value.toJson()};
  }
  deleteTriggerContext(path) {
    return {type: 'DELETE', path: path.concat(['triggerContext'])};
  }
  /**
   * @returns {string}
   */
  get saveData() {
    return this._hasSaveData ? this._saveData : JsonToString.default;
  }
  get hasSaveData() {
    return this._hasSaveData;
  }
  setSaveData(path, value) {
    return {type: 'SET', path: path.concat(['saveData']), value};
  }
  deleteSaveData(path) {
    return {type: 'DELETE', path: path.concat(['saveData'])};
  }
  /**
   * @returns {string}
   */
  get levelName() {
    return this._hasLevelName ? this._levelName : JsonToString.default;
  }
  get hasLevelName() {
    return this._hasLevelName;
  }
  setLevelName(path, value) {
    return {type: 'SET', path: path.concat(['levelName']), value};
  }
  deleteLevelName(path) {
    return {type: 'DELETE', path: path.concat(['levelName'])};
  }
  /**
   * @returns {boolean}
   */
  get muteMusic() {
    return this._hasMuteMusic ? this._muteMusic : JsonToBoolean.default;
  }
  get hasMuteMusic() {
    return this._hasMuteMusic;
  }
  setMuteMusic(path, value) {
    return {type: 'SET', path: path.concat(['muteMusic']), value};
  }
  deleteMuteMusic(path) {
    return {type: 'DELETE', path: path.concat(['muteMusic'])};
  }
  /**
   * @returns {boolean}
   */
  get muteSound() {
    return this._hasMuteSound ? this._muteSound : JsonToBoolean.default;
  }
  get hasMuteSound() {
    return this._hasMuteSound;
  }
  setMuteSound(path, value) {
    return {type: 'SET', path: path.concat(['muteSound']), value};
  }
  deleteMuteSound(path) {
    return {type: 'DELETE', path: path.concat(['muteSound'])};
  }
  /**
   * @returns {boolean}
   */
  get simulateOnline() {
    return this._hasSimulateOnline ? this._simulateOnline : JsonToBoolean.default;
  }
  get hasSimulateOnline() {
    return this._hasSimulateOnline;
  }
  setSimulateOnline(path, value) {
    return {type: 'SET', path: path.concat(['simulateOnline']), value};
  }
  deleteSimulateOnline(path) {
    return {type: 'DELETE', path: path.concat(['simulateOnline'])};
  }
  /**
   * @returns {boolean}
   */
  get simulateAds() {
    return this._hasSimulateAds ? this._simulateAds : JsonToBoolean.default;
  }
  get hasSimulateAds() {
    return this._hasSimulateAds;
  }
  setSimulateAds(path, value) {
    return {type: 'SET', path: path.concat(['simulateAds']), value};
  }
  deleteSimulateAds(path) {
    return {type: 'DELETE', path: path.concat(['simulateAds'])};
  }
  /**
   * @returns {number}
   */
  get simulateGems() {
    return this._hasSimulateGems ? this._simulateGems : JsonToInt32.default;
  }
  get hasSimulateGems() {
    return this._hasSimulateGems;
  }
  setSimulateGems(path, value) {
    return {type: 'SET', path: path.concat(['simulateGems']), value};
  }
  deleteSimulateGems(path) {
    return {type: 'DELETE', path: path.concat(['simulateGems'])};
  }
  /**
   * @returns {string}
   */
  get simulateUserId() {
    return this._hasSimulateUserId ? this._simulateUserId : JsonToString.default;
  }
  get hasSimulateUserId() {
    return this._hasSimulateUserId;
  }
  setSimulateUserId(path, value) {
    return {type: 'SET', path: path.concat(['simulateUserId']), value};
  }
  deleteSimulateUserId(path) {
    return {type: 'DELETE', path: path.concat(['simulateUserId'])};
  }
  /**
   * @returns {number}
   */
  get simulateLeaderBoardTopScore() {
    return this._hasSimulateLeaderBoardTopScore ? this._simulateLeaderBoardTopScore : JsonToDouble.default;
  }
  get hasSimulateLeaderBoardTopScore() {
    return this._hasSimulateLeaderBoardTopScore;
  }
  setSimulateLeaderBoardTopScore(path, value) {
    return {type: 'SET', path: path.concat(['simulateLeaderBoardTopScore']), value};
  }
  deleteSimulateLeaderBoardTopScore(path) {
    return {type: 'DELETE', path: path.concat(['simulateLeaderBoardTopScore'])};
  }
  /**
   * @returns {number}
   */
  get simulateLeaderBoardGroup() {
    return this._hasSimulateLeaderBoardGroup ? this._simulateLeaderBoardGroup : JsonToInt32.default;
  }
  get hasSimulateLeaderBoardGroup() {
    return this._hasSimulateLeaderBoardGroup;
  }
  setSimulateLeaderBoardGroup(path, value) {
    return {type: 'SET', path: path.concat(['simulateLeaderBoardGroup']), value};
  }
  deleteSimulateLeaderBoardGroup(path) {
    return {type: 'DELETE', path: path.concat(['simulateLeaderBoardGroup'])};
  }
  /**
   * @returns {boolean}
   */
  get simulateTouchInputWithMouseInput() {
    return this._hasSimulateTouchInputWithMouseInput ? this._simulateTouchInputWithMouseInput : JsonToBoolean.default;
  }
  get hasSimulateTouchInputWithMouseInput() {
    return this._hasSimulateTouchInputWithMouseInput;
  }
  setSimulateTouchInputWithMouseInput(path, value) {
    return {type: 'SET', path: path.concat(['simulateTouchInputWithMouseInput']), value};
  }
  deleteSimulateTouchInputWithMouseInput(path) {
    return {type: 'DELETE', path: path.concat(['simulateTouchInputWithMouseInput'])};
  }
  /**
   * @returns {boolean}
   */
  get throwTriggerErrorAsException() {
    return this._hasThrowTriggerErrorAsException ? this._throwTriggerErrorAsException : JsonToBoolean.default;
  }
  get hasThrowTriggerErrorAsException() {
    return this._hasThrowTriggerErrorAsException;
  }
  setThrowTriggerErrorAsException(path, value) {
    return {type: 'SET', path: path.concat(['throwTriggerErrorAsException']), value};
  }
  deleteThrowTriggerErrorAsException(path) {
    return {type: 'DELETE', path: path.concat(['throwTriggerErrorAsException'])};
  }
  /**
   * @returns {boolean}
   */
  get triggerFunctionProfiling() {
    return this._hasTriggerFunctionProfiling ? this._triggerFunctionProfiling : JsonToBoolean.default;
  }
  get hasTriggerFunctionProfiling() {
    return this._hasTriggerFunctionProfiling;
  }
  setTriggerFunctionProfiling(path, value) {
    return {type: 'SET', path: path.concat(['triggerFunctionProfiling']), value};
  }
  deleteTriggerFunctionProfiling(path) {
    return {type: 'DELETE', path: path.concat(['triggerFunctionProfiling'])};
  }
  /**
   * @returns {number}
   */
  get language() {
    return this._hasLanguage ? this._language : PlaySettings_Language.default;
  }
  get hasLanguage() {
    return this._hasLanguage;
  }
  setLanguage(path, value) {
    return {type: 'SET', path: path.concat(['language']), value};
  }
  deleteLanguage(path) {
    return {type: 'DELETE', path: path.concat(['language'])};
  }
  /**
   * @returns {string}
   */
  get wildSkyData() {
    return this._hasWildSkyData ? this._wildSkyData : JsonToString.default;
  }
  get hasWildSkyData() {
    return this._hasWildSkyData;
  }
  setWildSkyData(path, value) {
    return {type: 'SET', path: path.concat(['wildSkyData']), value};
  }
  deleteWildSkyData(path) {
    return {type: 'DELETE', path: path.concat(['wildSkyData'])};
  }
  /**
   * @returns {boolean}
   */
  get showIphoneXFrame() {
    return this._hasShowIphoneXFrame ? this._showIphoneXFrame : JsonToBoolean.default;
  }
  get hasShowIphoneXFrame() {
    return this._hasShowIphoneXFrame;
  }
  setShowIphoneXFrame(path, value) {
    return {type: 'SET', path: path.concat(['showIphoneXFrame']), value};
  }
  deleteShowIphoneXFrame(path) {
    return {type: 'DELETE', path: path.concat(['showIphoneXFrame'])};
  }
  /**
   * @returns {boolean}
   */
  get useSafeArea() {
    return this._hasUseSafeArea ? this._useSafeArea : JsonToBoolean.default;
  }
  get hasUseSafeArea() {
    return this._hasUseSafeArea;
  }
  setUseSafeArea(path, value) {
    return {type: 'SET', path: path.concat(['useSafeArea']), value};
  }
  deleteUseSafeArea(path) {
    return {type: 'DELETE', path: path.concat(['useSafeArea'])};
  }
  /**
   * @returns {PlaySettings_SaveData[]}
   */
  get mapSaveData() {
    return this._mapSaveData;
  }
  addMapSaveData(path, value) {
    return {type: 'ADD', path: path.concat(['mapSaveData']), value: value.toJson()};
  }
  setMapSaveData(path, value) {
    return {type: 'SET', path: path.concat(['mapSaveData']), value: ArrayToJson(value, PlaySettings_SaveData)};
  }
  setMapSaveDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapSaveData', key]), value: value.toJson()};
  }
  deleteMapSaveData(path) {
    return {type: 'DELETE', path: path.concat(['mapSaveData'])};
  }
  deleteMapSaveDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapSaveData', key])};
  }
  /**
   * @returns {string}
   */
  get font() {
    return this._hasFont ? this._font : JsonToString.default;
  }
  get hasFont() {
    return this._hasFont;
  }
  setFont(path, value) {
    return {type: 'SET', path: path.concat(['font']), value};
  }
  deleteFont(path) {
    return {type: 'DELETE', path: path.concat(['font'])};
  }
  /**
   * @returns {string}
   */
  get mapKey() {
    return this._hasMapKey ? this._mapKey : JsonToString.default;
  }
  get hasMapKey() {
    return this._hasMapKey;
  }
  setMapKey(path, value) {
    return {type: 'SET', path: path.concat(['mapKey']), value};
  }
  deleteMapKey(path) {
    return {type: 'DELETE', path: path.concat(['mapKey'])};
  }
  /**
   * @returns {number}
   */
  get overrideUpdateFrequency() {
    return this._hasOverrideUpdateFrequency ? this._overrideUpdateFrequency : JsonToDouble.default;
  }
  get hasOverrideUpdateFrequency() {
    return this._hasOverrideUpdateFrequency;
  }
  setOverrideUpdateFrequency(path, value) {
    return {type: 'SET', path: path.concat(['overrideUpdateFrequency']), value};
  }
  deleteOverrideUpdateFrequency(path) {
    return {type: 'DELETE', path: path.concat(['overrideUpdateFrequency'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "resolution": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasResolution = true;
              copy._resolution = ResolutionSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResolution) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasResolution = false;
              copy._resolution = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasResolution) {
            const copy = new PlaySettings(this);
            copy._hasResolution = true;
            copy._resolution = ResolutionSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._resolution.apply(type, path.slice(1), value);
          if (newValue === this._resolution) {
            return this;
          }
          const copy = new PlaySettings(this);
          copy._resolution = copy._resolution.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "triggerContext": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasTriggerContext = true;
              copy._triggerContext = TriggerContextSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTriggerContext) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasTriggerContext = false;
              copy._triggerContext = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTriggerContext) {
            const copy = new PlaySettings(this);
            copy._hasTriggerContext = true;
            copy._triggerContext = TriggerContextSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._triggerContext.apply(type, path.slice(1), value);
          if (newValue === this._triggerContext) {
            return this;
          }
          const copy = new PlaySettings(this);
          copy._triggerContext = copy._triggerContext.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "saveData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasSaveData = true;
              copy._saveData = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSaveData) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasSaveData = false;
              copy._saveData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasLevelName = true;
              copy._levelName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelName) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasLevelName = false;
              copy._levelName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "muteMusic": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasMuteMusic = true;
              copy._muteMusic = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMuteMusic) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasMuteMusic = false;
              copy._muteMusic = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "muteSound": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasMuteSound = true;
              copy._muteSound = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMuteSound) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasMuteSound = false;
              copy._muteSound = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "simulateOnline": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasSimulateOnline = true;
              copy._simulateOnline = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSimulateOnline) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasSimulateOnline = false;
              copy._simulateOnline = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "simulateAds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasSimulateAds = true;
              copy._simulateAds = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSimulateAds) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasSimulateAds = false;
              copy._simulateAds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "simulateGems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasSimulateGems = true;
              copy._simulateGems = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSimulateGems) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasSimulateGems = false;
              copy._simulateGems = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "simulateUserId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasSimulateUserId = true;
              copy._simulateUserId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSimulateUserId) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasSimulateUserId = false;
              copy._simulateUserId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "simulateLeaderBoardTopScore": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasSimulateLeaderBoardTopScore = true;
              copy._simulateLeaderBoardTopScore = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSimulateLeaderBoardTopScore) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasSimulateLeaderBoardTopScore = false;
              copy._simulateLeaderBoardTopScore = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "simulateLeaderBoardGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasSimulateLeaderBoardGroup = true;
              copy._simulateLeaderBoardGroup = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSimulateLeaderBoardGroup) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasSimulateLeaderBoardGroup = false;
              copy._simulateLeaderBoardGroup = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "simulateTouchInputWithMouseInput": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasSimulateTouchInputWithMouseInput = true;
              copy._simulateTouchInputWithMouseInput = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSimulateTouchInputWithMouseInput) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasSimulateTouchInputWithMouseInput = false;
              copy._simulateTouchInputWithMouseInput = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "throwTriggerErrorAsException": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasThrowTriggerErrorAsException = true;
              copy._throwTriggerErrorAsException = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasThrowTriggerErrorAsException) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasThrowTriggerErrorAsException = false;
              copy._throwTriggerErrorAsException = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "triggerFunctionProfiling": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasTriggerFunctionProfiling = true;
              copy._triggerFunctionProfiling = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTriggerFunctionProfiling) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasTriggerFunctionProfiling = false;
              copy._triggerFunctionProfiling = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "language": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasLanguage = true;
              copy._language = PlaySettings_Language.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLanguage) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasLanguage = false;
              copy._language = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "wildSkyData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasWildSkyData = true;
              copy._wildSkyData = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWildSkyData) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasWildSkyData = false;
              copy._wildSkyData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showIphoneXFrame": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasShowIphoneXFrame = true;
              copy._showIphoneXFrame = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowIphoneXFrame) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasShowIphoneXFrame = false;
              copy._showIphoneXFrame = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useSafeArea": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasUseSafeArea = true;
              copy._useSafeArea = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseSafeArea) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasUseSafeArea = false;
              copy._useSafeArea = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mapSaveData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._mapSaveData = [];        for (let i of value) {
                copy._mapSaveData.push(PlaySettings_SaveData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PlaySettings(this);
              copy._mapSaveData = copy._mapSaveData.concat([PlaySettings_SaveData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapSaveData.length === 0) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._mapSaveData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapSaveData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._mapSaveData = copy._mapSaveData.slice();
              copy._mapSaveData[path[1]] = PlaySettings_SaveData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PlaySettings(this);
              copy._mapSaveData = copy._mapSaveData.slice(0, path[1]).concat(copy._mapSaveData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapSaveData.length) {
            return this;
          }
          const oldValue = this._mapSaveData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PlaySettings(this);
          copy._mapSaveData = copy._mapSaveData.slice();
          copy._mapSaveData[key] = newValue;
          return copy;
        }
      }
      case "font": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasFont = true;
              copy._font = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFont) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasFont = false;
              copy._font = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasMapKey = true;
              copy._mapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapKey) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasMapKey = false;
              copy._mapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "overrideUpdateFrequency": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlaySettings(this);
              copy._hasOverrideUpdateFrequency = true;
              copy._overrideUpdateFrequency = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOverrideUpdateFrequency) {
                return this;
              }
              const copy = new PlaySettings(this);
              copy._hasOverrideUpdateFrequency = false;
              copy._overrideUpdateFrequency = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlaySettings} other
   * @returns {PlaySettings}
   */
  merge(other) {
    const copy = new PlaySettings(this);
    if (other._hasResolution) {
      if (copy._hasResolution) {
        copy._resolution = copy.resolution.merge(other.resolution);
      } else {
        copy._resolution = other._resolution;
      }
      copy._hasResolution = true;
    }
    if (other._hasTriggerContext) {
      if (copy._hasTriggerContext) {
        copy._triggerContext = copy.triggerContext.merge(other.triggerContext);
      } else {
        copy._triggerContext = other._triggerContext;
      }
      copy._hasTriggerContext = true;
    }
    if (other._hasSaveData) {
      copy._hasSaveData = true;
      copy._saveData = other._saveData;
    }
    if (other._hasLevelName) {
      copy._hasLevelName = true;
      copy._levelName = other._levelName;
    }
    if (other._hasMuteMusic) {
      copy._hasMuteMusic = true;
      copy._muteMusic = other._muteMusic;
    }
    if (other._hasMuteSound) {
      copy._hasMuteSound = true;
      copy._muteSound = other._muteSound;
    }
    if (other._hasSimulateOnline) {
      copy._hasSimulateOnline = true;
      copy._simulateOnline = other._simulateOnline;
    }
    if (other._hasSimulateAds) {
      copy._hasSimulateAds = true;
      copy._simulateAds = other._simulateAds;
    }
    if (other._hasSimulateGems) {
      copy._hasSimulateGems = true;
      copy._simulateGems = other._simulateGems;
    }
    if (other._hasSimulateUserId) {
      copy._hasSimulateUserId = true;
      copy._simulateUserId = other._simulateUserId;
    }
    if (other._hasSimulateLeaderBoardTopScore) {
      copy._hasSimulateLeaderBoardTopScore = true;
      copy._simulateLeaderBoardTopScore = other._simulateLeaderBoardTopScore;
    }
    if (other._hasSimulateLeaderBoardGroup) {
      copy._hasSimulateLeaderBoardGroup = true;
      copy._simulateLeaderBoardGroup = other._simulateLeaderBoardGroup;
    }
    if (other._hasSimulateTouchInputWithMouseInput) {
      copy._hasSimulateTouchInputWithMouseInput = true;
      copy._simulateTouchInputWithMouseInput = other._simulateTouchInputWithMouseInput;
    }
    if (other._hasThrowTriggerErrorAsException) {
      copy._hasThrowTriggerErrorAsException = true;
      copy._throwTriggerErrorAsException = other._throwTriggerErrorAsException;
    }
    if (other._hasTriggerFunctionProfiling) {
      copy._hasTriggerFunctionProfiling = true;
      copy._triggerFunctionProfiling = other._triggerFunctionProfiling;
    }
    if (other._hasLanguage) {
      copy._hasLanguage = true;
      copy._language = other._language;
    }
    if (other._hasWildSkyData) {
      copy._hasWildSkyData = true;
      copy._wildSkyData = other._wildSkyData;
    }
    if (other._hasShowIphoneXFrame) {
      copy._hasShowIphoneXFrame = true;
      copy._showIphoneXFrame = other._showIphoneXFrame;
    }
    if (other._hasUseSafeArea) {
      copy._hasUseSafeArea = true;
      copy._useSafeArea = other._useSafeArea;
    }
    copy._mapSaveData = this._mapSaveData.concat(other._mapSaveData);
    if (other._hasFont) {
      copy._hasFont = true;
      copy._font = other._font;
    }
    if (other._hasMapKey) {
      copy._hasMapKey = true;
      copy._mapKey = other._mapKey;
    }
    if (other._hasOverrideUpdateFrequency) {
      copy._hasOverrideUpdateFrequency = true;
      copy._overrideUpdateFrequency = other._overrideUpdateFrequency;
    }
    return copy;
  }
}
PlaySettings.default = new PlaySettings();
PlaySettings.SaveData = PlaySettings_SaveData;
PlaySettings.Language = PlaySettings_Language;
class PlaySettings_Builder {
  constructor(value) {
    this._value = new PlaySettings(value);
  }
  build() {
    return new PlaySettings(this._value);
  }
  setResolution(value) {
    this._value._hasResolution = true;
    this._value._resolution = value;
    return this;
  }
  deleteResolution() {
    this._value._hasResolution = false;
    this._value._resolution = null;
    return this;
  }
  setTriggerContext(value) {
    this._value._hasTriggerContext = true;
    this._value._triggerContext = value;
    return this;
  }
  deleteTriggerContext() {
    this._value._hasTriggerContext = false;
    this._value._triggerContext = null;
    return this;
  }
  setSaveData(value) {
    this._value._hasSaveData = true;
    this._value._saveData = value;
    return this;
  }
  deleteSaveData() {
    this._value._hasSaveData = false;
    this._value._saveData = null;
    return this;
  }
  setLevelName(value) {
    this._value._hasLevelName = true;
    this._value._levelName = value;
    return this;
  }
  deleteLevelName() {
    this._value._hasLevelName = false;
    this._value._levelName = null;
    return this;
  }
  setMuteMusic(value) {
    this._value._hasMuteMusic = true;
    this._value._muteMusic = value;
    return this;
  }
  deleteMuteMusic() {
    this._value._hasMuteMusic = false;
    this._value._muteMusic = null;
    return this;
  }
  setMuteSound(value) {
    this._value._hasMuteSound = true;
    this._value._muteSound = value;
    return this;
  }
  deleteMuteSound() {
    this._value._hasMuteSound = false;
    this._value._muteSound = null;
    return this;
  }
  setSimulateOnline(value) {
    this._value._hasSimulateOnline = true;
    this._value._simulateOnline = value;
    return this;
  }
  deleteSimulateOnline() {
    this._value._hasSimulateOnline = false;
    this._value._simulateOnline = null;
    return this;
  }
  setSimulateAds(value) {
    this._value._hasSimulateAds = true;
    this._value._simulateAds = value;
    return this;
  }
  deleteSimulateAds() {
    this._value._hasSimulateAds = false;
    this._value._simulateAds = null;
    return this;
  }
  setSimulateGems(value) {
    this._value._hasSimulateGems = true;
    this._value._simulateGems = value;
    return this;
  }
  deleteSimulateGems() {
    this._value._hasSimulateGems = false;
    this._value._simulateGems = null;
    return this;
  }
  setSimulateUserId(value) {
    this._value._hasSimulateUserId = true;
    this._value._simulateUserId = value;
    return this;
  }
  deleteSimulateUserId() {
    this._value._hasSimulateUserId = false;
    this._value._simulateUserId = null;
    return this;
  }
  setSimulateLeaderBoardTopScore(value) {
    this._value._hasSimulateLeaderBoardTopScore = true;
    this._value._simulateLeaderBoardTopScore = value;
    return this;
  }
  deleteSimulateLeaderBoardTopScore() {
    this._value._hasSimulateLeaderBoardTopScore = false;
    this._value._simulateLeaderBoardTopScore = null;
    return this;
  }
  setSimulateLeaderBoardGroup(value) {
    this._value._hasSimulateLeaderBoardGroup = true;
    this._value._simulateLeaderBoardGroup = value;
    return this;
  }
  deleteSimulateLeaderBoardGroup() {
    this._value._hasSimulateLeaderBoardGroup = false;
    this._value._simulateLeaderBoardGroup = null;
    return this;
  }
  setSimulateTouchInputWithMouseInput(value) {
    this._value._hasSimulateTouchInputWithMouseInput = true;
    this._value._simulateTouchInputWithMouseInput = value;
    return this;
  }
  deleteSimulateTouchInputWithMouseInput() {
    this._value._hasSimulateTouchInputWithMouseInput = false;
    this._value._simulateTouchInputWithMouseInput = null;
    return this;
  }
  setThrowTriggerErrorAsException(value) {
    this._value._hasThrowTriggerErrorAsException = true;
    this._value._throwTriggerErrorAsException = value;
    return this;
  }
  deleteThrowTriggerErrorAsException() {
    this._value._hasThrowTriggerErrorAsException = false;
    this._value._throwTriggerErrorAsException = null;
    return this;
  }
  setTriggerFunctionProfiling(value) {
    this._value._hasTriggerFunctionProfiling = true;
    this._value._triggerFunctionProfiling = value;
    return this;
  }
  deleteTriggerFunctionProfiling() {
    this._value._hasTriggerFunctionProfiling = false;
    this._value._triggerFunctionProfiling = null;
    return this;
  }
  setLanguage(value) {
    this._value._hasLanguage = true;
    this._value._language = value;
    return this;
  }
  deleteLanguage() {
    this._value._hasLanguage = false;
    this._value._language = null;
    return this;
  }
  setWildSkyData(value) {
    this._value._hasWildSkyData = true;
    this._value._wildSkyData = value;
    return this;
  }
  deleteWildSkyData() {
    this._value._hasWildSkyData = false;
    this._value._wildSkyData = null;
    return this;
  }
  setShowIphoneXFrame(value) {
    this._value._hasShowIphoneXFrame = true;
    this._value._showIphoneXFrame = value;
    return this;
  }
  deleteShowIphoneXFrame() {
    this._value._hasShowIphoneXFrame = false;
    this._value._showIphoneXFrame = null;
    return this;
  }
  setUseSafeArea(value) {
    this._value._hasUseSafeArea = true;
    this._value._useSafeArea = value;
    return this;
  }
  deleteUseSafeArea() {
    this._value._hasUseSafeArea = false;
    this._value._useSafeArea = null;
    return this;
  }
  addAllMapSaveData(values) {
    this._value._mapSaveData = this._value._mapSaveData.concat(values);
    return this;
  }
  addMapSaveData(value) {
    this._value._mapSaveData = this._value._mapSaveData.concat([value]);
    return this;
  }
  setMapSaveData(index, value) {
    this._value._mapSaveData = this._value._mapSaveData.concat();
    this._value._mapSaveData[index] = value;
    return this;
  }
  clearMapSaveData() {
    this._value._mapSaveData = [];
    return this;
  }
  setFont(value) {
    this._value._hasFont = true;
    this._value._font = value;
    return this;
  }
  deleteFont() {
    this._value._hasFont = false;
    this._value._font = null;
    return this;
  }
  setMapKey(value) {
    this._value._hasMapKey = true;
    this._value._mapKey = value;
    return this;
  }
  deleteMapKey() {
    this._value._hasMapKey = false;
    this._value._mapKey = null;
    return this;
  }
  setOverrideUpdateFrequency(value) {
    this._value._hasOverrideUpdateFrequency = true;
    this._value._overrideUpdateFrequency = value;
    return this;
  }
  deleteOverrideUpdateFrequency() {
    this._value._hasOverrideUpdateFrequency = false;
    this._value._overrideUpdateFrequency = null;
    return this;
  }
}
PlaySettings.Builder = PlaySettings_Builder;
class PlaySettings_WithParent {
  /**
   * @param {PlaySettings} value
   * @param {PlaySettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlaySettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasResolution() {
    if (this._cachedHasResolution === undefined) {
      if (this._value.hasResolution) {
        this._cachedHasResolution = true;
      } else {
        this._cachedHasResolution = this._parent ? this._parent.hasResolution : false;
      }
    }
    return this._cachedHasResolution;
  }
  get resolution() {
    if (!this._cachedResolution) {
      if (this._value.hasResolution) {
        this._cachedResolution = new ResolutionSettings.WithParent(this._value.resolution, this._parent && this._parent.hasResolution ? this._parent.resolution : null);
      } else {
        this._cachedResolution = this._parent ? new ResolutionSettings.WithParent(ResolutionSettings.default, this._parent.resolution) : ResolutionSettings.WithParent.default;
      }
    }
    return this._cachedResolution;
  }
  get hasTriggerContext() {
    if (this._cachedHasTriggerContext === undefined) {
      if (this._value.hasTriggerContext) {
        this._cachedHasTriggerContext = true;
      } else {
        this._cachedHasTriggerContext = this._parent ? this._parent.hasTriggerContext : false;
      }
    }
    return this._cachedHasTriggerContext;
  }
  get triggerContext() {
    if (!this._cachedTriggerContext) {
      if (this._value.hasTriggerContext) {
        this._cachedTriggerContext = new TriggerContextSettings.WithParent(this._value.triggerContext, this._parent && this._parent.hasTriggerContext ? this._parent.triggerContext : null);
      } else {
        this._cachedTriggerContext = this._parent ? new TriggerContextSettings.WithParent(TriggerContextSettings.default, this._parent.triggerContext) : TriggerContextSettings.WithParent.default;
      }
    }
    return this._cachedTriggerContext;
  }
  get hasSaveData() {
    if (this._cachedHasSaveData === undefined) {
      if (this._value.hasSaveData) {
        this._cachedHasSaveData = true;
      } else {
        this._cachedHasSaveData = this._parent ? this._parent.hasSaveData : false;
      }
    }
    return this._cachedHasSaveData;
  }
  get saveData() {
    if (this._cachedSaveData === undefined) {
      if (this._value.hasSaveData) {
        this._cachedSaveData = this._value.saveData;
      } else {
        this._cachedSaveData = this._parent ? this._parent.saveData : this._value.saveData;
      }
    }
    return this._cachedSaveData;
  }
  get hasLevelName() {
    if (this._cachedHasLevelName === undefined) {
      if (this._value.hasLevelName) {
        this._cachedHasLevelName = true;
      } else {
        this._cachedHasLevelName = this._parent ? this._parent.hasLevelName : false;
      }
    }
    return this._cachedHasLevelName;
  }
  get levelName() {
    if (this._cachedLevelName === undefined) {
      if (this._value.hasLevelName) {
        this._cachedLevelName = this._value.levelName;
      } else {
        this._cachedLevelName = this._parent ? this._parent.levelName : this._value.levelName;
      }
    }
    return this._cachedLevelName;
  }
  get hasMuteMusic() {
    if (this._cachedHasMuteMusic === undefined) {
      if (this._value.hasMuteMusic) {
        this._cachedHasMuteMusic = true;
      } else {
        this._cachedHasMuteMusic = this._parent ? this._parent.hasMuteMusic : false;
      }
    }
    return this._cachedHasMuteMusic;
  }
  get muteMusic() {
    if (this._cachedMuteMusic === undefined) {
      if (this._value.hasMuteMusic) {
        this._cachedMuteMusic = this._value.muteMusic;
      } else {
        this._cachedMuteMusic = this._parent ? this._parent.muteMusic : this._value.muteMusic;
      }
    }
    return this._cachedMuteMusic;
  }
  get hasMuteSound() {
    if (this._cachedHasMuteSound === undefined) {
      if (this._value.hasMuteSound) {
        this._cachedHasMuteSound = true;
      } else {
        this._cachedHasMuteSound = this._parent ? this._parent.hasMuteSound : false;
      }
    }
    return this._cachedHasMuteSound;
  }
  get muteSound() {
    if (this._cachedMuteSound === undefined) {
      if (this._value.hasMuteSound) {
        this._cachedMuteSound = this._value.muteSound;
      } else {
        this._cachedMuteSound = this._parent ? this._parent.muteSound : this._value.muteSound;
      }
    }
    return this._cachedMuteSound;
  }
  get hasSimulateOnline() {
    if (this._cachedHasSimulateOnline === undefined) {
      if (this._value.hasSimulateOnline) {
        this._cachedHasSimulateOnline = true;
      } else {
        this._cachedHasSimulateOnline = this._parent ? this._parent.hasSimulateOnline : false;
      }
    }
    return this._cachedHasSimulateOnline;
  }
  get simulateOnline() {
    if (this._cachedSimulateOnline === undefined) {
      if (this._value.hasSimulateOnline) {
        this._cachedSimulateOnline = this._value.simulateOnline;
      } else {
        this._cachedSimulateOnline = this._parent ? this._parent.simulateOnline : this._value.simulateOnline;
      }
    }
    return this._cachedSimulateOnline;
  }
  get hasSimulateAds() {
    if (this._cachedHasSimulateAds === undefined) {
      if (this._value.hasSimulateAds) {
        this._cachedHasSimulateAds = true;
      } else {
        this._cachedHasSimulateAds = this._parent ? this._parent.hasSimulateAds : false;
      }
    }
    return this._cachedHasSimulateAds;
  }
  get simulateAds() {
    if (this._cachedSimulateAds === undefined) {
      if (this._value.hasSimulateAds) {
        this._cachedSimulateAds = this._value.simulateAds;
      } else {
        this._cachedSimulateAds = this._parent ? this._parent.simulateAds : this._value.simulateAds;
      }
    }
    return this._cachedSimulateAds;
  }
  get hasSimulateGems() {
    if (this._cachedHasSimulateGems === undefined) {
      if (this._value.hasSimulateGems) {
        this._cachedHasSimulateGems = true;
      } else {
        this._cachedHasSimulateGems = this._parent ? this._parent.hasSimulateGems : false;
      }
    }
    return this._cachedHasSimulateGems;
  }
  get simulateGems() {
    if (this._cachedSimulateGems === undefined) {
      if (this._value.hasSimulateGems) {
        this._cachedSimulateGems = this._value.simulateGems;
      } else {
        this._cachedSimulateGems = this._parent ? this._parent.simulateGems : this._value.simulateGems;
      }
    }
    return this._cachedSimulateGems;
  }
  get hasSimulateUserId() {
    if (this._cachedHasSimulateUserId === undefined) {
      if (this._value.hasSimulateUserId) {
        this._cachedHasSimulateUserId = true;
      } else {
        this._cachedHasSimulateUserId = this._parent ? this._parent.hasSimulateUserId : false;
      }
    }
    return this._cachedHasSimulateUserId;
  }
  get simulateUserId() {
    if (this._cachedSimulateUserId === undefined) {
      if (this._value.hasSimulateUserId) {
        this._cachedSimulateUserId = this._value.simulateUserId;
      } else {
        this._cachedSimulateUserId = this._parent ? this._parent.simulateUserId : this._value.simulateUserId;
      }
    }
    return this._cachedSimulateUserId;
  }
  get hasSimulateLeaderBoardTopScore() {
    if (this._cachedHasSimulateLeaderBoardTopScore === undefined) {
      if (this._value.hasSimulateLeaderBoardTopScore) {
        this._cachedHasSimulateLeaderBoardTopScore = true;
      } else {
        this._cachedHasSimulateLeaderBoardTopScore = this._parent ? this._parent.hasSimulateLeaderBoardTopScore : false;
      }
    }
    return this._cachedHasSimulateLeaderBoardTopScore;
  }
  get simulateLeaderBoardTopScore() {
    if (this._cachedSimulateLeaderBoardTopScore === undefined) {
      if (this._value.hasSimulateLeaderBoardTopScore) {
        this._cachedSimulateLeaderBoardTopScore = this._value.simulateLeaderBoardTopScore;
      } else {
        this._cachedSimulateLeaderBoardTopScore = this._parent ? this._parent.simulateLeaderBoardTopScore : this._value.simulateLeaderBoardTopScore;
      }
    }
    return this._cachedSimulateLeaderBoardTopScore;
  }
  get hasSimulateLeaderBoardGroup() {
    if (this._cachedHasSimulateLeaderBoardGroup === undefined) {
      if (this._value.hasSimulateLeaderBoardGroup) {
        this._cachedHasSimulateLeaderBoardGroup = true;
      } else {
        this._cachedHasSimulateLeaderBoardGroup = this._parent ? this._parent.hasSimulateLeaderBoardGroup : false;
      }
    }
    return this._cachedHasSimulateLeaderBoardGroup;
  }
  get simulateLeaderBoardGroup() {
    if (this._cachedSimulateLeaderBoardGroup === undefined) {
      if (this._value.hasSimulateLeaderBoardGroup) {
        this._cachedSimulateLeaderBoardGroup = this._value.simulateLeaderBoardGroup;
      } else {
        this._cachedSimulateLeaderBoardGroup = this._parent ? this._parent.simulateLeaderBoardGroup : this._value.simulateLeaderBoardGroup;
      }
    }
    return this._cachedSimulateLeaderBoardGroup;
  }
  get hasSimulateTouchInputWithMouseInput() {
    if (this._cachedHasSimulateTouchInputWithMouseInput === undefined) {
      if (this._value.hasSimulateTouchInputWithMouseInput) {
        this._cachedHasSimulateTouchInputWithMouseInput = true;
      } else {
        this._cachedHasSimulateTouchInputWithMouseInput = this._parent ? this._parent.hasSimulateTouchInputWithMouseInput : false;
      }
    }
    return this._cachedHasSimulateTouchInputWithMouseInput;
  }
  get simulateTouchInputWithMouseInput() {
    if (this._cachedSimulateTouchInputWithMouseInput === undefined) {
      if (this._value.hasSimulateTouchInputWithMouseInput) {
        this._cachedSimulateTouchInputWithMouseInput = this._value.simulateTouchInputWithMouseInput;
      } else {
        this._cachedSimulateTouchInputWithMouseInput = this._parent ? this._parent.simulateTouchInputWithMouseInput : this._value.simulateTouchInputWithMouseInput;
      }
    }
    return this._cachedSimulateTouchInputWithMouseInput;
  }
  get hasThrowTriggerErrorAsException() {
    if (this._cachedHasThrowTriggerErrorAsException === undefined) {
      if (this._value.hasThrowTriggerErrorAsException) {
        this._cachedHasThrowTriggerErrorAsException = true;
      } else {
        this._cachedHasThrowTriggerErrorAsException = this._parent ? this._parent.hasThrowTriggerErrorAsException : false;
      }
    }
    return this._cachedHasThrowTriggerErrorAsException;
  }
  get throwTriggerErrorAsException() {
    if (this._cachedThrowTriggerErrorAsException === undefined) {
      if (this._value.hasThrowTriggerErrorAsException) {
        this._cachedThrowTriggerErrorAsException = this._value.throwTriggerErrorAsException;
      } else {
        this._cachedThrowTriggerErrorAsException = this._parent ? this._parent.throwTriggerErrorAsException : this._value.throwTriggerErrorAsException;
      }
    }
    return this._cachedThrowTriggerErrorAsException;
  }
  get hasTriggerFunctionProfiling() {
    if (this._cachedHasTriggerFunctionProfiling === undefined) {
      if (this._value.hasTriggerFunctionProfiling) {
        this._cachedHasTriggerFunctionProfiling = true;
      } else {
        this._cachedHasTriggerFunctionProfiling = this._parent ? this._parent.hasTriggerFunctionProfiling : false;
      }
    }
    return this._cachedHasTriggerFunctionProfiling;
  }
  get triggerFunctionProfiling() {
    if (this._cachedTriggerFunctionProfiling === undefined) {
      if (this._value.hasTriggerFunctionProfiling) {
        this._cachedTriggerFunctionProfiling = this._value.triggerFunctionProfiling;
      } else {
        this._cachedTriggerFunctionProfiling = this._parent ? this._parent.triggerFunctionProfiling : this._value.triggerFunctionProfiling;
      }
    }
    return this._cachedTriggerFunctionProfiling;
  }
  get hasLanguage() {
    if (this._cachedHasLanguage === undefined) {
      if (this._value.hasLanguage) {
        this._cachedHasLanguage = true;
      } else {
        this._cachedHasLanguage = this._parent ? this._parent.hasLanguage : false;
      }
    }
    return this._cachedHasLanguage;
  }
  get language() {
    if (this._cachedLanguage === undefined) {
      if (this._value.hasLanguage) {
        this._cachedLanguage = this._value.language;
      } else {
        this._cachedLanguage = this._parent ? this._parent.language : this._value.language;
      }
    }
    return this._cachedLanguage;
  }
  get hasWildSkyData() {
    if (this._cachedHasWildSkyData === undefined) {
      if (this._value.hasWildSkyData) {
        this._cachedHasWildSkyData = true;
      } else {
        this._cachedHasWildSkyData = this._parent ? this._parent.hasWildSkyData : false;
      }
    }
    return this._cachedHasWildSkyData;
  }
  get wildSkyData() {
    if (this._cachedWildSkyData === undefined) {
      if (this._value.hasWildSkyData) {
        this._cachedWildSkyData = this._value.wildSkyData;
      } else {
        this._cachedWildSkyData = this._parent ? this._parent.wildSkyData : this._value.wildSkyData;
      }
    }
    return this._cachedWildSkyData;
  }
  get hasShowIphoneXFrame() {
    if (this._cachedHasShowIphoneXFrame === undefined) {
      if (this._value.hasShowIphoneXFrame) {
        this._cachedHasShowIphoneXFrame = true;
      } else {
        this._cachedHasShowIphoneXFrame = this._parent ? this._parent.hasShowIphoneXFrame : false;
      }
    }
    return this._cachedHasShowIphoneXFrame;
  }
  get showIphoneXFrame() {
    if (this._cachedShowIphoneXFrame === undefined) {
      if (this._value.hasShowIphoneXFrame) {
        this._cachedShowIphoneXFrame = this._value.showIphoneXFrame;
      } else {
        this._cachedShowIphoneXFrame = this._parent ? this._parent.showIphoneXFrame : this._value.showIphoneXFrame;
      }
    }
    return this._cachedShowIphoneXFrame;
  }
  get hasUseSafeArea() {
    if (this._cachedHasUseSafeArea === undefined) {
      if (this._value.hasUseSafeArea) {
        this._cachedHasUseSafeArea = true;
      } else {
        this._cachedHasUseSafeArea = this._parent ? this._parent.hasUseSafeArea : false;
      }
    }
    return this._cachedHasUseSafeArea;
  }
  get useSafeArea() {
    if (this._cachedUseSafeArea === undefined) {
      if (this._value.hasUseSafeArea) {
        this._cachedUseSafeArea = this._value.useSafeArea;
      } else {
        this._cachedUseSafeArea = this._parent ? this._parent.useSafeArea : this._value.useSafeArea;
      }
    }
    return this._cachedUseSafeArea;
  }
  get selfMapSaveData() {
    if (!this._selfMapSaveData) {
      this._selfMapSaveData = [];
      for (let i of this._value.mapSaveData) {
        this._selfMapSaveData.push(new PlaySettings_SaveData.WithParent(i, null));
      }
    }
    return this._selfMapSaveData;
  }
  get inherentMapSaveData() {
    if (!this._inherentMapSaveData) {
      this._inherentMapSaveData = this._parent ? this._parent.mapSaveData : [];
    }
    return this._inherentMapSaveData;
  }
  get mapSaveData() {
    if (!this._allMapSaveData) {
      this._allMapSaveData = this._parent ? this._parent.mapSaveData.concat(this.selfMapSaveData) : this.selfMapSaveData;
    }
    return this._allMapSaveData;
  }
  get hasFont() {
    if (this._cachedHasFont === undefined) {
      if (this._value.hasFont) {
        this._cachedHasFont = true;
      } else {
        this._cachedHasFont = this._parent ? this._parent.hasFont : false;
      }
    }
    return this._cachedHasFont;
  }
  get font() {
    if (this._cachedFont === undefined) {
      if (this._value.hasFont) {
        this._cachedFont = this._value.font;
      } else {
        this._cachedFont = this._parent ? this._parent.font : this._value.font;
      }
    }
    return this._cachedFont;
  }
  get hasMapKey() {
    if (this._cachedHasMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedHasMapKey = true;
      } else {
        this._cachedHasMapKey = this._parent ? this._parent.hasMapKey : false;
      }
    }
    return this._cachedHasMapKey;
  }
  get mapKey() {
    if (this._cachedMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedMapKey = this._value.mapKey;
      } else {
        this._cachedMapKey = this._parent ? this._parent.mapKey : this._value.mapKey;
      }
    }
    return this._cachedMapKey;
  }
  get hasOverrideUpdateFrequency() {
    if (this._cachedHasOverrideUpdateFrequency === undefined) {
      if (this._value.hasOverrideUpdateFrequency) {
        this._cachedHasOverrideUpdateFrequency = true;
      } else {
        this._cachedHasOverrideUpdateFrequency = this._parent ? this._parent.hasOverrideUpdateFrequency : false;
      }
    }
    return this._cachedHasOverrideUpdateFrequency;
  }
  get overrideUpdateFrequency() {
    if (this._cachedOverrideUpdateFrequency === undefined) {
      if (this._value.hasOverrideUpdateFrequency) {
        this._cachedOverrideUpdateFrequency = this._value.overrideUpdateFrequency;
      } else {
        this._cachedOverrideUpdateFrequency = this._parent ? this._parent.overrideUpdateFrequency : this._value.overrideUpdateFrequency;
      }
    }
    return this._cachedOverrideUpdateFrequency;
  }
  update(current, parent) {
    const result = new PlaySettings_WithParent(current, parent);
    if (this._cachedResolution && this._value.hasResolution && current.hasResolution) {
      if (this._value.resolution === current.resolution && this._parent === parent) {
        result._cachedResolution = this._cachedResolution;
      } else {
        result._cachedResolution = this._cachedResolution.update(current.resolution, parent && parent.hasResolution ? parent.resolution : null);
      }
    }
    if (this._cachedTriggerContext && this._value.hasTriggerContext && current.hasTriggerContext) {
      if (this._value.triggerContext === current.triggerContext && this._parent === parent) {
        result._cachedTriggerContext = this._cachedTriggerContext;
      } else {
        result._cachedTriggerContext = this._cachedTriggerContext.update(current.triggerContext, parent && parent.hasTriggerContext ? parent.triggerContext : null);
      }
    }
    if (this._selfMapSaveData) {
      if (this._value.mapSaveData === current.mapSaveData) {
        result._selfMapSaveData = this._selfMapSaveData;
      } else {
        result._selfMapSaveData = [];
        for (let i = 0; i < current.mapSaveData.length; i++) {
          const oldValue = this._value.mapSaveData[i];
          if (oldValue) {
            const oldCache = this._selfMapSaveData[i];
            if (oldValue === current.mapSaveData[i]) {
              result._selfMapSaveData[i] = oldCache;
            } else {
              result._selfMapSaveData[i] = oldCache.update(current.mapSaveData[i], null);
            }
          } else {
            result._selfMapSaveData[i] = new PlaySettings_SaveData.WithParent(current.mapSaveData[i], null);
          }
        }
      }
    }
    return result;
  }
}
PlaySettings_WithParent.default = new PlaySettings_WithParent(PlaySettings.default, null);
PlaySettings.WithParent = PlaySettings_WithParent;
class PlaySettings_Descriptor {
  get resolution() {
    if (!this._resolution) {
      this._resolution = {
        name: "resolution",
        Name: "Resolution",
        number: 1,
        protoType: 11,
        protoName: "resolution",
        type: ResolutionSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resolution;
  }
  get triggerContext() {
    if (!this._triggerContext) {
      this._triggerContext = {
        name: "triggerContext",
        Name: "TriggerContext",
        number: 2,
        protoType: 11,
        protoName: "trigger_context",
        type: TriggerContextSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggerContext;
  }
  get saveData() {
    if (!this._saveData) {
      this._saveData = {
        name: "saveData",
        Name: "SaveData",
        number: 4,
        protoType: 9,
        protoName: "save_data",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._saveData;
  }
  get levelName() {
    if (!this._levelName) {
      this._levelName = {
        name: "levelName",
        Name: "LevelName",
        number: 5,
        protoType: 9,
        protoName: "level_name",
        type: JsonToString,
        options: {
          comments: "The level to play when editting data modules.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelName;
  }
  get muteMusic() {
    if (!this._muteMusic) {
      this._muteMusic = {
        name: "muteMusic",
        Name: "MuteMusic",
        number: 51,
        protoType: 8,
        protoName: "mute_music",
        type: JsonToBoolean,
        options: {
          comments: "If set, the game will start with music muted.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._muteMusic;
  }
  get muteSound() {
    if (!this._muteSound) {
      this._muteSound = {
        name: "muteSound",
        Name: "MuteSound",
        number: 52,
        protoType: 8,
        protoName: "mute_sound",
        type: JsonToBoolean,
        options: {
          comments: "If set, the game will start with sound muted.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._muteSound;
  }
  get simulateOnline() {
    if (!this._simulateOnline) {
      this._simulateOnline = {
        name: "simulateOnline",
        Name: "SimulateOnline",
        number: 7,
        protoType: 8,
        protoName: "simulate_online",
        type: JsonToBoolean,
        options: {
          comments: "If set, trigger API DCEI.IsOnline() will always return true",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._simulateOnline;
  }
  get simulateAds() {
    if (!this._simulateAds) {
      this._simulateAds = {
        name: "simulateAds",
        Name: "SimulateAds",
        number: 8,
        protoType: 8,
        protoName: "simulate_ads",
        type: JsonToBoolean,
        options: {
          comments: "If set, trigger API DCEI.ShowAds() will always be called with success.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._simulateAds;
  }
  get simulateGems() {
    if (!this._simulateGems) {
      this._simulateGems = {
        name: "simulateGems",
        Name: "SimulateGems",
        number: 9,
        protoType: 5,
        protoName: "simulate_gems",
        type: JsonToInt32,
        options: {
          comments: "If set, trigger API DCEI.GetGems() will return this value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._simulateGems;
  }
  get simulateUserId() {
    if (!this._simulateUserId) {
      this._simulateUserId = {
        name: "simulateUserId",
        Name: "SimulateUserId",
        number: 10,
        protoType: 9,
        protoName: "simulate_user_id",
        type: JsonToString,
        options: {
          comments: "If set, trigger API DCEI.GetUserId() will return this value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._simulateUserId;
  }
  get simulateLeaderBoardTopScore() {
    if (!this._simulateLeaderBoardTopScore) {
      this._simulateLeaderBoardTopScore = {
        name: "simulateLeaderBoardTopScore",
        Name: "SimulateLeaderBoardTopScore",
        number: 11,
        protoType: 1,
        protoName: "simulate_leader_board_top_score",
        type: JsonToDouble,
        options: {
          comments: "Set this value to the highest possible leader-board score. Users\' rank will be calculated from the diff between the users\' score and this value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._simulateLeaderBoardTopScore;
  }
  get simulateLeaderBoardGroup() {
    if (!this._simulateLeaderBoardGroup) {
      this._simulateLeaderBoardGroup = {
        name: "simulateLeaderBoardGroup",
        Name: "SimulateLeaderBoardGroup",
        number: 12,
        protoType: 5,
        protoName: "simulate_leader_board_group",
        type: JsonToInt32,
        options: {
          comments: "What group the user belongs to. 0 is normal users, 1 is cheater.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._simulateLeaderBoardGroup;
  }
  get simulateTouchInputWithMouseInput() {
    if (!this._simulateTouchInputWithMouseInput) {
      this._simulateTouchInputWithMouseInput = {
        name: "simulateTouchInputWithMouseInput",
        Name: "SimulateTouchInputWithMouseInput",
        number: 18,
        protoType: 8,
        protoName: "simulate_touch_input_with_mouse_input",
        type: JsonToBoolean,
        options: {
          comments: "If set, all mouse input events will be converted to touch input events. Use this when you need to test touch input handling on PC without a touch screen.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._simulateTouchInputWithMouseInput;
  }
  get throwTriggerErrorAsException() {
    if (!this._throwTriggerErrorAsException) {
      this._throwTriggerErrorAsException = {
        name: "throwTriggerErrorAsException",
        Name: "ThrowTriggerErrorAsException",
        number: 13,
        protoType: 8,
        protoName: "throw_trigger_error_as_exception",
        type: JsonToBoolean,
        options: {
          comments: "If set, trigger errors will be thrown as exceptions with full stack trace. Useful to get more context(e.g. line number) when trying to fix an error.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._throwTriggerErrorAsException;
  }
  get triggerFunctionProfiling() {
    if (!this._triggerFunctionProfiling) {
      this._triggerFunctionProfiling = {
        name: "triggerFunctionProfiling",
        Name: "TriggerFunctionProfiling",
        number: 17,
        protoType: 8,
        protoName: "trigger_function_profiling",
        type: JsonToBoolean,
        options: {
          comments: "If set, press F6 when playing a level in the editor will produce a trigger function profiling log file with information about how many times a trigger API is called and how many times each user-defined functions are called. Note that this adds extra overhead to each Lua function call and can cause lags when there are many Lua function calls.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggerFunctionProfiling;
  }
  get language() {
    if (!this._language) {
      this._language = {
        name: "language",
        Name: "Language",
        number: 14,
        protoType: 14,
        protoName: "language",
        type: PlaySettings_Language,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._language;
  }
  get wildSkyData() {
    if (!this._wildSkyData) {
      this._wildSkyData = {
        name: "wildSkyData",
        Name: "WildSkyData",
        number: 15,
        protoType: 9,
        protoName: "wild_sky_data",
        type: JsonToString,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._wildSkyData;
  }
  get showIphoneXFrame() {
    if (!this._showIphoneXFrame) {
      this._showIphoneXFrame = {
        name: "showIphoneXFrame",
        Name: "ShowIphoneXFrame",
        number: 101,
        protoType: 8,
        protoName: "show_iphone_x_frame",
        type: JsonToBoolean,
        options: {
          comments: "Show a iPhone X frame on the screen.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showIphoneXFrame;
  }
  get useSafeArea() {
    if (!this._useSafeArea) {
      this._useSafeArea = {
        name: "useSafeArea",
        Name: "UseSafeArea",
        number: 102,
        protoType: 8,
        protoName: "use_safe_area",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useSafeArea;
  }
  get mapSaveData() {
    if (!this._mapSaveData) {
      this._mapSaveData = {
        name: "mapSaveData",
        Name: "MapSaveData",
        number: 6,
        protoType: 11,
        protoName: "map_save_data",
        type: PlaySettings_SaveData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapSaveData;
  }
  get font() {
    if (!this._font) {
      this._font = {
        name: "font",
        Name: "Font",
        number: 21,
        protoType: 9,
        protoName: "font",
        type: JsonToString,
        options: {
          valueDropdown: "Fonts",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._font;
  }
  get mapKey() {
    if (!this._mapKey) {
      this._mapKey = {
        name: "mapKey",
        Name: "MapKey",
        number: 31,
        protoType: 9,
        protoName: "map_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKey;
  }
  get overrideUpdateFrequency() {
    if (!this._overrideUpdateFrequency) {
      this._overrideUpdateFrequency = {
        name: "overrideUpdateFrequency",
        Name: "OverrideUpdateFrequency",
        number: 16,
        protoType: 1,
        protoName: "override_update_frequency",
        type: JsonToDouble,
        options: {
          comments: "Set this to a large value to make the game run faster for testing purpose. There is no upper limit for this value as long as your frame rate can keep up.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._overrideUpdateFrequency;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.resolution,
        this.triggerContext,
        this.saveData,
        this.levelName,
        this.muteMusic,
        this.muteSound,
        this.simulateOnline,
        this.simulateAds,
        this.simulateGems,
        this.simulateUserId,
        this.simulateLeaderBoardTopScore,
        this.simulateLeaderBoardGroup,
        this.simulateTouchInputWithMouseInput,
        this.throwTriggerErrorAsException,
        this.triggerFunctionProfiling,
        this.language,
        this.wildSkyData,
        this.showIphoneXFrame,
        this.useSafeArea,
        this.mapSaveData,
        this.font,
        this.mapKey,
        this.overrideUpdateFrequency,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForResolution",
        Name: "DummyOneofForResolution",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTriggerContext",
        Name: "DummyOneofForTriggerContext",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSaveData",
        Name: "DummyOneofForSaveData",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelName",
        Name: "DummyOneofForLevelName",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMuteMusic",
        Name: "DummyOneofForMuteMusic",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMuteSound",
        Name: "DummyOneofForMuteSound",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSimulateOnline",
        Name: "DummyOneofForSimulateOnline",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSimulateAds",
        Name: "DummyOneofForSimulateAds",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSimulateGems",
        Name: "DummyOneofForSimulateGems",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSimulateUserId",
        Name: "DummyOneofForSimulateUserId",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSimulateLeaderBoardTopScore",
        Name: "DummyOneofForSimulateLeaderBoardTopScore",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSimulateLeaderBoardGroup",
        Name: "DummyOneofForSimulateLeaderBoardGroup",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSimulateTouchInputWithMouseInput",
        Name: "DummyOneofForSimulateTouchInputWithMouseInput",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForThrowTriggerErrorAsException",
        Name: "DummyOneofForThrowTriggerErrorAsException",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTriggerFunctionProfiling",
        Name: "DummyOneofForTriggerFunctionProfiling",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLanguage",
        Name: "DummyOneofForLanguage",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWildSkyData",
        Name: "DummyOneofForWildSkyData",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowIphoneXFrame",
        Name: "DummyOneofForShowIphoneXFrame",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseSafeArea",
        Name: "DummyOneofForUseSafeArea",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFont",
        Name: "DummyOneofForFont",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMapKey",
        Name: "DummyOneofForMapKey",
        fields: [
          this.fields[21],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOverrideUpdateFrequency",
        Name: "DummyOneofForOverrideUpdateFrequency",
        fields: [
          this.fields[22],
        ],
      });
    }
    return this._oneofs;
  }
}
PlaySettings.descriptor = new PlaySettings_Descriptor();
export class TriggerContextSettings {
  get descriptor() {
    return TriggerContextSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasIsDev = false;
    this._isDev = null;
    this._hasAttempted = false;
    this._attempted = null;
    this._hasCompleted = false;
    this._completed = null;
    this._hasDifficulty = false;
    this._difficulty = null;
    this._hasPrefix = false;
    this._prefix = null;
    this._hasDamageMultiplier = false;
    this._damageMultiplier = null;
    this._hasCreepLevel = false;
    this._creepLevel = null;
  }
  isEmpty() {
    if (this._hasIsDev) return false;
    if (this._hasAttempted) return false;
    if (this._hasCompleted) return false;
    if (this._hasDifficulty) return false;
    if (this._hasPrefix) return false;
    if (this._hasDamageMultiplier) return false;
    if (this._hasCreepLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TriggerContextSettings) {
      return value;
    }
    return TriggerContextSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new TriggerContextSettings();
    if (json.isDev != null) {
      result._hasIsDev = true;
      result._isDev = JsonToBoolean.fromJson(json.isDev);
    }
    if (json.attempted != null) {
      result._hasAttempted = true;
      result._attempted = JsonToInt32.fromJson(json.attempted);
    }
    if (json.completed != null) {
      result._hasCompleted = true;
      result._completed = JsonToBoolean.fromJson(json.completed);
    }
    if (json.difficulty != null) {
      result._hasDifficulty = true;
      result._difficulty = JsonToInt32.fromJson(json.difficulty);
    }
    if (json.prefix != null) {
      result._hasPrefix = true;
      result._prefix = JsonToString.fromJson(json.prefix);
    }
    if (json.damageMultiplier != null) {
      result._hasDamageMultiplier = true;
      result._damageMultiplier = JsonToDouble.fromJson(json.damageMultiplier);
    }
    if (json.creepLevel != null) {
      result._hasCreepLevel = true;
      result._creepLevel = JsonToInt32.fromJson(json.creepLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasIsDev) {
      result.isDev = JsonToBoolean.toJson(this._isDev);
    }
    if (this._hasAttempted) {
      result.attempted = JsonToInt32.toJson(this._attempted);
    }
    if (this._hasCompleted) {
      result.completed = JsonToBoolean.toJson(this._completed);
    }
    if (this._hasDifficulty) {
      result.difficulty = JsonToInt32.toJson(this._difficulty);
    }
    if (this._hasPrefix) {
      result.prefix = JsonToString.toJson(this._prefix);
    }
    if (this._hasDamageMultiplier) {
      result.damageMultiplier = JsonToDouble.toJson(this._damageMultiplier);
    }
    if (this._hasCreepLevel) {
      result.creepLevel = JsonToInt32.toJson(this._creepLevel);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get isDev() {
    return this._hasIsDev ? this._isDev : JsonToBoolean.default;
  }
  get hasIsDev() {
    return this._hasIsDev;
  }
  setIsDev(path, value) {
    return {type: 'SET', path: path.concat(['isDev']), value};
  }
  deleteIsDev(path) {
    return {type: 'DELETE', path: path.concat(['isDev'])};
  }
  /**
   * @returns {number}
   */
  get attempted() {
    return this._hasAttempted ? this._attempted : JsonToInt32.default;
  }
  get hasAttempted() {
    return this._hasAttempted;
  }
  setAttempted(path, value) {
    return {type: 'SET', path: path.concat(['attempted']), value};
  }
  deleteAttempted(path) {
    return {type: 'DELETE', path: path.concat(['attempted'])};
  }
  /**
   * @returns {boolean}
   */
  get completed() {
    return this._hasCompleted ? this._completed : JsonToBoolean.default;
  }
  get hasCompleted() {
    return this._hasCompleted;
  }
  setCompleted(path, value) {
    return {type: 'SET', path: path.concat(['completed']), value};
  }
  deleteCompleted(path) {
    return {type: 'DELETE', path: path.concat(['completed'])};
  }
  /**
   * @returns {number}
   */
  get difficulty() {
    return this._hasDifficulty ? this._difficulty : JsonToInt32.default;
  }
  get hasDifficulty() {
    return this._hasDifficulty;
  }
  setDifficulty(path, value) {
    return {type: 'SET', path: path.concat(['difficulty']), value};
  }
  deleteDifficulty(path) {
    return {type: 'DELETE', path: path.concat(['difficulty'])};
  }
  /**
   * @returns {string}
   */
  get prefix() {
    return this._hasPrefix ? this._prefix : JsonToString.default;
  }
  get hasPrefix() {
    return this._hasPrefix;
  }
  setPrefix(path, value) {
    return {type: 'SET', path: path.concat(['prefix']), value};
  }
  deletePrefix(path) {
    return {type: 'DELETE', path: path.concat(['prefix'])};
  }
  /**
   * @returns {number}
   */
  get damageMultiplier() {
    return this._hasDamageMultiplier ? this._damageMultiplier : JsonToDouble.default;
  }
  get hasDamageMultiplier() {
    return this._hasDamageMultiplier;
  }
  setDamageMultiplier(path, value) {
    return {type: 'SET', path: path.concat(['damageMultiplier']), value};
  }
  deleteDamageMultiplier(path) {
    return {type: 'DELETE', path: path.concat(['damageMultiplier'])};
  }
  /**
   * @returns {number}
   */
  get creepLevel() {
    return this._hasCreepLevel ? this._creepLevel : JsonToInt32.default;
  }
  get hasCreepLevel() {
    return this._hasCreepLevel;
  }
  setCreepLevel(path, value) {
    return {type: 'SET', path: path.concat(['creepLevel']), value};
  }
  deleteCreepLevel(path) {
    return {type: 'DELETE', path: path.concat(['creepLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "isDev": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerContextSettings(this);
              copy._hasIsDev = true;
              copy._isDev = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsDev) {
                return this;
              }
              const copy = new TriggerContextSettings(this);
              copy._hasIsDev = false;
              copy._isDev = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "attempted": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerContextSettings(this);
              copy._hasAttempted = true;
              copy._attempted = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAttempted) {
                return this;
              }
              const copy = new TriggerContextSettings(this);
              copy._hasAttempted = false;
              copy._attempted = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "completed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerContextSettings(this);
              copy._hasCompleted = true;
              copy._completed = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCompleted) {
                return this;
              }
              const copy = new TriggerContextSettings(this);
              copy._hasCompleted = false;
              copy._completed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "difficulty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerContextSettings(this);
              copy._hasDifficulty = true;
              copy._difficulty = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDifficulty) {
                return this;
              }
              const copy = new TriggerContextSettings(this);
              copy._hasDifficulty = false;
              copy._difficulty = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "prefix": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerContextSettings(this);
              copy._hasPrefix = true;
              copy._prefix = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrefix) {
                return this;
              }
              const copy = new TriggerContextSettings(this);
              copy._hasPrefix = false;
              copy._prefix = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "damageMultiplier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerContextSettings(this);
              copy._hasDamageMultiplier = true;
              copy._damageMultiplier = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamageMultiplier) {
                return this;
              }
              const copy = new TriggerContextSettings(this);
              copy._hasDamageMultiplier = false;
              copy._damageMultiplier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "creepLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerContextSettings(this);
              copy._hasCreepLevel = true;
              copy._creepLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCreepLevel) {
                return this;
              }
              const copy = new TriggerContextSettings(this);
              copy._hasCreepLevel = false;
              copy._creepLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TriggerContextSettings} other
   * @returns {TriggerContextSettings}
   */
  merge(other) {
    const copy = new TriggerContextSettings(this);
    if (other._hasIsDev) {
      copy._hasIsDev = true;
      copy._isDev = other._isDev;
    }
    if (other._hasAttempted) {
      copy._hasAttempted = true;
      copy._attempted = other._attempted;
    }
    if (other._hasCompleted) {
      copy._hasCompleted = true;
      copy._completed = other._completed;
    }
    if (other._hasDifficulty) {
      copy._hasDifficulty = true;
      copy._difficulty = other._difficulty;
    }
    if (other._hasPrefix) {
      copy._hasPrefix = true;
      copy._prefix = other._prefix;
    }
    if (other._hasDamageMultiplier) {
      copy._hasDamageMultiplier = true;
      copy._damageMultiplier = other._damageMultiplier;
    }
    if (other._hasCreepLevel) {
      copy._hasCreepLevel = true;
      copy._creepLevel = other._creepLevel;
    }
    return copy;
  }
}
TriggerContextSettings.default = new TriggerContextSettings();
class TriggerContextSettings_Builder {
  constructor(value) {
    this._value = new TriggerContextSettings(value);
  }
  build() {
    return new TriggerContextSettings(this._value);
  }
  setIsDev(value) {
    this._value._hasIsDev = true;
    this._value._isDev = value;
    return this;
  }
  deleteIsDev() {
    this._value._hasIsDev = false;
    this._value._isDev = null;
    return this;
  }
  setAttempted(value) {
    this._value._hasAttempted = true;
    this._value._attempted = value;
    return this;
  }
  deleteAttempted() {
    this._value._hasAttempted = false;
    this._value._attempted = null;
    return this;
  }
  setCompleted(value) {
    this._value._hasCompleted = true;
    this._value._completed = value;
    return this;
  }
  deleteCompleted() {
    this._value._hasCompleted = false;
    this._value._completed = null;
    return this;
  }
  setDifficulty(value) {
    this._value._hasDifficulty = true;
    this._value._difficulty = value;
    return this;
  }
  deleteDifficulty() {
    this._value._hasDifficulty = false;
    this._value._difficulty = null;
    return this;
  }
  setPrefix(value) {
    this._value._hasPrefix = true;
    this._value._prefix = value;
    return this;
  }
  deletePrefix() {
    this._value._hasPrefix = false;
    this._value._prefix = null;
    return this;
  }
  setDamageMultiplier(value) {
    this._value._hasDamageMultiplier = true;
    this._value._damageMultiplier = value;
    return this;
  }
  deleteDamageMultiplier() {
    this._value._hasDamageMultiplier = false;
    this._value._damageMultiplier = null;
    return this;
  }
  setCreepLevel(value) {
    this._value._hasCreepLevel = true;
    this._value._creepLevel = value;
    return this;
  }
  deleteCreepLevel() {
    this._value._hasCreepLevel = false;
    this._value._creepLevel = null;
    return this;
  }
}
TriggerContextSettings.Builder = TriggerContextSettings_Builder;
class TriggerContextSettings_WithParent {
  /**
   * @param {TriggerContextSettings} value
   * @param {TriggerContextSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TriggerContextSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasIsDev() {
    if (this._cachedHasIsDev === undefined) {
      if (this._value.hasIsDev) {
        this._cachedHasIsDev = true;
      } else {
        this._cachedHasIsDev = this._parent ? this._parent.hasIsDev : false;
      }
    }
    return this._cachedHasIsDev;
  }
  get isDev() {
    if (this._cachedIsDev === undefined) {
      if (this._value.hasIsDev) {
        this._cachedIsDev = this._value.isDev;
      } else {
        this._cachedIsDev = this._parent ? this._parent.isDev : this._value.isDev;
      }
    }
    return this._cachedIsDev;
  }
  get hasAttempted() {
    if (this._cachedHasAttempted === undefined) {
      if (this._value.hasAttempted) {
        this._cachedHasAttempted = true;
      } else {
        this._cachedHasAttempted = this._parent ? this._parent.hasAttempted : false;
      }
    }
    return this._cachedHasAttempted;
  }
  get attempted() {
    if (this._cachedAttempted === undefined) {
      if (this._value.hasAttempted) {
        this._cachedAttempted = this._value.attempted;
      } else {
        this._cachedAttempted = this._parent ? this._parent.attempted : this._value.attempted;
      }
    }
    return this._cachedAttempted;
  }
  get hasCompleted() {
    if (this._cachedHasCompleted === undefined) {
      if (this._value.hasCompleted) {
        this._cachedHasCompleted = true;
      } else {
        this._cachedHasCompleted = this._parent ? this._parent.hasCompleted : false;
      }
    }
    return this._cachedHasCompleted;
  }
  get completed() {
    if (this._cachedCompleted === undefined) {
      if (this._value.hasCompleted) {
        this._cachedCompleted = this._value.completed;
      } else {
        this._cachedCompleted = this._parent ? this._parent.completed : this._value.completed;
      }
    }
    return this._cachedCompleted;
  }
  get hasDifficulty() {
    if (this._cachedHasDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedHasDifficulty = true;
      } else {
        this._cachedHasDifficulty = this._parent ? this._parent.hasDifficulty : false;
      }
    }
    return this._cachedHasDifficulty;
  }
  get difficulty() {
    if (this._cachedDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedDifficulty = this._value.difficulty;
      } else {
        this._cachedDifficulty = this._parent ? this._parent.difficulty : this._value.difficulty;
      }
    }
    return this._cachedDifficulty;
  }
  get hasPrefix() {
    if (this._cachedHasPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedHasPrefix = true;
      } else {
        this._cachedHasPrefix = this._parent ? this._parent.hasPrefix : false;
      }
    }
    return this._cachedHasPrefix;
  }
  get prefix() {
    if (this._cachedPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedPrefix = this._value.prefix;
      } else {
        this._cachedPrefix = this._parent ? this._parent.prefix : this._value.prefix;
      }
    }
    return this._cachedPrefix;
  }
  get hasDamageMultiplier() {
    if (this._cachedHasDamageMultiplier === undefined) {
      if (this._value.hasDamageMultiplier) {
        this._cachedHasDamageMultiplier = true;
      } else {
        this._cachedHasDamageMultiplier = this._parent ? this._parent.hasDamageMultiplier : false;
      }
    }
    return this._cachedHasDamageMultiplier;
  }
  get damageMultiplier() {
    if (this._cachedDamageMultiplier === undefined) {
      if (this._value.hasDamageMultiplier) {
        this._cachedDamageMultiplier = this._value.damageMultiplier;
      } else {
        this._cachedDamageMultiplier = this._parent ? this._parent.damageMultiplier : this._value.damageMultiplier;
      }
    }
    return this._cachedDamageMultiplier;
  }
  get hasCreepLevel() {
    if (this._cachedHasCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedHasCreepLevel = true;
      } else {
        this._cachedHasCreepLevel = this._parent ? this._parent.hasCreepLevel : false;
      }
    }
    return this._cachedHasCreepLevel;
  }
  get creepLevel() {
    if (this._cachedCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedCreepLevel = this._value.creepLevel;
      } else {
        this._cachedCreepLevel = this._parent ? this._parent.creepLevel : this._value.creepLevel;
      }
    }
    return this._cachedCreepLevel;
  }
  update(current, parent) {
    const result = new TriggerContextSettings_WithParent(current, parent);
    return result;
  }
}
TriggerContextSettings_WithParent.default = new TriggerContextSettings_WithParent(TriggerContextSettings.default, null);
TriggerContextSettings.WithParent = TriggerContextSettings_WithParent;
class TriggerContextSettings_Descriptor {
  get isDev() {
    if (!this._isDev) {
      this._isDev = {
        name: "isDev",
        Name: "IsDev",
        number: 1,
        protoType: 8,
        protoName: "is_dev",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isDev;
  }
  get attempted() {
    if (!this._attempted) {
      this._attempted = {
        name: "attempted",
        Name: "Attempted",
        number: 2,
        protoType: 5,
        protoName: "attempted",
        type: JsonToInt32,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._attempted;
  }
  get completed() {
    if (!this._completed) {
      this._completed = {
        name: "completed",
        Name: "Completed",
        number: 3,
        protoType: 8,
        protoName: "completed",
        type: JsonToBoolean,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._completed;
  }
  get difficulty() {
    if (!this._difficulty) {
      this._difficulty = {
        name: "difficulty",
        Name: "Difficulty",
        number: 4,
        protoType: 5,
        protoName: "difficulty",
        type: JsonToInt32,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficulty;
  }
  get prefix() {
    if (!this._prefix) {
      this._prefix = {
        name: "prefix",
        Name: "Prefix",
        number: 5,
        protoType: 9,
        protoName: "prefix",
        type: JsonToString,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefix;
  }
  get damageMultiplier() {
    if (!this._damageMultiplier) {
      this._damageMultiplier = {
        name: "damageMultiplier",
        Name: "DamageMultiplier",
        number: 6,
        protoType: 1,
        protoName: "damage_multiplier",
        type: JsonToDouble,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damageMultiplier;
  }
  get creepLevel() {
    if (!this._creepLevel) {
      this._creepLevel = {
        name: "creepLevel",
        Name: "CreepLevel",
        number: 7,
        protoType: 5,
        protoName: "creep_level",
        type: JsonToInt32,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._creepLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.isDev,
        this.attempted,
        this.completed,
        this.difficulty,
        this.prefix,
        this.damageMultiplier,
        this.creepLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForIsDev",
        Name: "DummyOneofForIsDev",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAttempted",
        Name: "DummyOneofForAttempted",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCompleted",
        Name: "DummyOneofForCompleted",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDifficulty",
        Name: "DummyOneofForDifficulty",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrefix",
        Name: "DummyOneofForPrefix",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDamageMultiplier",
        Name: "DummyOneofForDamageMultiplier",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCreepLevel",
        Name: "DummyOneofForCreepLevel",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
TriggerContextSettings.descriptor = new TriggerContextSettings_Descriptor();
export class ResolutionSettings {
  get descriptor() {
    return ResolutionSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWidth = false;
    this._width = null;
    this._hasHeight = false;
    this._height = null;
    this._hasScale = false;
    this._scale = null;
  }
  isEmpty() {
    if (this._hasWidth) return false;
    if (this._hasHeight) return false;
    if (this._hasScale) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ResolutionSettings) {
      return value;
    }
    return ResolutionSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new ResolutionSettings();
    if (json.width != null) {
      result._hasWidth = true;
      result._width = JsonToInt32.fromJson(json.width);
    }
    if (json.height != null) {
      result._hasHeight = true;
      result._height = JsonToInt32.fromJson(json.height);
    }
    if (json.scale != null) {
      result._hasScale = true;
      result._scale = JsonToDouble.fromJson(json.scale);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWidth) {
      result.width = JsonToInt32.toJson(this._width);
    }
    if (this._hasHeight) {
      result.height = JsonToInt32.toJson(this._height);
    }
    if (this._hasScale) {
      result.scale = JsonToDouble.toJson(this._scale);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get width() {
    return this._hasWidth ? this._width : JsonToInt32.default;
  }
  get hasWidth() {
    return this._hasWidth;
  }
  setWidth(path, value) {
    return {type: 'SET', path: path.concat(['width']), value};
  }
  deleteWidth(path) {
    return {type: 'DELETE', path: path.concat(['width'])};
  }
  /**
   * @returns {number}
   */
  get height() {
    return this._hasHeight ? this._height : JsonToInt32.default;
  }
  get hasHeight() {
    return this._hasHeight;
  }
  setHeight(path, value) {
    return {type: 'SET', path: path.concat(['height']), value};
  }
  deleteHeight(path) {
    return {type: 'DELETE', path: path.concat(['height'])};
  }
  /**
   * @returns {number}
   */
  get scale() {
    return this._hasScale ? this._scale : JsonToDouble.default;
  }
  get hasScale() {
    return this._hasScale;
  }
  setScale(path, value) {
    return {type: 'SET', path: path.concat(['scale']), value};
  }
  deleteScale(path) {
    return {type: 'DELETE', path: path.concat(['scale'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "width": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ResolutionSettings(this);
              copy._hasWidth = true;
              copy._width = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWidth) {
                return this;
              }
              const copy = new ResolutionSettings(this);
              copy._hasWidth = false;
              copy._width = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "height": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ResolutionSettings(this);
              copy._hasHeight = true;
              copy._height = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHeight) {
                return this;
              }
              const copy = new ResolutionSettings(this);
              copy._hasHeight = false;
              copy._height = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "scale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ResolutionSettings(this);
              copy._hasScale = true;
              copy._scale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScale) {
                return this;
              }
              const copy = new ResolutionSettings(this);
              copy._hasScale = false;
              copy._scale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ResolutionSettings} other
   * @returns {ResolutionSettings}
   */
  merge(other) {
    const copy = new ResolutionSettings(this);
    if (other._hasWidth) {
      copy._hasWidth = true;
      copy._width = other._width;
    }
    if (other._hasHeight) {
      copy._hasHeight = true;
      copy._height = other._height;
    }
    if (other._hasScale) {
      copy._hasScale = true;
      copy._scale = other._scale;
    }
    return copy;
  }
}
ResolutionSettings.default = new ResolutionSettings();
class ResolutionSettings_Builder {
  constructor(value) {
    this._value = new ResolutionSettings(value);
  }
  build() {
    return new ResolutionSettings(this._value);
  }
  setWidth(value) {
    this._value._hasWidth = true;
    this._value._width = value;
    return this;
  }
  deleteWidth() {
    this._value._hasWidth = false;
    this._value._width = null;
    return this;
  }
  setHeight(value) {
    this._value._hasHeight = true;
    this._value._height = value;
    return this;
  }
  deleteHeight() {
    this._value._hasHeight = false;
    this._value._height = null;
    return this;
  }
  setScale(value) {
    this._value._hasScale = true;
    this._value._scale = value;
    return this;
  }
  deleteScale() {
    this._value._hasScale = false;
    this._value._scale = null;
    return this;
  }
}
ResolutionSettings.Builder = ResolutionSettings_Builder;
class ResolutionSettings_WithParent {
  /**
   * @param {ResolutionSettings} value
   * @param {ResolutionSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ResolutionSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWidth() {
    if (this._cachedHasWidth === undefined) {
      if (this._value.hasWidth) {
        this._cachedHasWidth = true;
      } else {
        this._cachedHasWidth = this._parent ? this._parent.hasWidth : false;
      }
    }
    return this._cachedHasWidth;
  }
  get width() {
    if (this._cachedWidth === undefined) {
      if (this._value.hasWidth) {
        this._cachedWidth = this._value.width;
      } else {
        this._cachedWidth = this._parent ? this._parent.width : this._value.width;
      }
    }
    return this._cachedWidth;
  }
  get hasHeight() {
    if (this._cachedHasHeight === undefined) {
      if (this._value.hasHeight) {
        this._cachedHasHeight = true;
      } else {
        this._cachedHasHeight = this._parent ? this._parent.hasHeight : false;
      }
    }
    return this._cachedHasHeight;
  }
  get height() {
    if (this._cachedHeight === undefined) {
      if (this._value.hasHeight) {
        this._cachedHeight = this._value.height;
      } else {
        this._cachedHeight = this._parent ? this._parent.height : this._value.height;
      }
    }
    return this._cachedHeight;
  }
  get hasScale() {
    if (this._cachedHasScale === undefined) {
      if (this._value.hasScale) {
        this._cachedHasScale = true;
      } else {
        this._cachedHasScale = this._parent ? this._parent.hasScale : false;
      }
    }
    return this._cachedHasScale;
  }
  get scale() {
    if (this._cachedScale === undefined) {
      if (this._value.hasScale) {
        this._cachedScale = this._value.scale;
      } else {
        this._cachedScale = this._parent ? this._parent.scale : this._value.scale;
      }
    }
    return this._cachedScale;
  }
  update(current, parent) {
    const result = new ResolutionSettings_WithParent(current, parent);
    return result;
  }
}
ResolutionSettings_WithParent.default = new ResolutionSettings_WithParent(ResolutionSettings.default, null);
ResolutionSettings.WithParent = ResolutionSettings_WithParent;
class ResolutionSettings_Descriptor {
  get width() {
    if (!this._width) {
      this._width = {
        name: "width",
        Name: "Width",
        number: 1,
        protoType: 5,
        protoName: "width",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._width;
  }
  get height() {
    if (!this._height) {
      this._height = {
        name: "height",
        Name: "Height",
        number: 2,
        protoType: 5,
        protoName: "height",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._height;
  }
  get scale() {
    if (!this._scale) {
      this._scale = {
        name: "scale",
        Name: "Scale",
        number: 3,
        protoType: 1,
        protoName: "scale",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scale;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.width,
        this.height,
        this.scale,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWidth",
        Name: "DummyOneofForWidth",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHeight",
        Name: "DummyOneofForHeight",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScale",
        Name: "DummyOneofForScale",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ResolutionSettings.descriptor = new ResolutionSettings_Descriptor();
export class ToolSettings {
  get descriptor() {
    return ToolSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasVscodePath = false;
    this._vscodePath = null;
  }
  isEmpty() {
    if (this._hasVscodePath) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ToolSettings) {
      return value;
    }
    return ToolSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new ToolSettings();
    if (json.vscodePath != null) {
      result._hasVscodePath = true;
      result._vscodePath = JsonToString.fromJson(json.vscodePath);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasVscodePath) {
      result.vscodePath = JsonToString.toJson(this._vscodePath);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get vscodePath() {
    return this._hasVscodePath ? this._vscodePath : JsonToString.default;
  }
  get hasVscodePath() {
    return this._hasVscodePath;
  }
  setVscodePath(path, value) {
    return {type: 'SET', path: path.concat(['vscodePath']), value};
  }
  deleteVscodePath(path) {
    return {type: 'DELETE', path: path.concat(['vscodePath'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "vscodePath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ToolSettings(this);
              copy._hasVscodePath = true;
              copy._vscodePath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVscodePath) {
                return this;
              }
              const copy = new ToolSettings(this);
              copy._hasVscodePath = false;
              copy._vscodePath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ToolSettings} other
   * @returns {ToolSettings}
   */
  merge(other) {
    const copy = new ToolSettings(this);
    if (other._hasVscodePath) {
      copy._hasVscodePath = true;
      copy._vscodePath = other._vscodePath;
    }
    return copy;
  }
}
ToolSettings.default = new ToolSettings();
class ToolSettings_Builder {
  constructor(value) {
    this._value = new ToolSettings(value);
  }
  build() {
    return new ToolSettings(this._value);
  }
  setVscodePath(value) {
    this._value._hasVscodePath = true;
    this._value._vscodePath = value;
    return this;
  }
  deleteVscodePath() {
    this._value._hasVscodePath = false;
    this._value._vscodePath = null;
    return this;
  }
}
ToolSettings.Builder = ToolSettings_Builder;
class ToolSettings_WithParent {
  /**
   * @param {ToolSettings} value
   * @param {ToolSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ToolSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasVscodePath() {
    if (this._cachedHasVscodePath === undefined) {
      if (this._value.hasVscodePath) {
        this._cachedHasVscodePath = true;
      } else {
        this._cachedHasVscodePath = this._parent ? this._parent.hasVscodePath : false;
      }
    }
    return this._cachedHasVscodePath;
  }
  get vscodePath() {
    if (this._cachedVscodePath === undefined) {
      if (this._value.hasVscodePath) {
        this._cachedVscodePath = this._value.vscodePath;
      } else {
        this._cachedVscodePath = this._parent ? this._parent.vscodePath : this._value.vscodePath;
      }
    }
    return this._cachedVscodePath;
  }
  update(current, parent) {
    const result = new ToolSettings_WithParent(current, parent);
    return result;
  }
}
ToolSettings_WithParent.default = new ToolSettings_WithParent(ToolSettings.default, null);
ToolSettings.WithParent = ToolSettings_WithParent;
class ToolSettings_Descriptor {
  get vscodePath() {
    if (!this._vscodePath) {
      this._vscodePath = {
        name: "vscodePath",
        Name: "VscodePath",
        number: 1,
        protoType: 9,
        protoName: "vscode_path",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._vscodePath;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.vscodePath,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForVscodePath",
        Name: "DummyOneofForVscodePath",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ToolSettings.descriptor = new ToolSettings_Descriptor();
export class ViewSettings {
  get descriptor() {
    return ViewSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEnableWildsky = false;
    this._enableWildsky = null;
  }
  isEmpty() {
    if (this._hasEnableWildsky) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ViewSettings) {
      return value;
    }
    return ViewSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new ViewSettings();
    if (json.enableWildsky != null) {
      result._hasEnableWildsky = true;
      result._enableWildsky = JsonToBoolean.fromJson(json.enableWildsky);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEnableWildsky) {
      result.enableWildsky = JsonToBoolean.toJson(this._enableWildsky);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get enableWildsky() {
    return this._hasEnableWildsky ? this._enableWildsky : JsonToBoolean.default;
  }
  get hasEnableWildsky() {
    return this._hasEnableWildsky;
  }
  setEnableWildsky(path, value) {
    return {type: 'SET', path: path.concat(['enableWildsky']), value};
  }
  deleteEnableWildsky(path) {
    return {type: 'DELETE', path: path.concat(['enableWildsky'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "enableWildsky": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ViewSettings(this);
              copy._hasEnableWildsky = true;
              copy._enableWildsky = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnableWildsky) {
                return this;
              }
              const copy = new ViewSettings(this);
              copy._hasEnableWildsky = false;
              copy._enableWildsky = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ViewSettings} other
   * @returns {ViewSettings}
   */
  merge(other) {
    const copy = new ViewSettings(this);
    if (other._hasEnableWildsky) {
      copy._hasEnableWildsky = true;
      copy._enableWildsky = other._enableWildsky;
    }
    return copy;
  }
}
ViewSettings.default = new ViewSettings();
class ViewSettings_Builder {
  constructor(value) {
    this._value = new ViewSettings(value);
  }
  build() {
    return new ViewSettings(this._value);
  }
  setEnableWildsky(value) {
    this._value._hasEnableWildsky = true;
    this._value._enableWildsky = value;
    return this;
  }
  deleteEnableWildsky() {
    this._value._hasEnableWildsky = false;
    this._value._enableWildsky = null;
    return this;
  }
}
ViewSettings.Builder = ViewSettings_Builder;
class ViewSettings_WithParent {
  /**
   * @param {ViewSettings} value
   * @param {ViewSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ViewSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEnableWildsky() {
    if (this._cachedHasEnableWildsky === undefined) {
      if (this._value.hasEnableWildsky) {
        this._cachedHasEnableWildsky = true;
      } else {
        this._cachedHasEnableWildsky = this._parent ? this._parent.hasEnableWildsky : false;
      }
    }
    return this._cachedHasEnableWildsky;
  }
  get enableWildsky() {
    if (this._cachedEnableWildsky === undefined) {
      if (this._value.hasEnableWildsky) {
        this._cachedEnableWildsky = this._value.enableWildsky;
      } else {
        this._cachedEnableWildsky = this._parent ? this._parent.enableWildsky : this._value.enableWildsky;
      }
    }
    return this._cachedEnableWildsky;
  }
  update(current, parent) {
    const result = new ViewSettings_WithParent(current, parent);
    return result;
  }
}
ViewSettings_WithParent.default = new ViewSettings_WithParent(ViewSettings.default, null);
ViewSettings.WithParent = ViewSettings_WithParent;
class ViewSettings_Descriptor {
  get enableWildsky() {
    if (!this._enableWildsky) {
      this._enableWildsky = {
        name: "enableWildsky",
        Name: "EnableWildsky",
        number: 1,
        protoType: 8,
        protoName: "enable_wildsky",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enableWildsky;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.enableWildsky,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEnableWildsky",
        Name: "DummyOneofForEnableWildsky",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ViewSettings.descriptor = new ViewSettings_Descriptor();
export class ProjectSettings {
  get descriptor() {
    return ProjectSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasProjectInfo = false;
    this._projectInfo = null;
    this._hasPlayer = false;
    this._player = null;
    this._hasDisplay = false;
    this._display = null;
    this._hasInput = false;
    this._input = null;
    this._hasFont = false;
    this._font = null;
    this._hasBuild = false;
    this._build = null;
  }
  isEmpty() {
    if (this._hasProjectInfo && !this._projectInfo.isEmpty()) return false;
    if (this._hasPlayer && !this._player.isEmpty()) return false;
    if (this._hasDisplay && !this._display.isEmpty()) return false;
    if (this._hasInput && !this._input.isEmpty()) return false;
    if (this._hasFont && !this._font.isEmpty()) return false;
    if (this._hasBuild && !this._build.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ProjectSettings) {
      return value;
    }
    return ProjectSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new ProjectSettings();
    if (json.projectInfo != null) {
      result._hasProjectInfo = true;
      result._projectInfo = ProjectInfo.fromJson(json.projectInfo);
    }
    if (json.player != null) {
      result._hasPlayer = true;
      result._player = dcei_engine_data_proto.PlayerSettings.fromJson(json.player);
    }
    if (json.display != null) {
      result._hasDisplay = true;
      result._display = dcei_engine_data_proto.DisplaySettings.fromJson(json.display);
    }
    if (json.input != null) {
      result._hasInput = true;
      result._input = dcei_engine_data_proto.InputSettings.fromJson(json.input);
    }
    if (json.font != null) {
      result._hasFont = true;
      result._font = dcei_engine_data_proto.FontSettings.fromJson(json.font);
    }
    if (json.build != null) {
      result._hasBuild = true;
      result._build = dcei_engine_data_proto.CustomAssetSettings.fromJson(json.build);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasProjectInfo && !this._projectInfo.isEmpty()) {
      result.projectInfo = ProjectInfo.toJson(this._projectInfo);
    }
    if (this._hasPlayer && !this._player.isEmpty()) {
      result.player = dcei_engine_data_proto.PlayerSettings.toJson(this._player);
    }
    if (this._hasDisplay && !this._display.isEmpty()) {
      result.display = dcei_engine_data_proto.DisplaySettings.toJson(this._display);
    }
    if (this._hasInput && !this._input.isEmpty()) {
      result.input = dcei_engine_data_proto.InputSettings.toJson(this._input);
    }
    if (this._hasFont && !this._font.isEmpty()) {
      result.font = dcei_engine_data_proto.FontSettings.toJson(this._font);
    }
    if (this._hasBuild && !this._build.isEmpty()) {
      result.build = dcei_engine_data_proto.CustomAssetSettings.toJson(this._build);
    }
    return result;
  }
  /**
   * @returns {ProjectInfo}
   */
  get projectInfo() {
    return this._hasProjectInfo ? this._projectInfo : ProjectInfo.default;
  }
  get hasProjectInfo() {
    return this._hasProjectInfo;
  }
  setProjectInfo(path, value) {
    return {type: 'SET', path: path.concat(['projectInfo']), value: value.toJson()};
  }
  deleteProjectInfo(path) {
    return {type: 'DELETE', path: path.concat(['projectInfo'])};
  }
  /**
   * @returns {dcei_engine_data_proto.PlayerSettings}
   */
  get player() {
    return this._hasPlayer ? this._player : dcei_engine_data_proto.PlayerSettings.default;
  }
  get hasPlayer() {
    return this._hasPlayer;
  }
  setPlayer(path, value) {
    return {type: 'SET', path: path.concat(['player']), value: value.toJson()};
  }
  deletePlayer(path) {
    return {type: 'DELETE', path: path.concat(['player'])};
  }
  /**
   * @returns {dcei_engine_data_proto.DisplaySettings}
   */
  get display() {
    return this._hasDisplay ? this._display : dcei_engine_data_proto.DisplaySettings.default;
  }
  get hasDisplay() {
    return this._hasDisplay;
  }
  setDisplay(path, value) {
    return {type: 'SET', path: path.concat(['display']), value: value.toJson()};
  }
  deleteDisplay(path) {
    return {type: 'DELETE', path: path.concat(['display'])};
  }
  /**
   * @returns {dcei_engine_data_proto.InputSettings}
   */
  get input() {
    return this._hasInput ? this._input : dcei_engine_data_proto.InputSettings.default;
  }
  get hasInput() {
    return this._hasInput;
  }
  setInput(path, value) {
    return {type: 'SET', path: path.concat(['input']), value: value.toJson()};
  }
  deleteInput(path) {
    return {type: 'DELETE', path: path.concat(['input'])};
  }
  /**
   * @returns {dcei_engine_data_proto.FontSettings}
   */
  get font() {
    return this._hasFont ? this._font : dcei_engine_data_proto.FontSettings.default;
  }
  get hasFont() {
    return this._hasFont;
  }
  setFont(path, value) {
    return {type: 'SET', path: path.concat(['font']), value: value.toJson()};
  }
  deleteFont(path) {
    return {type: 'DELETE', path: path.concat(['font'])};
  }
  /**
   * @returns {dcei_engine_data_proto.CustomAssetSettings}
   */
  get build() {
    return this._hasBuild ? this._build : dcei_engine_data_proto.CustomAssetSettings.default;
  }
  get hasBuild() {
    return this._hasBuild;
  }
  setBuild(path, value) {
    return {type: 'SET', path: path.concat(['build']), value: value.toJson()};
  }
  deleteBuild(path) {
    return {type: 'DELETE', path: path.concat(['build'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "projectInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectSettings(this);
              copy._hasProjectInfo = true;
              copy._projectInfo = ProjectInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProjectInfo) {
                return this;
              }
              const copy = new ProjectSettings(this);
              copy._hasProjectInfo = false;
              copy._projectInfo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasProjectInfo) {
            const copy = new ProjectSettings(this);
            copy._hasProjectInfo = true;
            copy._projectInfo = ProjectInfo.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._projectInfo.apply(type, path.slice(1), value);
          if (newValue === this._projectInfo) {
            return this;
          }
          const copy = new ProjectSettings(this);
          copy._projectInfo = copy._projectInfo.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "player": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectSettings(this);
              copy._hasPlayer = true;
              copy._player = dcei_engine_data_proto.PlayerSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayer) {
                return this;
              }
              const copy = new ProjectSettings(this);
              copy._hasPlayer = false;
              copy._player = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayer) {
            const copy = new ProjectSettings(this);
            copy._hasPlayer = true;
            copy._player = dcei_engine_data_proto.PlayerSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._player.apply(type, path.slice(1), value);
          if (newValue === this._player) {
            return this;
          }
          const copy = new ProjectSettings(this);
          copy._player = copy._player.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "display": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectSettings(this);
              copy._hasDisplay = true;
              copy._display = dcei_engine_data_proto.DisplaySettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplay) {
                return this;
              }
              const copy = new ProjectSettings(this);
              copy._hasDisplay = false;
              copy._display = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDisplay) {
            const copy = new ProjectSettings(this);
            copy._hasDisplay = true;
            copy._display = dcei_engine_data_proto.DisplaySettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._display.apply(type, path.slice(1), value);
          if (newValue === this._display) {
            return this;
          }
          const copy = new ProjectSettings(this);
          copy._display = copy._display.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "input": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectSettings(this);
              copy._hasInput = true;
              copy._input = dcei_engine_data_proto.InputSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInput) {
                return this;
              }
              const copy = new ProjectSettings(this);
              copy._hasInput = false;
              copy._input = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasInput) {
            const copy = new ProjectSettings(this);
            copy._hasInput = true;
            copy._input = dcei_engine_data_proto.InputSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._input.apply(type, path.slice(1), value);
          if (newValue === this._input) {
            return this;
          }
          const copy = new ProjectSettings(this);
          copy._input = copy._input.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "font": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectSettings(this);
              copy._hasFont = true;
              copy._font = dcei_engine_data_proto.FontSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFont) {
                return this;
              }
              const copy = new ProjectSettings(this);
              copy._hasFont = false;
              copy._font = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFont) {
            const copy = new ProjectSettings(this);
            copy._hasFont = true;
            copy._font = dcei_engine_data_proto.FontSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._font.apply(type, path.slice(1), value);
          if (newValue === this._font) {
            return this;
          }
          const copy = new ProjectSettings(this);
          copy._font = copy._font.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "build": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectSettings(this);
              copy._hasBuild = true;
              copy._build = dcei_engine_data_proto.CustomAssetSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBuild) {
                return this;
              }
              const copy = new ProjectSettings(this);
              copy._hasBuild = false;
              copy._build = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBuild) {
            const copy = new ProjectSettings(this);
            copy._hasBuild = true;
            copy._build = dcei_engine_data_proto.CustomAssetSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._build.apply(type, path.slice(1), value);
          if (newValue === this._build) {
            return this;
          }
          const copy = new ProjectSettings(this);
          copy._build = copy._build.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ProjectSettings} other
   * @returns {ProjectSettings}
   */
  merge(other) {
    const copy = new ProjectSettings(this);
    if (other._hasProjectInfo) {
      if (copy._hasProjectInfo) {
        copy._projectInfo = copy.projectInfo.merge(other.projectInfo);
      } else {
        copy._projectInfo = other._projectInfo;
      }
      copy._hasProjectInfo = true;
    }
    if (other._hasPlayer) {
      if (copy._hasPlayer) {
        copy._player = copy.player.merge(other.player);
      } else {
        copy._player = other._player;
      }
      copy._hasPlayer = true;
    }
    if (other._hasDisplay) {
      if (copy._hasDisplay) {
        copy._display = copy.display.merge(other.display);
      } else {
        copy._display = other._display;
      }
      copy._hasDisplay = true;
    }
    if (other._hasInput) {
      if (copy._hasInput) {
        copy._input = copy.input.merge(other.input);
      } else {
        copy._input = other._input;
      }
      copy._hasInput = true;
    }
    if (other._hasFont) {
      if (copy._hasFont) {
        copy._font = copy.font.merge(other.font);
      } else {
        copy._font = other._font;
      }
      copy._hasFont = true;
    }
    if (other._hasBuild) {
      if (copy._hasBuild) {
        copy._build = copy.build.merge(other.build);
      } else {
        copy._build = other._build;
      }
      copy._hasBuild = true;
    }
    return copy;
  }
}
ProjectSettings.default = new ProjectSettings();
class ProjectSettings_Builder {
  constructor(value) {
    this._value = new ProjectSettings(value);
  }
  build() {
    return new ProjectSettings(this._value);
  }
  setProjectInfo(value) {
    this._value._hasProjectInfo = true;
    this._value._projectInfo = value;
    return this;
  }
  deleteProjectInfo() {
    this._value._hasProjectInfo = false;
    this._value._projectInfo = null;
    return this;
  }
  setPlayer(value) {
    this._value._hasPlayer = true;
    this._value._player = value;
    return this;
  }
  deletePlayer() {
    this._value._hasPlayer = false;
    this._value._player = null;
    return this;
  }
  setDisplay(value) {
    this._value._hasDisplay = true;
    this._value._display = value;
    return this;
  }
  deleteDisplay() {
    this._value._hasDisplay = false;
    this._value._display = null;
    return this;
  }
  setInput(value) {
    this._value._hasInput = true;
    this._value._input = value;
    return this;
  }
  deleteInput() {
    this._value._hasInput = false;
    this._value._input = null;
    return this;
  }
  setFont(value) {
    this._value._hasFont = true;
    this._value._font = value;
    return this;
  }
  deleteFont() {
    this._value._hasFont = false;
    this._value._font = null;
    return this;
  }
  setBuild(value) {
    this._value._hasBuild = true;
    this._value._build = value;
    return this;
  }
  deleteBuild() {
    this._value._hasBuild = false;
    this._value._build = null;
    return this;
  }
}
ProjectSettings.Builder = ProjectSettings_Builder;
class ProjectSettings_WithParent {
  /**
   * @param {ProjectSettings} value
   * @param {ProjectSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ProjectSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasProjectInfo() {
    if (this._cachedHasProjectInfo === undefined) {
      if (this._value.hasProjectInfo) {
        this._cachedHasProjectInfo = true;
      } else {
        this._cachedHasProjectInfo = this._parent ? this._parent.hasProjectInfo : false;
      }
    }
    return this._cachedHasProjectInfo;
  }
  get projectInfo() {
    if (!this._cachedProjectInfo) {
      if (this._value.hasProjectInfo) {
        this._cachedProjectInfo = new ProjectInfo.WithParent(this._value.projectInfo, this._parent && this._parent.hasProjectInfo ? this._parent.projectInfo : null);
      } else {
        this._cachedProjectInfo = this._parent ? new ProjectInfo.WithParent(ProjectInfo.default, this._parent.projectInfo) : ProjectInfo.WithParent.default;
      }
    }
    return this._cachedProjectInfo;
  }
  get hasPlayer() {
    if (this._cachedHasPlayer === undefined) {
      if (this._value.hasPlayer) {
        this._cachedHasPlayer = true;
      } else {
        this._cachedHasPlayer = this._parent ? this._parent.hasPlayer : false;
      }
    }
    return this._cachedHasPlayer;
  }
  get player() {
    if (!this._cachedPlayer) {
      if (this._value.hasPlayer) {
        this._cachedPlayer = new dcei_engine_data_proto.PlayerSettings.WithParent(this._value.player, this._parent && this._parent.hasPlayer ? this._parent.player : null);
      } else {
        this._cachedPlayer = this._parent ? new dcei_engine_data_proto.PlayerSettings.WithParent(dcei_engine_data_proto.PlayerSettings.default, this._parent.player) : dcei_engine_data_proto.PlayerSettings.WithParent.default;
      }
    }
    return this._cachedPlayer;
  }
  get hasDisplay() {
    if (this._cachedHasDisplay === undefined) {
      if (this._value.hasDisplay) {
        this._cachedHasDisplay = true;
      } else {
        this._cachedHasDisplay = this._parent ? this._parent.hasDisplay : false;
      }
    }
    return this._cachedHasDisplay;
  }
  get display() {
    if (!this._cachedDisplay) {
      if (this._value.hasDisplay) {
        this._cachedDisplay = new dcei_engine_data_proto.DisplaySettings.WithParent(this._value.display, this._parent && this._parent.hasDisplay ? this._parent.display : null);
      } else {
        this._cachedDisplay = this._parent ? new dcei_engine_data_proto.DisplaySettings.WithParent(dcei_engine_data_proto.DisplaySettings.default, this._parent.display) : dcei_engine_data_proto.DisplaySettings.WithParent.default;
      }
    }
    return this._cachedDisplay;
  }
  get hasInput() {
    if (this._cachedHasInput === undefined) {
      if (this._value.hasInput) {
        this._cachedHasInput = true;
      } else {
        this._cachedHasInput = this._parent ? this._parent.hasInput : false;
      }
    }
    return this._cachedHasInput;
  }
  get input() {
    if (!this._cachedInput) {
      if (this._value.hasInput) {
        this._cachedInput = new dcei_engine_data_proto.InputSettings.WithParent(this._value.input, this._parent && this._parent.hasInput ? this._parent.input : null);
      } else {
        this._cachedInput = this._parent ? new dcei_engine_data_proto.InputSettings.WithParent(dcei_engine_data_proto.InputSettings.default, this._parent.input) : dcei_engine_data_proto.InputSettings.WithParent.default;
      }
    }
    return this._cachedInput;
  }
  get hasFont() {
    if (this._cachedHasFont === undefined) {
      if (this._value.hasFont) {
        this._cachedHasFont = true;
      } else {
        this._cachedHasFont = this._parent ? this._parent.hasFont : false;
      }
    }
    return this._cachedHasFont;
  }
  get font() {
    if (!this._cachedFont) {
      if (this._value.hasFont) {
        this._cachedFont = new dcei_engine_data_proto.FontSettings.WithParent(this._value.font, this._parent && this._parent.hasFont ? this._parent.font : null);
      } else {
        this._cachedFont = this._parent ? new dcei_engine_data_proto.FontSettings.WithParent(dcei_engine_data_proto.FontSettings.default, this._parent.font) : dcei_engine_data_proto.FontSettings.WithParent.default;
      }
    }
    return this._cachedFont;
  }
  get hasBuild() {
    if (this._cachedHasBuild === undefined) {
      if (this._value.hasBuild) {
        this._cachedHasBuild = true;
      } else {
        this._cachedHasBuild = this._parent ? this._parent.hasBuild : false;
      }
    }
    return this._cachedHasBuild;
  }
  get build() {
    if (!this._cachedBuild) {
      if (this._value.hasBuild) {
        this._cachedBuild = new dcei_engine_data_proto.CustomAssetSettings.WithParent(this._value.build, this._parent && this._parent.hasBuild ? this._parent.build : null);
      } else {
        this._cachedBuild = this._parent ? new dcei_engine_data_proto.CustomAssetSettings.WithParent(dcei_engine_data_proto.CustomAssetSettings.default, this._parent.build) : dcei_engine_data_proto.CustomAssetSettings.WithParent.default;
      }
    }
    return this._cachedBuild;
  }
  update(current, parent) {
    const result = new ProjectSettings_WithParent(current, parent);
    if (this._cachedProjectInfo && this._value.hasProjectInfo && current.hasProjectInfo) {
      if (this._value.projectInfo === current.projectInfo && this._parent === parent) {
        result._cachedProjectInfo = this._cachedProjectInfo;
      } else {
        result._cachedProjectInfo = this._cachedProjectInfo.update(current.projectInfo, parent && parent.hasProjectInfo ? parent.projectInfo : null);
      }
    }
    if (this._cachedPlayer && this._value.hasPlayer && current.hasPlayer) {
      if (this._value.player === current.player && this._parent === parent) {
        result._cachedPlayer = this._cachedPlayer;
      } else {
        result._cachedPlayer = this._cachedPlayer.update(current.player, parent && parent.hasPlayer ? parent.player : null);
      }
    }
    if (this._cachedDisplay && this._value.hasDisplay && current.hasDisplay) {
      if (this._value.display === current.display && this._parent === parent) {
        result._cachedDisplay = this._cachedDisplay;
      } else {
        result._cachedDisplay = this._cachedDisplay.update(current.display, parent && parent.hasDisplay ? parent.display : null);
      }
    }
    if (this._cachedInput && this._value.hasInput && current.hasInput) {
      if (this._value.input === current.input && this._parent === parent) {
        result._cachedInput = this._cachedInput;
      } else {
        result._cachedInput = this._cachedInput.update(current.input, parent && parent.hasInput ? parent.input : null);
      }
    }
    if (this._cachedFont && this._value.hasFont && current.hasFont) {
      if (this._value.font === current.font && this._parent === parent) {
        result._cachedFont = this._cachedFont;
      } else {
        result._cachedFont = this._cachedFont.update(current.font, parent && parent.hasFont ? parent.font : null);
      }
    }
    if (this._cachedBuild && this._value.hasBuild && current.hasBuild) {
      if (this._value.build === current.build && this._parent === parent) {
        result._cachedBuild = this._cachedBuild;
      } else {
        result._cachedBuild = this._cachedBuild.update(current.build, parent && parent.hasBuild ? parent.build : null);
      }
    }
    return result;
  }
}
ProjectSettings_WithParent.default = new ProjectSettings_WithParent(ProjectSettings.default, null);
ProjectSettings.WithParent = ProjectSettings_WithParent;
class ProjectSettings_Descriptor {
  get projectInfo() {
    if (!this._projectInfo) {
      this._projectInfo = {
        name: "projectInfo",
        Name: "ProjectInfo",
        number: 1,
        protoType: 11,
        protoName: "project_info",
        type: ProjectInfo,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._projectInfo;
  }
  get player() {
    if (!this._player) {
      this._player = {
        name: "player",
        Name: "Player",
        number: 2,
        protoType: 11,
        protoName: "player",
        type: dcei_engine_data_proto.PlayerSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._player;
  }
  get display() {
    if (!this._display) {
      this._display = {
        name: "display",
        Name: "Display",
        number: 3,
        protoType: 11,
        protoName: "display",
        type: dcei_engine_data_proto.DisplaySettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._display;
  }
  get input() {
    if (!this._input) {
      this._input = {
        name: "input",
        Name: "Input",
        number: 4,
        protoType: 11,
        protoName: "input",
        type: dcei_engine_data_proto.InputSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._input;
  }
  get font() {
    if (!this._font) {
      this._font = {
        name: "font",
        Name: "Font",
        number: 5,
        protoType: 11,
        protoName: "font",
        type: dcei_engine_data_proto.FontSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._font;
  }
  get build() {
    if (!this._build) {
      this._build = {
        name: "build",
        Name: "Build",
        number: 6,
        protoType: 11,
        protoName: "build",
        type: dcei_engine_data_proto.CustomAssetSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._build;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.projectInfo,
        this.player,
        this.display,
        this.input,
        this.font,
        this.build,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForProjectInfo",
        Name: "DummyOneofForProjectInfo",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayer",
        Name: "DummyOneofForPlayer",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplay",
        Name: "DummyOneofForDisplay",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInput",
        Name: "DummyOneofForInput",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFont",
        Name: "DummyOneofForFont",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBuild",
        Name: "DummyOneofForBuild",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
ProjectSettings.descriptor = new ProjectSettings_Descriptor();
class ProjectInfo_ProjectType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "GAME": return 0;
        case "LIBRARY": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ProjectInfo_ProjectType.fromJson(value);
  }
  static fromReact(e) {
    return ProjectInfo_ProjectType.fromJson(e);
  }
}
ProjectInfo_ProjectType.GAME = 0;
ProjectInfo_ProjectType.LIBRARY = 1;
ProjectInfo_ProjectType.default = 0;
ProjectInfo_ProjectType.values = {
  GAME: 0,
  LIBRARY: 1,
};
ProjectInfo_ProjectType.names = {
  0: "GAME",
  1: "LIBRARY",
};
export class ProjectInfo {
  get descriptor() {
    return ProjectInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasType = false;
    this._type = null;
    this._hasVersion = false;
    this._version = null;
    this._hasProjectName = false;
    this._projectName = null;
    this._hasEntryMap = false;
    this._entryMap = null;
  }
  isEmpty() {
    if (this._hasType) return false;
    if (this._hasVersion) return false;
    if (this._hasProjectName) return false;
    if (this._hasEntryMap) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ProjectInfo) {
      return value;
    }
    return ProjectInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new ProjectInfo();
    if (json.type != null) {
      result._hasType = true;
      result._type = ProjectInfo_ProjectType.fromJson(json.type);
    }
    if (json.version != null) {
      result._hasVersion = true;
      result._version = JsonToString.fromJson(json.version);
    }
    if (json.projectName != null) {
      result._hasProjectName = true;
      result._projectName = JsonToString.fromJson(json.projectName);
    }
    if (json.entryMap != null) {
      result._hasEntryMap = true;
      result._entryMap = JsonToString.fromJson(json.entryMap);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasType) {
      result.type = ProjectInfo_ProjectType.toJson(this._type);
    }
    if (this._hasVersion) {
      result.version = JsonToString.toJson(this._version);
    }
    if (this._hasProjectName) {
      result.projectName = JsonToString.toJson(this._projectName);
    }
    if (this._hasEntryMap) {
      result.entryMap = JsonToString.toJson(this._entryMap);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get type() {
    return this._hasType ? this._type : ProjectInfo_ProjectType.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {string}
   */
  get version() {
    return this._hasVersion ? this._version : JsonToString.default;
  }
  get hasVersion() {
    return this._hasVersion;
  }
  setVersion(path, value) {
    return {type: 'SET', path: path.concat(['version']), value};
  }
  deleteVersion(path) {
    return {type: 'DELETE', path: path.concat(['version'])};
  }
  /**
   * @returns {string}
   */
  get projectName() {
    return this._hasProjectName ? this._projectName : JsonToString.default;
  }
  get hasProjectName() {
    return this._hasProjectName;
  }
  setProjectName(path, value) {
    return {type: 'SET', path: path.concat(['projectName']), value};
  }
  deleteProjectName(path) {
    return {type: 'DELETE', path: path.concat(['projectName'])};
  }
  /**
   * @returns {string}
   */
  get entryMap() {
    return this._hasEntryMap ? this._entryMap : JsonToString.default;
  }
  get hasEntryMap() {
    return this._hasEntryMap;
  }
  setEntryMap(path, value) {
    return {type: 'SET', path: path.concat(['entryMap']), value};
  }
  deleteEntryMap(path) {
    return {type: 'DELETE', path: path.concat(['entryMap'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectInfo(this);
              copy._hasType = true;
              copy._type = ProjectInfo_ProjectType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new ProjectInfo(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "version": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectInfo(this);
              copy._hasVersion = true;
              copy._version = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVersion) {
                return this;
              }
              const copy = new ProjectInfo(this);
              copy._hasVersion = false;
              copy._version = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "projectName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectInfo(this);
              copy._hasProjectName = true;
              copy._projectName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProjectName) {
                return this;
              }
              const copy = new ProjectInfo(this);
              copy._hasProjectName = false;
              copy._projectName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "entryMap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectInfo(this);
              copy._hasEntryMap = true;
              copy._entryMap = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEntryMap) {
                return this;
              }
              const copy = new ProjectInfo(this);
              copy._hasEntryMap = false;
              copy._entryMap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ProjectInfo} other
   * @returns {ProjectInfo}
   */
  merge(other) {
    const copy = new ProjectInfo(this);
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    if (other._hasVersion) {
      copy._hasVersion = true;
      copy._version = other._version;
    }
    if (other._hasProjectName) {
      copy._hasProjectName = true;
      copy._projectName = other._projectName;
    }
    if (other._hasEntryMap) {
      copy._hasEntryMap = true;
      copy._entryMap = other._entryMap;
    }
    return copy;
  }
}
ProjectInfo.default = new ProjectInfo();
ProjectInfo.ProjectType = ProjectInfo_ProjectType;
class ProjectInfo_Builder {
  constructor(value) {
    this._value = new ProjectInfo(value);
  }
  build() {
    return new ProjectInfo(this._value);
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  setVersion(value) {
    this._value._hasVersion = true;
    this._value._version = value;
    return this;
  }
  deleteVersion() {
    this._value._hasVersion = false;
    this._value._version = null;
    return this;
  }
  setProjectName(value) {
    this._value._hasProjectName = true;
    this._value._projectName = value;
    return this;
  }
  deleteProjectName() {
    this._value._hasProjectName = false;
    this._value._projectName = null;
    return this;
  }
  setEntryMap(value) {
    this._value._hasEntryMap = true;
    this._value._entryMap = value;
    return this;
  }
  deleteEntryMap() {
    this._value._hasEntryMap = false;
    this._value._entryMap = null;
    return this;
  }
}
ProjectInfo.Builder = ProjectInfo_Builder;
class ProjectInfo_WithParent {
  /**
   * @param {ProjectInfo} value
   * @param {ProjectInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ProjectInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get hasVersion() {
    if (this._cachedHasVersion === undefined) {
      if (this._value.hasVersion) {
        this._cachedHasVersion = true;
      } else {
        this._cachedHasVersion = this._parent ? this._parent.hasVersion : false;
      }
    }
    return this._cachedHasVersion;
  }
  get version() {
    if (this._cachedVersion === undefined) {
      if (this._value.hasVersion) {
        this._cachedVersion = this._value.version;
      } else {
        this._cachedVersion = this._parent ? this._parent.version : this._value.version;
      }
    }
    return this._cachedVersion;
  }
  get hasProjectName() {
    if (this._cachedHasProjectName === undefined) {
      if (this._value.hasProjectName) {
        this._cachedHasProjectName = true;
      } else {
        this._cachedHasProjectName = this._parent ? this._parent.hasProjectName : false;
      }
    }
    return this._cachedHasProjectName;
  }
  get projectName() {
    if (this._cachedProjectName === undefined) {
      if (this._value.hasProjectName) {
        this._cachedProjectName = this._value.projectName;
      } else {
        this._cachedProjectName = this._parent ? this._parent.projectName : this._value.projectName;
      }
    }
    return this._cachedProjectName;
  }
  get hasEntryMap() {
    if (this._cachedHasEntryMap === undefined) {
      if (this._value.hasEntryMap) {
        this._cachedHasEntryMap = true;
      } else {
        this._cachedHasEntryMap = this._parent ? this._parent.hasEntryMap : false;
      }
    }
    return this._cachedHasEntryMap;
  }
  get entryMap() {
    if (this._cachedEntryMap === undefined) {
      if (this._value.hasEntryMap) {
        this._cachedEntryMap = this._value.entryMap;
      } else {
        this._cachedEntryMap = this._parent ? this._parent.entryMap : this._value.entryMap;
      }
    }
    return this._cachedEntryMap;
  }
  update(current, parent) {
    const result = new ProjectInfo_WithParent(current, parent);
    return result;
  }
}
ProjectInfo_WithParent.default = new ProjectInfo_WithParent(ProjectInfo.default, null);
ProjectInfo.WithParent = ProjectInfo_WithParent;
class ProjectInfo_Descriptor {
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 1,
        protoType: 14,
        protoName: "type",
        type: ProjectInfo_ProjectType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get version() {
    if (!this._version) {
      this._version = {
        name: "version",
        Name: "Version",
        number: 2,
        protoType: 9,
        protoName: "version",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._version;
  }
  get projectName() {
    if (!this._projectName) {
      this._projectName = {
        name: "projectName",
        Name: "ProjectName",
        number: 3,
        protoType: 9,
        protoName: "project_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._projectName;
  }
  get entryMap() {
    if (!this._entryMap) {
      this._entryMap = {
        name: "entryMap",
        Name: "EntryMap",
        number: 4,
        protoType: 9,
        protoName: "entry_map",
        type: JsonToString,
        options: {
          comments: "For game projects, this is the starting map when launching the game in arcade or in standalone build. For library projects, this is the map that will be imported by dependents.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._entryMap;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.type,
        this.version,
        this.projectName,
        this.entryMap,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVersion",
        Name: "DummyOneofForVersion",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProjectName",
        Name: "DummyOneofForProjectName",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEntryMap",
        Name: "DummyOneofForEntryMap",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ProjectInfo.descriptor = new ProjectInfo_Descriptor();
